export const aiResourcesData = [
  // Investigación (24 recursos)
  {
    id: 'asta-allen',
    name: 'ASTA',
    description: {
      es: 'Herramienta de IA para análisis y búsqueda académica desarrollada por Allen Institute.',
      en: 'AI tool for academic analysis and research developed by Allen Institute.',
      pt: 'Ferramenta de IA para análise e pesquisa acadêmica desenvolvida pelo Allen Institute.',
      fr: 'Outil d\'IA pour l\'analyse académique et la recherche développé par Allen Institute.',
      de: 'KI-Tool für akademische Analyse und Forschung, entwickelt vom Allen Institute.',
      it: 'Strumento di IA per analisi accademica e ricerca sviluppato dall\'Allen Institute.',
      zh: 'Allen Institute开发的用于学术分析和研究的AI工具。',
      ja: 'Allen Instituteが开发した学術分析と研究のためのAIツール。',
      ko: 'Allen Institute에서 개발한 학술 분석 및 연구용 AI 도구.',
      pl: 'Narzędzie AI do analizy akademickiej i badań opracowane przez Allen Institute.',
      ro: 'Instrument AI pentru analiză academică și cercetare dezvoltat de Allen Institute.'
    },
    url: 'https://asta.allen.ai',
    category: 'Investigación',
    favicon: 'https://asta.allen.ai/favicon.ico',
    tags: {
      es: ['Análisis académico', 'Allen Institute', 'Búsqueda', 'Investigación'],
      en: ['Academic analysis', 'Allen Institute', 'Search', 'Research'],
      pt: ['Análise acadêmica', 'Allen Institute', 'Busca', 'Pesquisa'],
      fr: ['Analyse académique', 'Allen Institute', 'Recherche', 'Investigation'],
      de: ['Akademische Analyse', 'Allen Institute', 'Suche', 'Forschung'],
      it: ['Analisi accademica', 'Allen Institute', 'Ricerca', 'Investigazione'],
      zh: ['学术分析', 'Allen Institute', '搜索', '研究'],
      ja: ['学術分析', 'Allen Institute', '検索', '研究'],
      ko: ['학술 분석', 'Allen Institute', '검색', '연구'],
      pl: ['Analiza akademicka', 'Allen Institute', 'Wyszukiwanie', 'Badania'],
      ro: ['Analiză academică', 'Allen Institute', 'Căutare', 'Cercetare']
    },
    rating: 4.3
  },
  {
    id: 'answerthis',
    name: 'AnswerThis',
    description: {
      es: 'Plataforma de IA para obtener respuestas precisas a preguntas de investigación y análisis.',
      en: 'AI platform to get precise answers to research and analysis questions.',
      pt: 'Plataforma de IA para obter respostas precisas a perguntas de pesquisa e análise.',
      fr: 'Plateforme d\'IA pour obtenir des réponses précises aux questions de recherche et d\'analyse.',
      de: 'KI-Plattform für präzise Antworten auf Forschungs- und Analysefragen.',
      it: 'Piattaforma di IA per ottenere risposte precise a domande di ricerca e analisi.',
      zh: '用于获得研究和分析问题精确答案的AI平台。',
      ja: '研究と分析の質問に正確な回答を得るためのAIプラットフォーム。',
      ko: '연구 및 분석 질문에 대한 정확한 답변을 얻기 위한 AI 플랫폼.',
      pl: 'Platforma AI do uzyskiwania precyzyjnych odpowiedzi na pytania badawcze i analityczne.',
      ro: 'Platformă AI pentru obținerea de răspunsuri precise la întrebări de cercetare și analiză.'
    },
    url: 'https://answerthis.io',
    category: 'Investigación',
    favicon: 'https://answerthis.io/favicon.ico',
    tags: {
      es: ['Respuestas precisas', 'Preguntas', 'Análisis', 'Investigación'],
      en: ['Precise answers', 'Questions', 'Analysis', 'Research'],
      pt: ['Respostas precisas', 'Perguntas', 'Análise', 'Pesquisa'],
      fr: ['Réponses précises', 'Questions', 'Analyse', 'Recherche'],
      de: ['Präzise Antworten', 'Fragen', 'Analyse', 'Forschung'],
      it: ['Risposte precise', 'Domande', 'Analisi', 'Ricerca'],
      zh: ['精确答案', '问题', '分析', '研究'],
      ja: ['正確な回答', '質問', '分析', '研究'],
      ko: ['정확한 답변', '질문', '분석', '연구'],
      pl: ['Precyzyjne odpowiedzi', 'Pytania', 'Analiza', 'Badania'],
      ro: ['Răspunsuri precise', 'Întrebări', 'Analiză', 'Cercetare']
    },
    rating: 4.2
  },
  {
    id: 'connected-papers',
    name: 'Connected Papers',
    description: {
      es: 'Herramienta visual para explorar papers académicos y encontrar investigación relevante mediante grafos interactivos.',
      en: 'Visual tool to explore academic papers and find relevant research through interactive graphs.',
      pt: 'Ferramenta visual para explorar artigos acadêmicos e encontrar pesquisas relevantes através de gráficos interativos.',
      fr: 'Outil visuel pour explorer les articles académiques et trouver des recherches pertinentes via des graphiques interactifs.',
      de: 'Visuelles Tool zur Erkundung akademischer Papiere und zum Finden relevanter Forschung durch interaktive Grafiken.',
      it: 'Strumento visivo per esplorare articoli accademici e trovare ricerche rilevanti tramite grafici interattivi.',
      zh: '通过交互式图形探索学术论文并找到相关研究的可视化工具。',
      ja: 'インタラクティブなグラフを通じて学術論文を探索し、関連する研究を見つけるための視覚的ツール。',
      ko: '대화형 그래프를 통해 학술 논문을 탐색하고 관련 연구를 찾는 시각적 도구.',
      pl: 'Narzędzie wizualne do eksploracji artykułów akademickich i znajdowania odpowiednich badań za pomocą interaktywnych wykresów.',
      ro: 'Instrument vizual pentru explorarea lucrărilor academice și găsirea cercetărilor relevante prin grafice interactive.'
    },
    url: 'https://connectedpapers.com',
    category: 'Investigación',
    favicon: 'https://connectedpapers.com/favicon.ico',
    tags: {
      es: ['Visual', 'Documentos académicos', 'Grafos', 'Interactivo'],
      en: ['Visual', 'Papers', 'Graphs', 'Interactive'],
      pt: ['Visual', 'Artigos', 'Gráficos', 'Interativo'],
      fr: ['Visuel', 'Articles', 'Graphiques', 'Interactif'],
      de: ['Visuell', 'Papiere', 'Grafiken', 'Interaktiv'],
      it: ['Visivo', 'Articoli', 'Grafici', 'Interattivo'],
      zh: ['视觉', '论文', '图形', '交互'],
      ja: ['ビジュアル', '論文', 'グラフ', 'インタラクティブ'],
      ko: ['시각적', '논문', '그래프', '대화형'],
      pl: ['Wizualny', 'Artykuły', 'Wykresy', 'Interaktywny'],
      ro: ['Vizual', 'Lucrări', 'Grafice', 'Interactiv']
    },
    rating: 4.6
  },
  {
    id: 'consensus',
    name: 'Consensus',
    description: {
      es: 'Motor de búsqueda de IA para papers científicos con resúmenes y análisis automáticos de literatura académica.',
      en: 'AI search engine for scientific papers with automatic summaries and analysis of academic literature.',
      pt: 'Motor de busca de IA para artigos científicos com resumos automáticos e análise de literatura acadêmica.',
      fr: 'Moteur de recherche IA pour articles scientifiques avec résumés automatiques et analyse de littérature académique.',
      de: 'KI-Suchmaschine für wissenschaftliche Papiere mit automatischen Zusammenfassungen und Analyse akademischer Literatur.',
      it: 'Motore di ricerca AI per articoli scientifici con riassunti automatici e analisi della letteratura accademica.',
      zh: '用于科学论文的AI搜索引擎，具有自动摘要和学术文献分析功能。',
      ja: '学術文献の自动要約と分析機能を備えた科学論文用AIサーチエンジン。',
      ko: '자동 요약 및 학술 문헌 분석 기능을 갖춘 과학 논문용 AI 검색 엔진.',
      pl: 'Wyszukiwarka AI dla artykułów naukowych z automatycznymi streszczeniami i analizą literatury akademickiej.',
      ro: 'Motor de căutare AI pentru lucrări științifice cu rezumate automate și analiză a literaturii academice.'
    },
    url: 'https://consensus.app',
    category: 'Investigación',
    favicon: 'https://consensus.app/favicon.ico',
    tags: {
      es: ['Documentos académicos', 'Análisis', 'Académico', 'Literatura'],
      en: ['Scientific papers', 'Analysis', 'Academic', 'Literature'],
      pt: ['Artigos científicos', 'Análise', 'Acadêmico', 'Literatura'],
      fr: ['Articles scientifiques', 'Analyse', 'Académique', 'Littérature'],
      de: ['Wissenschaftliche Papiere', 'Analyse', 'Akademisch', 'Literatur'],
      it: ['Articoli scientifici', 'Analisi', 'Accademico', 'Letteratura'],
      zh: ['科学论文', '分析', '学术', '文献'],
      ja: ['科学論文', '分析', '学術', '文献'],
      ko: ['과학 논문', '분석', '학술', '문헌'],
      pl: ['Artykuły naukowe', 'Analiza', 'Akademicki', 'Literatura'],
      ro: ['Lucrări științifice', 'Analiză', 'Academic', 'Literatură']
    },
    rating: 4.7
  },
  {
    id: 'converse',
    name: 'Converse',
    description: {
      es: 'Asistente de IA conversacional para investigación y análisis de documentos académicos.',
      en: 'Conversational AI assistant for research and analysis of academic documents.',
      pt: 'Assistente de IA conversacional para pesquisa e análise de documentos acadêmicos.',
      fr: 'Assistant IA conversationnel pour la recherche et l\'analyse de documents académiques.',
      de: 'Konversationaler KI-Assistent für Forschung und Analyse akademischer Dokumente.',
      it: 'Assistente AI conversazionale per ricerca e analisi di documenti accademici.',
      zh: '用于研究和分析学术文档的对话式AI助手。',
      ja: '学術文書の研究と分析のための対話型AIアシスタント。',
      ko: '학술 문서의 연구 및 분석을 위한 대화형 AI 어시스턴트.',
      pl: 'Konwersacyjny asystent AI do badań i analizy dokumentów akademickich.',
      ro: 'Asistent AI conversațional pentru cercetarea și analiza documentelor academice.'
    },
    url: 'https://getconverse.com',
    category: 'Investigación',
    favicon: 'https://getconverse.com/favicon.ico',
    tags: {
      es: ['Conversacional', 'Documentos académicos', 'Asistente', 'Análisis'],
      en: ['Conversational', 'Academic documents', 'Assistant', 'Analysis'],
      pt: ['Conversacional', 'Documentos acadêmicos', 'Assistente', 'Análise'],
      fr: ['Conversationnel', 'Documents académiques', 'Assistant', 'Analyse'],
      de: ['Konversational', 'Akademische Dokumente', 'Assistent', 'Analyse'],
      it: ['Conversazionale', 'Documenti accademici', 'Assistente', 'Analisi'],
      zh: ['对话式', '学术文档', '助手', '分析'],
      ja: ['対話型', '学術文書', 'アシスタント', '分析'],
      ko: ['대화형', '학술 문서', '어시스턴트', '분석'],
      pl: ['Konwersacyjny', 'Dokumenty akademickie', 'Asystent', 'Analiza'],
      ro: ['Conversațional', 'Documente academice', 'Asistent', 'Analiză']
    },
    rating: 4.1
  },
  {
    id: 'elicit',
    name: 'Elicit',
    description: {
      es: 'Asistente de investigación de IA que ayuda a encontrar, resumir y extraer datos de papers académicos.',
      en: 'AI research assistant that helps find, summarize and extract data from academic papers.',
      pt: 'Assistente de pesquisa de IA que ajuda a encontrar, resumir e extrair dados de artigos acadêmicos.',
      fr: 'Assistant de recherche IA qui aide à trouver, résumer et extraire des données d\'articles académiques.',
      de: 'KI-Forschungsassistent, der beim Finden, Zusammenfassen und Extrahieren von Daten aus akademischen Papieren hilft.',
      it: 'Assistente di ricerca AI che aiuta a trovare, riassumere ed estrarre dati da articoli accademici.',
      zh: '帮助查找、总结和从学术论文中提取数据的AI研究助手。',
      ja: '学術論文からデータを見つけ、要約し、抽出するのを支援するAI研究アシスタント。',
      ko: '학술 논문에서 데이터를 찾고, 요약하고, 추출하는 데 도움을 주는 AI 연구 어시스턴트.',
      pl: 'Asystent badań AI, który pomaga znaleźć, podsumować i wyodrębnić dane z artykułów akademickich.',
      ro: 'Asistent de cercetare AI care ajută la găsirea, rezumarea și extragerea datelor din lucrări academice.'
    },
    url: 'https://elicit.com',
    category: 'Investigación',
    favicon: 'https://elicit.com/favicon.ico',
    tags: {
      es: ['Investigación', 'Resúmenes', 'Datos', 'Documentos académicos'],
      en: ['Research', 'Summaries', 'Data', 'Papers'],
      pt: ['Pesquisa', 'Resumos', 'Dados', 'Artigos'],
      fr: ['Recherche', 'Résumés', 'Données', 'Articles'],
      de: ['Forschung', 'Zusammenfassungen', 'Daten', 'Papiere'],
      it: ['Ricerca', 'Riassunti', 'Dati', 'Articoli'],
      zh: ['研究', '摘要', '数据', '论文'],
      ja: ['研究', '要約', 'データ', '論文'],
      ko: ['연구', '요약', '데이터', '논문'],
      pl: ['Badania', 'Streszczenia', 'Dane', 'Artykuły'],
      ro: ['Cercetare', 'Rezumate', 'Date', 'Lucrări']
    },
    rating: 4.6
  },
  {
    id: 'gopdf',
    name: 'GoPDF',
    description: {
      es: 'Herramienta de IA para análisis y procesamiento inteligente de documentos PDF.',
      en: 'AI tool for intelligent analysis and processing of PDF documents.',
      pt: 'Ferramenta de IA para análise inteligente e processamento de documentos PDF.',
      fr: 'Outil IA pour l\'analyse intelligente et le traitement de documents PDF.',
      de: 'KI-Tool für intelligente Analyse und Verarbeitung von PDF-Dokumenten.',
      it: 'Strumento AI per analisi intelligente e elaborazione di documenti PDF.',
      zh: '用于PDF文档智能分析和处理的AI工具。',
      ja: 'PDF文書のインテリジェントな分析と処理のためのAIツール。',
      ko: 'PDF 문서의 지능적인 분석 및 처리를 위한 AI 도구.',
      pl: 'Narzędzie AI do inteligentnej analizy i przetwarzania dokumentów PDF.',
      ro: 'Instrument AI pentru analiza inteligentă și procesarea documentelor PDF.'
    },
    url: 'https://gopdf.io',
    category: 'Investigación',
    favicon: 'https://gopdf.io/favicon.ico',
    tags: {
      es: ['PDF', 'Procesamiento', 'Documentos', 'Análisis'],
      en: ['PDF', 'Processing', 'Documents', 'Analysis'],
      pt: ['PDF', 'Processamento', 'Documentos', 'Análise'],
      fr: ['PDF', 'Traitement', 'Documents', 'Analyse'],
      de: ['PDF', 'Verarbeitung', 'Dokumente', 'Analyse'],
      it: ['PDF', 'Elaborazione', 'Documenti', 'Analisi'],
      zh: ['PDF', '处理', '文档', '分析'],
      ja: ['PDF', '処理', '文書', '分析'],
      ko: ['PDF', '처리', '문서', '분석'],
      pl: ['PDF', 'Przetwarzanie', 'Dokumenty', 'Analiza'],
      ro: ['PDF', 'Procesare', 'Documente', 'Analiză']
    },
    rating: 4.0
  },
  {
    id: 'iki-ai',
    name: 'IKI AI',
    description: {
      es: 'Plataforma de inteligencia artificial para investigación y descubrimiento de conocimiento.',
      en: 'Artificial intelligence platform for research and knowledge discovery.',
      pt: 'Plataforma de inteligência artificial para pesquisa e descoberta de conhecimento.',
      fr: 'Plateforme d\'intelligence artificielle pour la recherche et la découverte de connaissances.',
      de: 'Künstliche Intelligenz-Plattform für Forschung und Wissensentdeckung.',
      it: 'Piattaforma di intelligenza artificiale per ricerca e scoperta della conoscenza.',
      zh: '用于研究和知识发现的人工智能平台。',
      ja: '研究と知識発見のための人工知能プラットフォーム。',
      ko: '연구 및 지식 발견을 위한 인공지능 플랫폼.',
      pl: 'Platforma sztucznej inteligencji do badań i odkrywania wiedzy.',
      ro: 'Platformă de inteligență artificială pentru cercetare și descoperirea cunoștințelor.'
    },
    url: 'https://iki.ai',
    category: 'Investigación',
    favicon: 'https://iki.ai/favicon.ico',
    tags: {
      es: ['Descubrimiento', 'Conocimiento', 'Plataforma', 'Investigación'],
      en: ['Discovery', 'Knowledge', 'Platform', 'Research'],
      pt: ['Descoberta', 'Conhecimento', 'Plataforma', 'Pesquisa'],
      fr: ['Découverte', 'Connaissance', 'Plateforme', 'Recherche'],
      de: ['Entdeckung', 'Wissen', 'Plattform', 'Forschung'],
      it: ['Scoperta', 'Conoscenza', 'Piattaforma', 'Ricerca'],
      zh: ['发现', '知识', '平台', '研究'],
      ja: ['発見', '知識', 'プラットフォーム', '研究'],
      ko: ['발견', '지식', '플랫폼', '연구'],
      pl: ['Odkrycie', 'Wiedza', 'Platforma', 'Badania'],
      ro: ['Descoperire', 'Cunoștințe', 'Platformă', 'Cercetare']
    },
    rating: 4.2
  },
  {
    id: 'inciteful',
    name: 'Inciteful',
    description: {
      es: 'Herramienta para mapear y explorar redes de citaciones académicas usando inteligencia artificial.',
      en: 'Tool to map and explore academic citation networks using artificial intelligence.',
      pt: 'Ferramenta para mapear e explorar redes de citações acadêmicas usando inteligência artificial.',
      fr: 'Outil pour cartographier et explorer les réseaux de citations académiques en utilisant l\'intelligence artificielle.',
      de: 'Tool zum Kartieren und Erkunden akademischer Zitationsnetzwerke mit künstlicher Intelligenz.',
      it: 'Strumento per mappare ed esplorare reti di citazioni accademiche utilizzando l\'intelligenza artificiale.',
      zh: '使用人工智能映射和探索学术引用网络的工具。',
      ja: '人工知能を使用して学術引用ネットワークをマッピングし探索するツール。',
      ko: '인공지능을 사용하여 학술 인용 네트워크를 매핑하고 탐색하는 도구.',
      pl: 'Narzędzie do mapowania i eksploracji sieci cytowań akademickich przy użyciu sztucznej inteligencji.',
      ro: 'Instrument pentru maparea și explorarea rețelelor de citări academice folosind inteligența artificială.'
    },
    url: 'https://inciteful.xyz',
    category: 'Investigación',
    favicon: 'https://inciteful.xyz/favicon.ico',
    tags: {
      es: ['Citaciones', 'Redes académicas', 'Mapear', 'Explorar'],
      en: ['Citations', 'Academic networks', 'Mapping', 'Explore'],
      pt: ['Citações', 'Redes acadêmicas', 'Mapear', 'Explorar'],
      fr: ['Citations', 'Réseaux académiques', 'Cartographier', 'Explorer'],
      de: ['Zitationen', 'Akademische Netzwerke', 'Kartieren', 'Erkunden'],
      it: ['Citazioni', 'Reti accademiche', 'Mappare', 'Esplorare'],
      zh: ['引用', '学术网络', '映射', '探索'],
      ja: ['引用', '学術ネットワーク', 'マッピング', '探索'],
      ko: ['인용', '학술 네트워크', '매핑', '탐색'],
      pl: ['Cytowania', 'Sieci akademickie', 'Mapowanie', 'Eksploracja'],
      ro: ['Citări', 'Rețele academice', 'Mapare', 'Explorare']
    },
    rating: 4.4
  },
  {
    id: 'logically',
    name: 'Logically',
    description: {
      es: 'Plataforma de IA para verificación de hechos y análisis de desinformación.',
      en: 'AI platform for fact-checking and disinformation analysis.',
      pt: 'Plataforma de IA para verificação de fatos e análise de desinformação.',
      fr: 'Plateforme IA pour la vérification des faits et l\'analyse de la désinformation.',
      de: 'KI-Plattform für Faktenprüfung und Desinformationsanalyse.',
      it: 'Piattaforma AI per verifica dei fatti e analisi della disinformazione.',
      zh: '用于事实核查和虚假信息分析的AI平台。',
      ja: 'ファクトチェックと偽情報分析のためのAIプラットフォーム。',
      ko: '팩트체킹과 허위정보 분석을 위한 AI 플랫폼.',
      pl: 'Platforma AI do sprawdzania faktów i analizy dezinformacji.',
      ro: 'Platformă AI pentru verificarea faptelor și analiza dezinformării.'
    },
    url: 'https://logically.app',
    category: 'Investigación',
    favicon: 'https://logically.app/favicon.ico',
    tags: {
      es: ['Verificación', 'Hechos', 'Desinformación', 'Análisis'],
      en: ['Verification', 'Facts', 'Disinformation', 'Analysis'],
      pt: ['Verificação', 'Fatos', 'Desinformação', 'Análise'],
      fr: ['Vérification', 'Faits', 'Désinformation', 'Analyse'],
      de: ['Verifikation', 'Fakten', 'Desinformation', 'Analyse'],
      it: ['Verifica', 'Fatti', 'Disinformazione', 'Analisi'],
      zh: ['验证', '事实', '虚假信息', '分析'],
      ja: ['検証', '事实', '偽情報', '分析'],
      ko: ['검증', '사실', '허위정보', '분석'],
      pl: ['Weryfikacja', 'Fakty', 'Dezinformacja', 'Analiza'],
      ro: ['Verificare', 'Fapte', 'Dezinformare', 'Analiză']
    },
    rating: 4.3
  },
  {
    id: 'mymemo',
    name: 'MyMemo',
    description: {
      es: 'Asistente de IA para organizar, buscar y gestionar notas de investigación.',
      en: 'AI assistant to organize, search and manage research notes.',
      pt: 'Assistente de IA para organizar, buscar e gerenciar notas de pesquisa.',
      fr: 'Assistant IA pour organiser, rechercher et gérer les notes de recherche.',
      de: 'KI-Assistent zum Organisieren, Suchen und Verwalten von Forschungsnotizen.',
      it: 'Assistente AI per organizzare, cercare e gestire note di ricerca.',
      zh: '用于组织、搜索和管理研究笔记的AI助手。',
      ja: '研究ノートを整理、検索、管理するためのAIアシスタント。',
      ko: '연구 노트를 정리, 검색, 관리하는 AI 어시스턴트.',
      pl: 'Asystent AI do organizowania, wyszukiwania i zarządzania notatkami badawczymi.',
      ro: 'Asistent AI pentru organizarea, căutarea și gestionarea notițelor de cercetare.'
    },
    url: 'https://mymemo.ai',
    category: 'Investigación',
    favicon: 'https://mymemo.ai/favicon.ico',
    tags: {
      es: ['Notas', 'Organizar', 'Gestionar', 'Búsqueda'],
      en: ['Notes', 'Organize', 'Manage', 'Search'],
      pt: ['Notas', 'Organizar', 'Gerenciar', 'Busca'],
      fr: ['Notes', 'Organiser', 'Gérer', 'Recherche'],
      de: ['Notizen', 'Organisieren', 'Verwalten', 'Suche'],
      it: ['Note', 'Organizzare', 'Gestire', 'Ricerca'],
      zh: ['笔记', '组织', '管理', '搜索'],
      ja: ['ノート', '整理', '管理', '検索'],
      ko: ['노트', '정리', '관리', '검색'],
      pl: ['Notatki', 'Organizować', 'Zarządzać', 'Wyszukiwanie'],
      ro: ['Notițe', 'Organiza', 'Gestiona', 'Căutare']
    },
    rating: 4.1
  },
  {
    id: 'notebooklm',
    name: 'NotebookLM',
    description: {
      es: 'Asistente de investigación de Google que utiliza IA para analizar y sintetizar información.',
      en: 'Google research assistant that uses AI to analyze and synthesize information.',
      pt: 'Assistente de pesquisa do Google que usa IA para analisar e sintetizar informações.',
      fr: 'Assistant de recherche Google qui utilise l\'IA pour analyser et synthétiser l\'information.',
      de: 'Google-Forschungsassistent, der KI zur Analyse und Synthese von Informationen verwendet.',
      it: 'Assistente di ricerca Google che utilizza l\'IA per analizzare e sintetizzare informazioni.',
      zh: '谷歌研究助手，使用AI分析和综合信息。',
      ja: '情報を分析し統合するためにAIを使用するGoogleの研究アシスタント。',
      ko: '정보를 분석하고 종합하기 위해 AI를 사용하는 Google 연구 어시스턴트.',
      pl: 'Asystent badań Google, który używa AI do analizy i syntezy informacji.',
      ro: 'Asistent de cercetare Google care folosește AI pentru a analiza și sintetiza informații.'
    },
    url: 'https://notebooklm.google',
    category: 'Investigación',
    favicon: 'https://www.google.com/favicon.ico',
    tags: {
      es: ['Google', 'Sintetizar', 'Analizar', 'Información'],
      en: ['Google', 'Synthesize', 'Analyze', 'Information'],
      pt: ['Google', 'Sintetizar', 'Analisar', 'Informação'],
      fr: ['Google', 'Synthétiser', 'Analyser', 'Information'],
      de: ['Google', 'Synthetisieren', 'Analysieren', 'Information'],
      it: ['Google', 'Sintetizzare', 'Analizzare', 'Informazione'],
      zh: ['谷歌', '综合', '分析', '信息'],
      ja: ['Google', '統合', '分析', '情報'],
      ko: ['구글', '종합', '분석', '정보'],
      pl: ['Google', 'Syntetyzować', 'Analizować', 'Informacja'],
      ro: ['Google', 'Sintetiza', 'Analiza', 'Informație']
    },
    rating: 4.5
  },
  {
    id: 'openalex',
    name: 'OpenAlex',
    description: {
      es: 'Base de datos abierta de literatura académica con análisis bibliométrico impulsado por IA.',
      en: 'Open database of academic literature with AI-powered bibliometric analysis.',
      pt: 'Base de dados aberta de literatura acadêmica com análise bibliométrica alimentada por IA.',
      fr: 'Base de données ouverte de littérature académique avec analyse bibliométrique alimentée par IA.',
      de: 'Offene Datenbank akademischer Literatur mit KI-gestützter bibliometrischer Analyse.',
      it: 'Database aperto di letteratura accademica con analisi bibliometrica alimentata da AI.',
      zh: '具有AI驱动的文献计量分析的开放学术文献数据库。',
      ja: 'AI駆動の文献計量分析を備えたオープンな学術文献データベース。',
      ko: 'AI 기반 서지계량 분석을 갖춘 개방형 학술 문헌 데이터베이스.',
      pl: 'Otwarta baza danych literatury akademickiej z analizą bibliometryczną napędzaną przez AI.',
      ro: 'Bază de date deschisă de literatură academică cu analiză bibliometrică alimentată de AI.'
    },
    url: 'https://openalex.org',
    category: 'Investigación',
    favicon: 'https://openalex.org/favicon.ico',
    tags: {
      es: ['Base datos', 'Bibliométrico', 'Literatura académica', 'Abierta'],
      en: ['Database', 'Bibliometric', 'Academic literature', 'Open'],
      pt: ['Base dados', 'Bibliométrico', 'Literatura acadêmica', 'Aberta'],
      fr: ['Base données', 'Bibliométrique', 'Littérature académique', 'Ouverte'],
      de: ['Datenbank', 'Bibliometrisch', 'Akademische Literatur', 'Offen'],
      it: ['Database', 'Bibliometrico', 'Letteratura accademica', 'Aperto'],
      zh: ['数据库', '文献计量', '学术文献', '开放'],
      ja: ['データベース', '文献計量', '学術文献', 'オープン'],
      ko: ['데이터베이스', '서지계량', '학술 문헌', '개방'],
      pl: ['Baza danych', 'Bibliometryczny', 'Literatura akademicka', 'Otwarta'],
      ro: ['Bază date', 'Bibliometric', 'Literatură academică', 'Deschisă']
    },
    rating: 4.4
  },
  {
    id: 'openknowledgemaps',
    name: 'Open Knowledge Maps',
    description: {
      es: 'Mapas visuales de conocimiento científico para explorar campos de investigación.',
      en: 'Visual maps of scientific knowledge to explore research fields.',
      pt: 'Mapas visuais de conhecimento científico para explorar campos de pesquisa.',
      fr: 'Cartes visuelles de connaissances scientifiques pour explorer les domaines de recherche.',
      de: 'Visuelle Karten wissenschaftlichen Wissens zur Erkundung von Forschungsfeldern.',
      it: 'Mappe visive della conoscenza scientifica per esplorare campi di ricerca.',
      zh: '用于探索研究领域的科学知识可视化地图。',
      ja: '研究分野を探索するための科学知識の視覚的マップ。',
      ko: '연구 분야를 탐색하기 위한 과학 지식의 시각적 지도.',
      pl: 'Wizualne mapy wiedzy naukowej do eksploracji dziedzin badawczych.',
      ro: 'Hărți vizuale ale cunoștințelor științifice pentru explorarea domeniilor de cercetare.'
    },
    url: 'https://openknowledgemaps.org',
    category: 'Investigación',
    favicon: 'https://openknowledgemaps.org/favicon.ico',
    tags: {
      es: ['Mapas visuales', 'Conocimiento científico', 'Explorar', 'Campos'],
      en: ['Visual maps', 'Scientific knowledge', 'Explore', 'Fields'],
      pt: ['Mapas visuais', 'Conhecimento científico', 'Explorar', 'Campos'],
      fr: ['Cartes visuelles', 'Connaissance scientifique', 'Explorer', 'Domaines'],
      de: ['Visuelle Karten', 'Wissenschaftliches Wissen', 'Erkunden', 'Felder'],
      it: ['Mappe visive', 'Conoscenza scientifica', 'Esplorare', 'Campi'],
      zh: ['视觉地图', '科学知识', '探索', '领域'],
      ja: ['視覚的マップ', '科学知識', '探索', '分野'],
      ko: ['시각적 지도', '과학 지식', '탐색', '분야'],
      pl: ['Mapy wizualne', 'Wiedza naukowa', 'Eksploracja', 'Dziedziny'],
      ro: ['Hărți vizuale', 'Cunoștințe științifice', 'Explorare', 'Domenii']
    },
    rating: 4.3
  },
  {
    id: 'orkg',
    name: 'ORKG Ask',
    description: {
      es: 'Sistema de preguntas y respuestas sobre conocimiento científico estructurado.',
      en: 'Question and answer system for structured scientific knowledge.',
      pt: 'Sistema de perguntas e respostas sobre conhecimento científico estruturado.',
      fr: 'Système de questions-réponses sur les connaissances scientifiques structurées.',
      de: 'Frage-Antwort-System für strukturiertes wissenschaftliches Wissen.',
      it: 'Sistema di domande e risposte sulla conoscenza scientifica strutturata.',
      zh: '结构化科学知识的问答系统。',
      ja: '構造化された科学知識のための質問回答システム。',
      ko: '구조화된 과학 지식을 위한 질문 답변 시스템.',
      pl: 'System pytań i odpowiedzi na temat ustrukturyzowanej wiedzy naukowej.',
      ro: 'Sistem de întrebări și răspunsuri despre cunoștințele științifice structurate.'
    },
    url: 'https://ask.orkg.org',
    category: 'Investigación',
    favicon: 'https://ask.orkg.org/favicon.ico',
    tags: {
      es: ['Preguntas', 'Respuestas', 'Conocimiento científico', 'Estructurado'],
      en: ['Questions', 'Answers', 'Scientific knowledge', 'Structured'],
      pt: ['Perguntas', 'Respostas', 'Conhecimento científico', 'Estruturado'],
      fr: ['Questions', 'Réponses', 'Connaissance scientifique', 'Structuré'],
      de: ['Fragen', 'Antworten', 'Wissenschaftliches Wissen', 'Strukturiert'],
      it: ['Domande', 'Risposte', 'Conoscenza scientifica', 'Strutturato'],
      zh: ['问题', '答案', '科学知识', '结构化'],
      ja: ['質問', '回答', '科学知識', '構造化'],
      ko: ['질문', '답변', '과학 지식', '구조화'],
      pl: ['Pytania', 'Odpowiedzi', 'Wiedza naukowa', 'Ustrukturyzowana'],
      ro: ['Întrebări', 'Răspunsuri', 'Cunoștințe științifice', 'Structurate']
    },
    rating: 4.2
  },
  {
    id: 'paperguide',
    name: 'PaperGuide',
    description: {
      es: 'Asistente de IA para escribir, revisar y mejorar papers académicos.',
      en: 'AI assistant to write, review and improve academic papers.',
      pt: 'Assistente de IA para escrever, revisar e melhorar artigos acadêmicos.',
      fr: 'Assistant IA pour écrire, réviser et améliorer les articles académiques.',
      de: 'KI-Assistent zum Schreiben, Überprüfen und Verbessern akademischer Papiere.',
      it: 'Assistente AI per scrivere, rivedere e migliorare articoli accademici.',
      zh: '用于撰写、审查和改进学术论文的AI助手。',
      ja: '学術論文を書き、レビューし、改善するためのAIアシスタント。',
      ko: '학술 논문을 작성, 검토, 개선하기 위한 AI 어시스턴트.',
      pl: 'Asystent AI do pisania, przeglądania i poprawiania artykułów akademickich.',
      ro: 'Asistent AI pentru scrierea, revizuirea și îmbunătățirea lucrărilor academice.'
    },
    url: 'https://paperguide.ai',
    category: 'Investigación',
    favicon: 'https://paperguide.ai/favicon.ico',
    tags: {
      es: ['Escribir artículos', 'Revisar', 'Mejorar', 'Académicos'],
      en: ['Write papers', 'Review', 'Improve', 'Academic'],
      pt: ['Escrever artigos', 'Revisar', 'Melhorar', 'Acadêmicos'],
      fr: ['Écrire articles', 'Réviser', 'Améliorer', 'Académiques'],
      de: ['Papiere schreiben', 'Überprüfen', 'Verbessern', 'Akademisch'],
      it: ['Scrivere articoli', 'Rivedere', 'Migliorare', 'Accademici'],
      zh: ['写论文', '审查', '改进', '学术'],
      ja: ['論文を書く', 'レビュー', '改善', '学術'],
      ko: ['논문 작성', '검토', '개선', '학술'],
      pl: ['Pisać artykuły', 'Przeglądać', 'Poprawiać', 'Akademickie'],
      ro: ['Scrie lucrări', 'Revizui', 'Îmbunătăți', 'Academice']
    },
    rating: 4.3
  },
  {
    id: 'researchrabbit',
    name: 'ResearchRabbit',
    description: {
      es: 'Plataforma de descubrimiento de investigación que utiliza IA para mapear y explorar literatura científica.',
      en: 'Research discovery platform that uses AI to map and explore scientific literature.',
      pt: 'Plataforma de descoberta de pesquisa que usa IA para mapear e explorar literatura científica.',
      fr: 'Plateforme de découverte de recherche qui utilise l\'IA pour cartographier et explorer la littérature scientifique.',
      de: 'Forschungsentdeckungsplattform, die KI zum Kartieren und Erkunden wissenschaftlicher Literatur verwendet.',
      it: 'Piattaforma di scoperta della ricerca che utilizza l\'IA per mappare ed esplorare la letteratura scientifica.',
      zh: '使用AI映射和探索科学文献的研究发现平台。',
      ja: 'AIを使用して科学文献をマッピングし探索する研究発見プラットフォーム。',
      ko: 'AI를 사용하여 과학 문헌을 매핑하고 탐색하는 연구 발견 플랫폼.',
      pl: 'Platforma odkrywania badań, która używa AI do mapowania i eksploracji literatury naukowej.',
      ro: 'Platformă de descoperire a cercetărilor care folosește AI pentru maparea și explorarea literaturii științifice.'
    },
    url: 'https://researchrabbit.ai',
    category: 'Investigación',
    favicon: 'https://researchrabbit.ai/favicon.ico',
    tags: {
      es: ['Descubrimiento', 'Mapeo', 'Literatura', 'Exploración'],
      en: ['Discovery', 'Mapping', 'Literature', 'Exploration'],
      pt: ['Descoberta', 'Mapeamento', 'Literatura', 'Exploração'],
      fr: ['Découverte', 'Cartographie', 'Littérature', 'Exploration'],
      de: ['Entdeckung', 'Kartierung', 'Literatur', 'Erkundung'],
      it: ['Scoperta', 'Mappatura', 'Letteratura', 'Esplorazione'],
      zh: ['发现', '映射', '文献', '探索'],
      ja: ['発見', 'マッピング', '文献', '探索'],
      ko: ['발견', '매핑', '문헌', '탐색'],
      pl: ['Odkrycie', 'Mapowanie', 'Literatura', 'Eksploracja'],
      ro: ['Descoperire', 'Mapare', 'Literatură', 'Explorare']
    },
    rating: 4.5
  },
  {
    id: 'scienceopen',
    name: 'ScienceOpen',
    description: {
      es: 'Plataforma de publicación y descubrimiento científico con herramientas de IA.',
      en: 'Scientific publishing and discovery platform with AI tools.',
      pt: 'Plataforma de publicação e descoberta científica com ferramentas de IA.',
      fr: 'Plateforme de publication et de découverte scientifique avec des outils IA.',
      de: 'Wissenschaftliche Veröffentlichungs- und Entdeckungsplattform mit KI-Tools.',
      it: 'Piattaforma di pubblicazione e scoperta scientifica con strumenti AI.',
      zh: '具有AI工具的科学出版和发现平台。',
      ja: 'AIツールを備えた科学出版と発見のプラットフォーム。',
      ko: 'AI 도구를 갖춘 과학 출판 및 발견 플랫폼.',
      pl: 'Platforma publikacji naukowych i odkryć z narzędziami AI.',
      ro: 'Platformă de publicare și descoperire științifică cu instrumente AI.'
    },
    url: 'https://scienceopen.com',
    category: 'Investigación',
    favicon: 'https://scienceopen.com/favicon.ico',
    tags: {
      es: ['Publicación', 'Descubrimiento científico', 'Plataforma', 'Herramientas'],
      en: ['Publishing', 'Scientific discovery', 'Platform', 'Tools'],
      pt: ['Publicação', 'Descoberta científica', 'Plataforma', 'Ferramentas'],
      fr: ['Publication', 'Découverte scientifique', 'Plateforme', 'Outils'],
      de: ['Veröffentlichung', 'Wissenschaftliche Entdeckung', 'Plattform', 'Werkzeuge'],
      it: ['Pubblicazione', 'Scoperta scientifica', 'Piattaforma', 'Strumenti'],
      zh: ['出版', '科学发现', '平台', '工具'],
      ja: ['出版', '科学的発見', 'プラットフォーム', 'ツール'],
      ko: ['출판', '과학적 발견', '플랫폼', '도구'],
      pl: ['Publikacja', 'Odkrycie naukowe', 'Platforma', 'Narzędzia'],
      ro: ['Publicare', 'Descoperire științifică', 'Platformă', 'Instrumente']
    },
    rating: 4.4
  },
  {
    id: 'scispace',
    name: 'SciSpace',
    description: {
      es: 'Copiloto de IA para investigación que ayuda a leer, entender y escribir papers científicos.',
      en: 'AI research copilot that helps read, understand and write scientific papers.',
      pt: 'Copiloto de IA para pesquisa que ajuda a ler, entender e escrever artigos científicos.',
      fr: 'Copilote IA de recherche qui aide à lire, comprendre et écrire des articles scientifiques.',
      de: 'KI-Forschungscopilot, der beim Lesen, Verstehen und Schreiben wissenschaftlicher Papiere hilft.',
      it: 'Copilota AI per la ricerca che aiuta a leggere, comprendere e scrivere articoli scientifici.',
      zh: '帮助阅读、理解和撰写科学论文的AI研究副驾驶。',
      ja: '科学論文を読み、理解し、書くのを支援するAI研究コパイロット。',
      ko: '과학 논문을 읽고, 이해하고, 작성하는 데 도움을 주는 AI 연구 코파일럿.',
      pl: 'Kopilot badawczy AI, który pomaga czytać, rozumieć i pisać artykuły naukowe.',
      ro: 'Copilot AI de cercetare care ajută la citirea, înțelegerea și scrierea lucrărilor științifice.'
    },
    url: 'https://scispace.com/search',
    category: 'Investigación',
    favicon: 'https://scispace.com/favicon.ico',
    tags: {
      es: ['Copiloto', 'Leer', 'Entender', 'Escribir'],
      en: ['Copilot', 'Read', 'Understand', 'Write'],
      pt: ['Copiloto', 'Ler', 'Entender', 'Escrever'],
      fr: ['Copilote', 'Lire', 'Comprendre', 'Écrire'],
      de: ['Copilot', 'Lesen', 'Verstehen', 'Schreiben'],
      it: ['Copilota', 'Leggere', 'Comprendere', 'Scrivere'],
      zh: ['副驾驶', '阅读', '理解', '写作'],
      ja: ['コパイロット', '読む', '理解', '書く'],
      ko: ['코파일럿', '읽기', '이해', '쓰기'],
      pl: ['Kopilot', 'Czytać', 'Rozumieć', 'Pisać'],
      ro: ['Copilot', 'Citi', 'Înțelege', 'Scrie']
    },
    rating: 4.5
  },
  {
    id: 'scite',
    name: 'Scite',
    description: {
      es: 'Plataforma que utiliza IA para analizar cómo se citan los artículos científicos y evaluar su credibilidad.',
      en: 'Platform that uses AI to analyze how scientific articles are cited and evaluate their credibility.',
      pt: 'Plataforma que usa IA para analisar como artigos científicos são citados e avaliar sua credibilidade.',
      fr: 'Plateforme qui utilise l\'IA pour analyser comment les articles scientifiques sont cités et évaluer leur crédibilité.',
      de: 'Plattform, die KI verwendet, um zu analysieren, wie wissenschaftliche Artikel zitiert werden und ihre Glaubwürdigkeit zu bewerten.',
      it: 'Piattaforma che utilizza l\'IA per analizzare come vengono citati gli articoli scientifici e valutare la loro credibilità.',
      zh: '使用AI分析科学文章如何被引用并评估其可信度的平台。',
      ja: '科学論文がどのように引用されるかを分析し、その信頼性を評価するためにAIを使用するプラットフォーム。',
      ko: '과학 논문이 어떻게 인용되는지 분석하고 신뢰성을 평가하기 위해 AI를 사용하는 플랫폼.',
      pl: 'Platforma, która używa AI do analizy sposobu cytowania artykułów naukowych i oceny ich wiarygodności.',
      ro: 'Platformă care folosește AI pentru a analiza modul în care sunt citate articolele științifice și pentru a evalua credibilitatea lor.'
    },
    url: 'https://scite.ai',
    category: 'Investigación',
    favicon: 'https://scite.ai/favicon.ico',
    tags: {
      es: ['Citas', 'Credibilidad', 'Análisis', 'Científico'],
      en: ['Citations', 'Credibility', 'Analysis', 'Scientific'],
      pt: ['Citações', 'Credibilidade', 'Análise', 'Científico'],
      fr: ['Citations', 'Crédibilité', 'Analyse', 'Scientifique'],
      de: ['Zitationen', 'Glaubwürdigkeit', 'Analyse', 'Wissenschaftlich'],
      it: ['Citazioni', 'Credibilità', 'Analisi', 'Scientifico'],
      zh: ['引用', '可信度', '分析', '科学'],
      ja: ['引用', '信頼性', '分析', '科学的'],
      ko: ['인용', '신뢰성', '분석', '과학적'],
      pl: ['Cytowania', 'Wiarygodność', 'Analiza', 'Naukowy'],
      ro: ['Citări', 'Credibilitate', 'Analiză', 'Științific']
    },
    rating: 4.4
  },
  {
    id: 'semantic-scholar',
    name: 'Semantic Scholar',
    description: {
      es: 'Base de datos académica potenciada por IA con búsqueda inteligente y análisis de citas científicas.',
      en: 'AI-powered academic database with intelligent search and scientific citation analysis.',
      pt: 'Base de dados acadêmica alimentada por IA com busca inteligente e análise de citações científicas.',
      fr: 'Base de données académique alimentée par IA avec recherche intelligente et analyse des citations scientifiques.',
      de: 'KI-gestützte akademische Datenbank mit intelligenter Suche und wissenschaftlicher Zitationsanalyse.',
      it: 'Database accademico alimentato da AI con ricerca intelligente e analisi delle citazioni scientifiche.',
      zh: '具有智能搜索和科学引用分析的AI驱动学术数据库。',
      ja: 'インテリジェント検索と科学的引用分析を備えたAI駆動の学術データベース。',
      ko: '지능적 검색 및 과학적 인용 분석을 갖춘 AI 기반 학술 데이터베이스.',
      pl: 'Baza danych akademickich napędzana przez AI z inteligentnym wyszukiwaniem i analizą cytowań naukowych.',
      ro: 'Bază de date academică alimentată de AI cu căutare inteligentă și analiză a citărilor științifice.'
    },
    url: 'https://semanticscholar.org',
    category: 'Investigación',
    favicon: 'https://semanticscholar.org/favicon.ico',
    tags: {
      es: ['Académico', 'Citas', 'Búsqueda inteligente', 'Base de datos'],
      en: ['Academic', 'Citations', 'Intelligent search', 'Database'],
      pt: ['Acadêmico', 'Citações', 'Busca inteligente', 'Base dados'],
      fr: ['Académique', 'Citations', 'Recherche intelligente', 'Base données'],
      de: ['Akademisch', 'Zitationen', 'Intelligente Suche', 'Datenbank'],
      it: ['Accademico', 'Citazioni', 'Ricerca intelligente', 'Database'],
      zh: ['学术', '引用', '智能搜索', '数据库'],
      ja: ['学術', '引用', 'インテリジェント検索', 'データベース'],
      ko: ['학술', '인용', '지능적 검색', '데이터베이스'],
      pl: ['Akademicki', 'Cytowania', 'Inteligentne wyszukiwanie', 'Baza danych'],
      ro: ['Academic', 'Citări', 'Căutare inteligentă', 'Bază date']
    },
    rating: 4.8
  },
  {
    id: 'socrates',
    name: 'Socrates',
    description: {
      es: 'Asistente de IA para hacer preguntas profundas y análisis crítico de investigación.',
      en: 'AI assistant for deep questioning and critical research analysis.',
      pt: 'Assistente de IA para fazer perguntas profundas e análise crítica de pesquisa.',
      fr: 'Assistant IA pour poser des questions approfondies et analyser la recherche de manière critique.',
      de: 'KI-Assistent für tiefgreifende Befragung und kritische Forschungsanalyse.',
      it: 'Assistente AI per porre domande profonde e analisi critica della ricerca.',
      zh: '用于深度提问和批判性研究分析的AI助手。',
      ja: '深い質問と批判的研究分析のためのAIアシスタント。',
      ko: '깊은 질문과 비판적 연구 분석을 위한 AI 어시스턴트.',
      pl: 'Asystent AI do zadawania głębokich pytań i krytycznej analizy badań.',
      ro: 'Asistent AI pentru întrebări profunde și analiză critică a cercetării.'
    },
    url: 'https://socrates.im',
    category: 'Investigación',
    favicon: 'https://socrates.im/favicon.ico',
    tags: {
      es: ['Preguntas profundas', 'Análisis crítico', 'Asistente', 'Investigación'],
      en: ['Deep questions', 'Critical analysis', 'Assistant', 'Research'],
      pt: ['Perguntas profundas', 'Análise crítica', 'Assistente', 'Pesquisa'],
      fr: ['Questions profondes', 'Analyse critique', 'Assistant', 'Recherche'],
      de: ['Tiefe Fragen', 'Kritische Analyse', 'Assistent', 'Forschung'],
      it: ['Domande profonde', 'Analisi critica', 'Assistente', 'Ricerca'],
      zh: ['深度问题', '批判分析', '助手', '研究'],
      ja: ['深い質問', '批判的分析', 'アシスタント', '研究'],
      ko: ['깊은 질문', '비판적 분석', '어시스턴트', '연구'],
      pl: ['Głębokie pytania', 'Analiza krytyczna', 'Asystent', 'Badania'],
      ro: ['Întrebări profunde', 'Analiză critică', 'Asistent', 'Cercetare']
    },
    rating: 4.2
  },
  {
    id: 'solidpoint',
    name: 'SolidPoint',
    description: {
      es: 'Herramienta de IA para resumir y extraer puntos clave de videos y documentos.',
      en: 'AI tool to summarize and extract key points from videos and documents.',
      pt: 'Ferramenta de IA para resumir e extrair pontos-chave de vídeos e documentos.',
      fr: 'Outil IA pour résumer et extraire les points clés des vidéos et documents.',
      de: 'KI-Tool zum Zusammenfassen und Extrahieren von Schlüsselpunkten aus Videos und Dokumenten.',
      it: 'Strumento AI per riassumere ed estrarre punti chiave da video e documenti.',
      zh: '用于总结和从视频和文档中提取关键点的AI工具。',
      ja: 'ビデオや文書から要点を要約し抽出するためのAIツール。',
      ko: '비디오와 문서에서 핵심 포인트를 요약하고 추출하는 AI 도구.',
      pl: 'Narzędzie AI do podsumowywania i wyodrębniania kluczowych punktów z filmów i dokumentów.',
      ro: 'Instrument AI pentru rezumarea și extragerea punctelor cheie din videoclipuri și documente.'
    },
    url: 'https://solidpoint.ai',
    category: 'Investigación',
    favicon: 'https://solidpoint.ai/favicon.ico',
    tags: {
      es: ['Resumir', 'Puntos clave', 'Videos', 'Documentos'],
      en: ['Summarize', 'Key points', 'Videos', 'Documents'],
      pt: ['Resumir', 'Pontos-chave', 'Vídeos', 'Documentos'],
      fr: ['Résumer', 'Points clés', 'Vidéos', 'Documents'],
      de: ['Zusammenfassen', 'Schlüsselpunkte', 'Videos', 'Dokumente'],
      it: ['Riassumere', 'Punti chiave', 'Video', 'Documenti'],
      zh: ['总结', '关键点', '视频', '文档'],
      ja: ['要約', 'キーポイント', 'ビデオ', '文書'],
      ko: ['요약', '핵심 포인트', '비디오', '문서'],
      pl: ['Podsumowywać', 'Kluczowe punkty', 'Filmy', 'Dokumenty'],
      ro: ['Rezuma', 'Puncte cheie', 'Videoclipuri', 'Documente']
    },
    rating: 4.3
  },
  {
    id: 'undermind',
    name: 'Undermind',
    description: {
      es: 'Motor de búsqueda de IA especializado en descubrimiento de investigación académica profunda.',
      en: 'AI search engine specialized in deep academic research discovery.',
      pt: 'Motor de busca de IA especializado na descoberta de pesquisa acadêmica profunda.',
      fr: 'Moteur de recherche IA spécialisé dans la découverte de recherche académique approfondie.',
      de: 'KI-Suchmaschine spezialisiert auf tiefe akademische Forschungsentdeckung.',
      it: 'Motore di ricerca AI specializzato nella scoperta di ricerca accademica profonda.',
      zh: '专门用于深度学术研究发现的AI搜索引擎。',
      ja: '深い学術研究発見に特化したAIサーチエンジン。',
      ko: '깊은 학술 연구 발견에 특화된 AI 검색 엔진.',
      pl: 'Wyszukiwarka AI specjalizująca się w odkrywaniu głębokich badań akademickich.',
      ro: 'Motor de căutare AI specializat în descoperirea cercetărilor academice profunde.'
    },
    url: 'https://undermind.ai',
    category: 'Investigación',
    favicon: 'https://undermind.ai/favicon.ico',
    tags: {
      es: ['Motor búsqueda', 'Descubrimiento', 'Académica profunda', 'Investigación'],
      en: ['Search engine', 'Discovery', 'Deep academic', 'Research'],
      pt: ['Motor busca', 'Descoberta', 'Acadêmica profunda', 'Pesquisa'],
      fr: ['Moteur recherche', 'Découverte', 'Académique profonde', 'Recherche'],
      de: ['Suchmaschine', 'Entdeckung', 'Tiefe Akademie', 'Forschung'],
      it: ['Motore ricerca', 'Scoperta', 'Accademica profonda', 'Ricerca'],
      zh: ['搜索引擎', '发现', '深度学术', '研究'],
      ja: ['検索エンジン', '発見', '深い学術', '研究'],
      ko: ['검색 엔진', '발견', '깊은 학술', '연구'],
      pl: ['Wyszukiwarka', 'Odkrycie', 'Głęboka akademia', 'Badania'],
      ro: ['Motor căutare', 'Descoperire', 'Academică profundă', 'Cercetare']
    },
    rating: 4.4
  },

  // Texto y redacción (5 recursos)
  {
    id: 'aithor',
    name: 'Aithor',
    description: {
      es: 'Asistente de IA para escritura académica y creación de ensayos con referencias.',
      en: 'AI assistant for academic writing and essay creation with references.',
      pt: 'Assistente de IA para escrita acadêmica e criação de ensaios com referências.',
      fr: 'Assistant IA pour l\'écriture académique et la création d\'essais avec références.',
      de: 'KI-Assistent für akademisches Schreiben und Essay-Erstellung mit Referenzen.',
      it: 'Assistente AI per scrittura accademica e creazione di saggi con riferimenti.',
      zh: '用于学术写作和带参考文献的论文创作的AI助手。',
      ja: '参考文献付きの学術文書作成とエッセイ作成のためのAIアシスタント。',
      ko: '참고문헌이 있는 학술 글쓰기 및 에세이 작성을 위한 AI 어시스턴트.',
      pl: 'Asystent AI do pisania akademickiego i tworzenia esejów z referencjami.',
      ro: 'Asistent AI pentru scrierea academică și crearea de eseuri cu referințe.'
    },
    url: 'https://aithor.com',
    category: 'Texto y redacción',
    favicon: 'https://aithor.com/favicon.ico',
    tags: {
      es: ['Escritura académica', 'Ensayos', 'Referencias', 'Asistente'],
      en: ['Academic writing', 'Essays', 'References', 'Assistant'],
      pt: ['Escrita acadêmica', 'Ensaios', 'Referências', 'Assistente'],
      fr: ['Écriture académique', 'Essais', 'Références', 'Assistant'],
      de: ['Akademisches Schreiben', 'Essays', 'Referenzen', 'Assistent'],
      it: ['Scrittura accademica', 'Saggi', 'Riferimenti', 'Assistente'],
      zh: ['学术写作', '论文', '参考文献', '助手'],
      ja: ['学術文書作成', 'エッセイ', '参考文献', 'アシスタント'],
      ko: ['학술 글쓰기', '에세이', '참고문헌', '어시스턴트'],
      pl: ['Pisanie akademickie', 'Eseje', 'Referencje', 'Asystent'],
      ro: ['Scriere academică', 'Eseuri', 'Referințe', 'Asistent']
    },
    rating: 4.2
  },
  {
    id: 'copy-ai',
    name: 'Copy.ai',
    description: {
      es: 'Generador de contenido con IA para marketing, copywriting y creación de textos.',
      en: 'AI content generator for marketing, copywriting and text creation.',
      pt: 'Gerador de conteúdo com IA para marketing, copywriting e criação de textos.',
      fr: 'Générateur de contenu IA pour le marketing, la rédaction publicitaire et la création de textes.',
      de: 'KI-Inhaltsgenerator für Marketing, Copywriting und Texterstellung.',
      it: 'Generatore di contenuti AI per marketing, copywriting e creazione di testi.',
      zh: '用于营销、文案写作和文本创作的AI内容生成器。',
      ja: 'マーケティング、コピーライティング、テキスト作成のためのAIコンテンツジェネレーター。',
      ko: '마케팅, 카피라이팅 및 텍스트 생성을 위한 AI 콘텐츠 생성기.',
      pl: 'Generator treści AI do marketingu, copywritingu i tworzenia tekstów.',
      ro: 'Generator de conținut AI pentru marketing, copywriting și crearea de texte.'
    },
    url: 'https://www.copy.ai',
    category: 'Texto y redacción',
    favicon: 'https://www.copy.ai/favicon.ico',
    tags: {
      es: ['Marketing', 'Copywriting', 'Generador', 'Contenido'],
      en: ['Marketing', 'Copywriting', 'Generator', 'Content'],
      pt: ['Marketing', 'Copywriting', 'Gerador', 'Conteúdo'],
      fr: ['Marketing', 'Rédaction publicitaire', 'Générateur', 'Contenu'],
      de: ['Marketing', 'Copywriting', 'Generator', 'Inhalt'],
      it: ['Marketing', 'Copywriting', 'Generatore', 'Contenuto'],
      zh: ['营销', '文案写作', '生成器', '内容'],
      ja: ['マーケティング', 'コピーライティング', 'ジェネレーター', 'コンテンツ'],
      ko: ['마케팅', '카피라이팅', '생성기', '콘텐츠'],
      pl: ['Marketing', 'Copywriting', 'Generator', 'Treść'],
      ro: ['Marketing', 'Copywriting', 'Generator', 'Conținut']
    },
    rating: 4.4
  },
  {
    id: 'grammarly',
    name: 'Grammarly',
    description: {
      es: 'Asistente de escritura con IA para corrección gramatical, estilo y tono en múltiples idiomas.',
      en: 'AI writing assistant for grammar correction, style and tone in multiple languages.',
      pt: 'Assistente de escrita com IA para correção gramatical, estilo e tom em múltiplas linguagens.',
      fr: 'Assistant d\'écriture IA pour la correction grammaticale, le style et le ton en plusieurs langues.',
      de: 'KI-Schreibassistent für Grammatikkorrektur, Stil und Ton in mehreren Sprachen.',
      it: 'Assistente di scrittura AI per correzione grammaticale, stile e tono in più lingue.',
      zh: '用于多语言语法纠正、风格和语调的AI写作助手。',
      ja: '複数言語での文法訂正、スタイル、トーンのためのAIライティングアシスタント。',
      ko: '여러 언어에서 문법 교정, 스타일 및 톤을 위한 AI 글쓰기 어시스턴트.',
      pl: 'Asystent pisania AI do korekty gramatycznej, stylu i tonu w wielu językach.',
      ro: 'Asistent de scriere AI pentru corectarea gramaticală, stilul și tonul în mai multe limbi.'
    },
    url: 'https://www.grammarly.com',
    category: 'Texto y redacción',
    favicon: 'https://www.grammarly.com/favicon.ico',
    tags: {
      es: ['Gramática', 'Estilo', 'Multiidioma', 'Corrección'],
      en: ['Grammar', 'Style', 'Multilingual', 'Correction'],
      pt: ['Gramática', 'Estilo', 'Multilíngue', 'Correção'],
      fr: ['Grammaire', 'Style', 'Multilingue', 'Correction'],
      de: ['Grammatik', 'Stil', 'Mehrsprachig', 'Korrektur'],
      it: ['Grammatica', 'Stile', 'Multilingue', 'Correzione'],
      zh: ['语法', '风格', '多语言', '纠正'],
      ja: ['文法', 'スタイル', '多言語', '訂正'],
      ko: ['문법', '스타일', '다국어', '교정'],
      pl: ['Gramatyka', 'Styl', 'Wielojęzyczny', 'Korekta'],
      ro: ['Gramatică', 'Stil', 'Multilingv', 'Corectare']
    },
    rating: 4.7
  },
  {
    id: 'languagetool',
    name: 'LanguageTool',
    description: {
      es: 'Corrector gramatical y de estilo multiidioma con funciones avanzadas de IA.',
      en: 'Multilingual grammar and style checker with advanced AI features.',
      pt: 'Corretor gramatical e de estilo multilíngue com recursos avançados de IA.',
      fr: 'Correcteur grammatical et stylistique multilingue avec fonctionnalités IA avancées.',
      de: 'Mehrsprachiger Grammatik- und Stilprüfer mit erweiterten KI-Funktionen.',
      it: 'Correttore grammaticale e di stile multilingue con funzionalità AI avanzate.',
      zh: '具有高级AI功能的多语言语法和风格检查器。',
      ja: '高度なAI機能を備えた多言語文法・スタイルチェッカー。',
      ko: '고급 AI 기능을 갖춘 다국어 문법 및 스타일 검사기.',
      pl: 'Wielojęzyczny sprawdzacz gramatyki i stylu z zaawansowanymi funkcjami AI.',
      ro: 'Verificator gramatical și de stil multilingv cu funcționalități AI avansate.'
    },
    url: 'https://languagetool.org',
    category: 'Texto y redacción',
    favicon: 'https://languagetool.org/favicon.ico',
    tags: {
      es: ['Corrector gramatical', 'Multiidioma', 'Estilo', 'Avanzadas'],
      en: ['Grammar checker', 'Multilingual', 'Style', 'Advanced'],
      pt: ['Corretor gramatical', 'Multilíngue', 'Estilo', 'Avançado'],
      fr: ['Correcteur grammatical', 'Multilingue', 'Style', 'Avancé'],
      de: ['Grammatikprüfer', 'Mehrsprachig', 'Stil', 'Erweitert'],
      it: ['Correttore grammaticale', 'Multilingue', 'Stile', 'Avanzato'],
      zh: ['语法检查器', '多语言', '风格', '高级'],
      ja: ['文法チェッカー', '多言語', 'スタイル', '高度'],
      ko: ['문법 검사기', '다국어', '스타일', '고급'],
      pl: ['Sprawdzacz gramatyki', 'Wielojęzyczny', 'Styl', 'Zaawansowany'],
      ro: ['Verificator gramatical', 'Multilingv', 'Stil', 'Avansat']
    },
    rating: 4.5
  },
  {
    id: 'quillbot',
    name: 'QuillBot',
    description: {
      es: 'Herramienta de parafraseo y escritura con IA que mejora la claridad y el estilo del texto.',
      en: 'AI paraphrasing and writing tool that improves text clarity and style.',
      pt: 'Ferramenta de paráfrase e escrita com IA que melhora a clareza e estilo do texto.',
      fr: 'Outil de paraphrase et d\'écriture IA qui améliore la clarté et le style du texte.',
      de: 'KI-Paraphrasierungs- und Schreibtool, das Textklarheit und -stil verbessert.',
      it: 'Strumento di parafrasi e scrittura AI che migliora la chiarezza e lo stile del testo.',
      zh: '提高文本清晰度和风格的AI释义和写作工具。',
      ja: 'テキストの明瞭性とスタイルを向上させるAI言い換えおよび執筆ツール。',
      ko: '텍스트의 명확성과 스타일을 향상시키는 AI 의역 및 쓰기 도구.',
      pl: 'Narzędzie AI do parafrazowania i pisania, które poprawia jasność i styl tekstu.',
      ro: 'Instrument AI de parafrază și scriere care îmbunătățește claritatea și stilul textului.'
    },
    url: 'https://quillbot.com',
    category: 'Texto y redacción',
    favicon: 'https://quillbot.com/favicon.ico',
    tags: {
      es: ['Parafraseo', 'Escritura', 'Claridad', 'Estilo'],
      en: ['Paraphrasing', 'Writing', 'Clarity', 'Style'],
      pt: ['Paráfrase', 'Escrita', 'Clareza', 'Estilo'],
      fr: ['Paraphrase', 'Écriture', 'Clarté', 'Style'],
      de: ['Paraphrasierung', 'Schreiben', 'Klarheit', 'Stil'],
      it: ['Parafrasi', 'Scrittura', 'Chiarezza', 'Stile'],
      zh: ['释义', '写作', '清晰度', '风格'],
      ja: ['言い換え', '執筆', '明瞭性', 'スタイル'],
      ko: ['의역', '쓰기', '명확성', '스타일'],
      pl: ['Parafrazowanie', 'Pisanie', 'Jasność', 'Styl'],
      ro: ['Parafrază', 'Scriere', 'Claritate', 'Stil']
    },
    rating: 4.4
  },

  // Educación (2 recursos)
  {
    id: 'genially',
    name: 'Genially',
    description: {
      es: 'Plataforma para crear contenido educativo interactivo con herramientas de IA.',
      en: 'Platform to create interactive educational content with AI tools.',
      pt: 'Plataforma para criar conteúdo educacional interativo com ferramentas de IA.',
      fr: 'Plateforme pour créer du contenu éducatif interactif avec des outils IA.',
      de: 'Plattform zur Erstellung interaktiver Bildungsinhalte mit KI-Tools.',
      it: 'Piattaforma per creare contenuti educativi interattivi con strumenti AI.',
      zh: '使用AI工具创建互动教育内容的平台。',
      ja: 'AIツールを使用してインタラクティブな教育コンテンツを作成するプラットフォーム。',
      ko: 'AI 도구로 대화형 교육 콘텐츠를 만드는 플랫폼.',
      pl: 'Platforma do tworzenia interaktywnych treści edukacyjnych z narzędziami AI.',
      ro: 'Platformă pentru crearea de conținut educațional interactiv cu instrumente AI.'
    },
    url: 'https://genially.com',
    category: 'Educación',
    favicon: 'https://genially.com/favicon.ico',
    tags: {
      es: ['Contenido educativo', 'Interactivo', 'Plataforma', 'Creativo'],
      en: ['Educational content', 'Interactive', 'Platform', 'Creative'],
      pt: ['Conteúdo educacional', 'Interativo', 'Plataforma', 'Criativo'],
      fr: ['Contenu éducatif', 'Interactif', 'Plateforme', 'Créatif'],
      de: ['Bildungsinhalt', 'Interaktiv', 'Plattform', 'Kreativ'],
      it: ['Contenuto educativo', 'Interattivo', 'Piattaforma', 'Creativo'],
      zh: ['教育内容', '互动', '平台', '创意'],
      ja: ['教育コンテンツ', 'インタラクティブ', 'プラットフォーム', 'クリエイティブ'],
      ko: ['교육 콘텐츠', '대화형', '플랫폼', '창의적'],
      pl: ['Treść edukacyjna', 'Interaktywny', 'Platforma', 'Kreatywny'],
      ro: ['Conținut educațional', 'Interactiv', 'Platformă', 'Creativ']
    },
    rating: 4.6
  },
  {
    id: 'quizlet',
    name: 'Quizlet',
    description: {
      es: 'Herramienta de estudio con IA para crear flashcards, cuestionarios y material educativo.',
      en: 'AI study tool to create flashcards, quizzes and educational material.',
      pt: 'Ferramenta de estudo com IA para criar flashcards, questionários e material educacional.',
      fr: 'Outil d\'étude IA pour créer des flashcards, des quiz et du matériel éducatif.',
      de: 'KI-Lerntool zur Erstellung von Lernkarten, Quiz und Bildungsmaterial.',
      it: 'Strumento di studio AI per creare flashcard, quiz e materiale educativo.',
      zh: '用于创建闪卡、测验和教育材料的AI学习工具。',
      ja: 'フラッシュカード、クイズ、教育資料を作成するためのAI学習ツール。',
      ko: '플래시카드, 퀴즈 및 교육 자료를 만드는 AI 학습 도구.',
      pl: 'Narzędzie do nauki AI do tworzenia fiszek, quizów i materiałów edukacyjnych.',
      ro: 'Instrument de studiu AI pentru crearea de flashcard-uri, chestionare și materiale educaționale.'
    },
    url: 'https://quizlet.com',
    category: 'Educación',
    favicon: 'https://quizlet.com/favicon.ico',
    tags: {
      es: ['Estudio', 'Flashcards', 'Cuestionarios', 'Material educativo'],
      en: ['Study', 'Flashcards', 'Quizzes', 'Educational material'],
      pt: ['Estudo', 'Flashcards', 'Questionários', 'Material educacional'],
      fr: ['Étude', 'Flashcards', 'Quiz', 'Matériel éducatif'],
      de: ['Studium', 'Lernkarten', 'Quiz', 'Bildungsmaterial'],
      it: ['Studio', 'Flashcard', 'Quiz', 'Materiale educativo'],
      zh: ['学习', '闪卡', '测验', '教育材料'],
      ja: ['学習', 'フラッシュカード', 'クイズ', '教育資料'],
      ko: ['학습', '플래시카드', '퀴즈', '교육 자료'],
      pl: ['Nauka', 'Fiszki', 'Quizy', 'Materiał edukacyjny'],
      ro: ['Studiu', 'Flashcard-uri', 'Chestionare', 'Material educațional']
    },
    rating: 4.5
  },

  // Chatbots (12 recursos)
  {
    id: 'chatgpt',
    name: 'ChatGPT',
    description: {
      es: 'El asistente de IA más popular para conversaciones, escritura, programación y análisis. Desarrollado por OpenAI.',
      en: 'The most popular AI assistant for conversations, writing, programming and analysis. Developed by OpenAI.',
      pt: 'O assistente de IA mais popular para conversas, escrita, programação e análise. Desenvolvido pela OpenAI.',
      fr: 'L\'assistant IA le plus populaire pour les conversations, l\'écriture, la programmation et l\'analyse. Développé par OpenAI.',
      de: 'Der beliebteste KI-Assistent für Gespräche, Schreiben, Programmierung und Analyse. Entwickelt von OpenAI.',
      it: 'L\'assistente AI più popolare per conversazioni, scrittura, programmazione e analisi. Sviluppato da OpenAI.',
      zh: '最受欢迎的AI助手，用于对话、写作、编程和分析。由OpenAI开发。',
      ja: '会話、執筆、プログラミング、分析のための最も人気のあるAIアシスタント。OpenAIによって开发。',
      ko: '대화, 글쓰기, 프로그래밍 및 분석을 위한 가장 인기 있는 AI 어시스턴트. OpenAI에서 개발.',
      pl: 'Najpopularniejszy asystent AI do rozmów, pisania, programowania i analiz. Opracowany przez OpenAI.',
      ro: 'Cel mai popular asistent AI pentru conversații, scriere, programare și analiză. Dezvoltat de OpenAI.'
    },
    url: 'https://chatgpt.com',
    category: 'Chatbots',
    favicon: 'https://chatgpt.com/favicon.ico',
    tags: {
      es: ['Conversación', 'Escritura', 'Programación', 'Análisis'],
      en: ['Conversation', 'Writing', 'Programming', 'Analysis'],
      pt: ['Conversa', 'Escrita', 'Programação', 'Análise'],
      fr: ['Conversation', 'Écriture', 'Programmation', 'Analyse'],
      de: ['Gespräch', 'Schreiben', 'Programmierung', 'Analyse'],
      it: ['Conversazione', 'Scrittura', 'Programmazione', 'Analisi'],
      zh: ['对话', '写作', '编程', '分析'],
      ja: ['会話', '執筆', 'プログラミング', '分析'],
      ko: ['대화', '글쓰기', '프로그래밍', '분석'],
      pl: ['Rozmowa', 'Pisanie', 'Programowanie', 'Analiza'],
      ro: ['Conversație', 'Scriere', 'Programare', 'Analiză']
    },
    rating: 4.9
  },
  {
    id: 'claude',
    name: 'Claude',
    description: {
      es: 'Asistente de IA de Anthropic, especializado en conversaciones largas y análisis detallado de documentos.',
      en: 'Anthropic AI assistant, specialized in long conversations and detailed document analysis.',
      pt: 'Assistente de IA da Anthropic, especializado em conversas longas e análise detalhada de documentos.',
      fr: 'Assistant IA d\'Anthropic, spécialisé dans les longues conversations et l\'analyse détaillée de documents.',
      de: 'Anthropic KI-Assistent, spezialisiert auf lange Gespräche und detaillierte Dokumentenanalyse.',
      it: 'Assistente AI di Anthropic, specializzato in conversazioni lunghe e analisi dettagliata di documenti.',
      zh: 'Anthropic的AI助手，专门从事长对话和详细的文档分析。',
      ja: 'Anthropicの長い会話と詳細な文書分析に特化したAIアシスタント。',
      ko: '긴 대화와 상세한 문서 분석에 특화된 Anthropic의 AI 어시스턴트.',
      pl: 'Asystent AI Anthropic, specjalizujący się w długich rozmowach i szczegółowej analizie dokumentów.',
      ro: 'Asistent AI Anthropic, specializat în conversații lungi și analiză detaliată a documentelor.'
    },
    url: 'https://www.anthropic.com/claude',
    category: 'Chatbots',
    favicon: 'https://www.anthropic.com/favicon.ico',
    tags: {
      es: ['Conversación', 'Análisis', 'Documentos', 'Escritura'],
      en: ['Conversation', 'Analysis', 'Documents', 'Writing'],
      pt: ['Conversa', 'Análise', 'Documentos', 'Escrita'],
      fr: ['Conversation', 'Analyse', 'Documents', 'Écriture'],
      de: ['Gespräch', 'Analyse', 'Dokumente', 'Schreiben'],
      it: ['Conversazione', 'Analisi', 'Documenti', 'Scrittura'],
      zh: ['对话', '分析', '文档', '写作'],
      ja: ['会話', '分析', '文書', '執筆'],
      ko: ['대화', '분석', '문서', '글쓰기'],
      pl: ['Rozmowa', 'Analiza', 'Dokumenty', 'Pisanie'],
      ro: ['Conversație', 'Analiză', 'Documente', 'Scriere']
    },
    rating: 4.8
  },
  {
    id: 'deepseek',
    name: 'DeepSeek',
    description: {
      es: 'Modelo de IA conversacional avanzado para análisis profundo y razonamiento complejo.',
      en: 'Advanced conversational AI model for deep analysis and complex reasoning.',
      pt: 'Modelo de IA conversacional avançado para análise profunda e raciocínio complexo.',
      fr: 'Modèle IA conversationnel avancé pour l\'analyse approfondie et le raisonnement complexe.',
      de: 'Fortgeschrittenes konversationelles KI-Modell für tiefgreifende Analyse und komplexe Schlussfolgerungen.',
      it: 'Modello AI conversazionale avanzato per analisi profonda e ragionamento complesso.',
      zh: '用于深度分析和复杂推理的高级对话式AI模型。',
      ja: '深い分析と複雑な推論のための高度な対話型AIモデル。',
      ko: '깊은 분석과 복잡한 추론을 위한 고급 대화형 AI 모델.',
      pl: 'Zaawansowany konwersacyjny model AI do głębokiej analizy i złożonego rozumowania.',
      ro: 'Model AI conversațional avansat pentru analiză profundă și raționament complex.'
    },
    url: 'https://www.deepseek.com',
    category: 'Chatbots',
    favicon: 'https://www.deepseek.com/favicon.ico',
    tags: {
      es: ['Conversacional', 'Análisis profundo', 'Razonamiento', 'Avanzado'],
      en: ['Conversational', 'Deep analysis', 'Reasoning', 'Advanced'],
      pt: ['Conversacional', 'Análise profunda', 'Raciocínio', 'Avançado'],
      fr: ['Conversationnel', 'Analyse approfondie', 'Raisonnement', 'Avancé'],
      de: ['Konversational', 'Tiefgreifende Analyse', 'Schlussfolgerung', 'Fortgeschritten'],
      it: ['Conversazionale', 'Analisi profonda', 'Ragionamento', 'Avanzato'],
      zh: ['对话式', '深度分析', '推理', '高级'],
      ja: ['対話型', '深い分析', '推論', '高度'],
      ko: ['대화형', '깊은 분석', '추론', '고급'],
      pl: ['Konwersacyjny', 'Głęboka analiza', 'Rozumowanie', 'Zaawansowany'],
      ro: ['Conversațional', 'Analiză profundă', 'Raționament', 'Avansat']
    },
    rating: 4.6
  },
  {
    id: 'gemini-google',
    name: 'Gemini',
    description: {
      es: 'IA multimodal de Google que puede procesar texto, imágenes, audio y video en una sola conversación.',
      en: 'Google\'s multimodal AI that can process text, images, audio and video in a single conversation.',
      pt: 'IA multimodal do Google que pode processar texto, imagens, áudio e vídeo em uma única conversa.',
      fr: 'IA multimodale de Google qui peut traiter texte, images, audio et vidéo en une seule conversation.',
      de: 'Googles multimodale KI, die Text, Bilder, Audio und Video in einem einzigen Gespräch verarbeiten kann.',
      it: 'IA multimodale di Google che può elaborare testo, immagini, audio e video in una singola conversazione.',
      zh: '谷歌的多模态AI，可以在单次对话中处理文本、图像、音频和视频。',
      ja: 'テキスト、画像、音声、動画を1つの会話で処理できるGoogleのマルチモーダルAI。',
      ko: '단일 대화에서 텍스트, 이미지, 오디오 및 비디오를 처리할 수 있는 Google의 멀티모달 AI.',
      pl: 'Multimodalna AI Google, która może przetwarzać tekst, obrazy, dźwięk i wideo w jednej rozmowie.',
      ro: 'IA multimodală Google care poate procesa text, imagini, audio și video într-o singură conversație.'
    },
    url: 'https://gemini.google.com',
    category: 'Chatbots',
    favicon: 'https://www.google.com/favicon.ico',
    tags: {
      es: ['Multimodal', 'Google', 'Conversación', 'Texto'],
      en: ['Multimodal', 'Google', 'Conversation', 'Text'],
      pt: ['Multimodal', 'Google', 'Conversa', 'Texto'],
      fr: ['Multimodal', 'Google', 'Conversation', 'Texte'],
      de: ['Multimodal', 'Google', 'Gespräch', 'Text'],
      it: ['Multimodale', 'Google', 'Conversazione', 'Testo'],
      zh: ['多模态', '谷歌', '对话', '文本'],
      ja: ['マルチモーダル', 'Google', '会話', 'テキスト'],
      ko: ['멀티모달', '구글', '대화', '텍스트'],
      pl: ['Multimodalny', 'Google', 'Rozmowa', 'Tekst'],
      ro: ['Multimodal', 'Google', 'Conversație', 'Text']
    },
    rating: 4.7
  },
  {
    id: 'grok',
    name: 'Grok',
    description: {
      es: 'Asistente de IA de xAI con acceso en tiempo real a información y personalidad única.',
      en: 'xAI AI assistant with real-time information access and unique personality.',
      pt: 'Assistente de IA da xAI com acesso a informações em tempo real e personalidade única.',
      fr: 'Assistant IA de xAI avec accès aux informations en temps réel et personnalité unique.',
      de: 'xAI KI-Assistent mit Echtzeit-Informationszugang und einzigartiger Persönlichkeit.',
      it: 'Assistente AI di xAI con accesso alle informazioni in tempo reale e personalità unica.',
      zh: 'xAI的AI助手，具有实时信息访问和独特个性。',
      ja: 'リアルタイム情報アクセスと独特の個性を持つxAIのAIアシスタント。',
      ko: '실시간 정보 액세스와 독특한 성격을 가진 xAI의 AI 어시스턴트.',
      pl: 'Asystent AI xAI z dostępem do informacji w czasie rzeczywistym i unikalną osobowością.',
      ro: 'Asistent AI xAI cu acces la informații în timp real și personalitate unică.'
    },
    url: 'https://grok.com',
    category: 'Chatbots',
    favicon: 'https://grok.com/favicon.ico',
    tags: {
      es: ['Tiempo real', 'Información', 'Personalidad', 'xAI'],
      en: ['Real-time', 'Information', 'Personality', 'xAI'],
      pt: ['Tempo real', 'Informação', 'Personalidade', 'xAI'],
      fr: ['Temps réel', 'Information', 'Personnalité', 'xAI'],
      de: ['Echtzeit', 'Information', 'Persönlichkeit', 'xAI'],
      it: ['Tempo reale', 'Informazione', 'Personalità', 'xAI'],
      zh: ['实时', '信息', '个性', 'xAI'],
      ja: ['リアルタイム', '情報', '個性', 'xAI'],
      ko: ['실시간', '정보', '성격', 'xAI'],
      pl: ['Czas rzeczywisty', 'Informacja', 'Osobowość', 'xAI'],
      ro: ['Timp real', 'Informație', 'Personalitate', 'xAI']
    },
    rating: 4.3
  },
  {
    id: 'liquid-ai',
    name: 'Liquid AI',
    description: {
      es: 'Plataforma de IA conversacional con modelos de lenguaje líquidos y adaptables.',
      en: 'Conversational AI platform with liquid and adaptable language models.',
      pt: 'Plataforma de IA conversacional com modelos de linguagem líquidos e adaptáveis.',
      fr: 'Plateforme IA conversationnelle avec des modèles de langage liquides et adaptables.',
      de: 'Konversationelle KI-Plattform mit flüssigen und anpassbaren Sprachmodellen.',
      it: 'Piattaforma AI conversazionale con modelli linguistici liquidi e adattabili.',
      zh: '具有液态和适应性语言模型的对话式AI平台。',
      ja: '液体で適応可能な言語モデルを持つ対话型AIプラットフォーム。',
      ko: '유동적이고 적응 가능한 언어 모델을 갖춘 대화형 AI 플랫폼.',
      pl: 'Platforma konwersacyjnej AI z płynnymi i adaptacyjnymi modelami językowymi.',
      ro: 'Platformă AI conversațională cu modele de limbaj lichide și adaptabile.'
    },
    url: 'https://playground.liquid.ai',
    category: 'Chatbots',
    favicon: 'https://playground.liquid.ai/favicon.ico',
    tags: {
      es: ['Modelos líquidos', 'Adaptables', 'Conversacional', 'Plataforma'],
      en: ['Liquid models', 'Adaptable', 'Conversational', 'Platform'],
      pt: ['Modelos líquidos', 'Adaptáveis', 'Conversacional', 'Plataforma'],
      fr: ['Modèles liquides', 'Adaptables', 'Conversationnel', 'Plateforme'],
      de: ['Flüssige Modelle', 'Anpassbar', 'Konversational', 'Plattform'],
      it: ['Modelli liquidi', 'Adattabili', 'Conversazionale', 'Piattaforma'],
      zh: ['液态模型', '适应性', '对话式', '平台'],
      ja: ['液体モデル', '適応可能', '対話型', 'プラットフォーム'],
      ko: ['유동 모델', '적응 가능', '대화형', '플랫폼'],
      pl: ['Modele płynne', 'Adaptacyjne', 'Konwersacyjny', 'Platforma'],
      ro: ['Modele lichide', 'Adaptabile', 'Conversațional', 'Platformă']
    },
    rating: 4.2
  },
  {
    id: 'meta-ai',
    name: 'Meta AI',
    description: {
      es: 'Asistente de inteligencia artificial de Meta integrado en sus plataformas sociales.',
      en: 'Meta artificial intelligence assistant integrated into their social platforms.',
      pt: 'Assistente de inteligência artificial da Meta integrado em suas plataformas sociais.',
      fr: 'Assistant d\'intelligence artificielle de Meta intégré dans leurs plateformes sociales.',
      de: 'Meta Künstliche Intelligenz-Assistent, integriert in ihre sozialen Plattformen.',
      it: 'Assistente di intelligenza artificiale di Meta integrato nelle loro piattaforme sociali.',
      zh: 'Meta人工智能助手，集成到他们的社交平台中。',
      ja: 'Metaの人工知能アシスタント、ソーシャルプラットフォームに統合。',
      ko: 'Meta의 인공지능 어시스턴트, 소셜 플랫폼에 통합.',
      pl: 'Asystent sztucznej inteligencji Meta zintegrowany z ich platformami społecznościowymi.',
      ro: 'Asistent de inteligență artificială Meta integrat în platformele lor sociale.'
    },
    url: 'https://www.meta.ai',
    category: 'Chatbots',
    favicon: 'https://www.meta.ai/favicon.ico',
    tags: {
      es: ['Meta', 'Plataformas sociales', 'Integrado', 'Asistente'],
      en: ['Meta', 'Social platforms', 'Integrated', 'Assistant'],
      pt: ['Meta', 'Plataformas sociais', 'Integrado', 'Assistente'],
      fr: ['Meta', 'Plateformes sociales', 'Intégré', 'Assistant'],
      de: ['Meta', 'Soziale Plattformen', 'Integriert', 'Assistent'],
      it: ['Meta', 'Piattaforme sociali', 'Integrato', 'Assistente'],
      zh: ['Meta', '社交平台', '集成', '助手'],
      ja: ['Meta', 'ソーシャルプラットフォーム', '統合', 'アシスタント'],
      ko: ['메타', '소셜 플랫폼', '통합', '어시스턴트'],
      pl: ['Meta', 'Platformy społecznościowe', 'Zintegrowany', 'Asystent'],
      ro: ['Meta', 'Platforme sociale', 'Integrat', 'Asistent']
    },
    rating: 4.4
  },
  {
    id: 'copilot-microsoft',
    name: 'Copilot',
    description: {
      es: 'Asistente de IA de Microsoft integrado en Windows y aplicaciones de Office.',
      en: 'Microsoft AI assistant integrated into Windows and Office applications.',
      pt: 'Assistente de IA da Microsoft integrado no Windows e aplicativos do Office.',
      fr: 'Assistant IA de Microsoft intégré dans Windows et les applications Office.',
      de: 'Microsoft KI-Assistent, integriert in Windows und Office-Anwendungen.',
      it: 'Assistente AI di Microsoft integrato in Windows e applicazioni Office.',
      zh: '集成到Windows和Office应用程序中的微软AI助手。',
      ja: 'WindowsとOfficeアプリケーションに統合されたMicrosoftのAIアシスタント。',
      ko: 'Windows 및 Office 애플리케이션에 통합된 Microsoft AI 어시스턴트.',
      pl: 'Asystent AI Microsoft zintegrowany z Windows i aplikacjami Office.',
      ro: 'Asistent AI Microsoft integrat în Windows și aplicațiile Office.'
    },
    url: 'https://copilot.microsoft.com',
    category: 'Chatbots',
    favicon: 'https://copilot.microsoft.com/favicon.ico',
    tags: {
      es: ['Microsoft', 'Windows', 'Office', 'Integrado'],
      en: ['Microsoft', 'Windows', 'Office', 'Integrated'],
      pt: ['Microsoft', 'Windows', 'Office', 'Integrado'],
      fr: ['Microsoft', 'Windows', 'Office', 'Intégré'],
      de: ['Microsoft', 'Windows', 'Office', 'Integriert'],
      it: ['Microsoft', 'Windows', 'Office', 'Integrato'],
      zh: ['微软', 'Windows', 'Office', '集成'],
      ja: ['Microsoft', 'Windows', 'Office', '統合'],
      ko: ['마이크로소프트', 'Windows', 'Office', '통합'],
      pl: ['Microsoft', 'Windows', 'Office', 'Zintegrowany'],
      ro: ['Microsoft', 'Windows', 'Office', 'Integrat']
    },
    rating: 4.5
  },
  {
    id: 'mistral-ai',
    name: 'Mistral AI',
    description: {
      es: 'Modelos de IA conversacional europeos con enfoque en eficiencia y rendimiento.',
      en: 'European conversational AI models with focus on efficiency and performance.',
      pt: 'Modelos de IA conversacional europeus com foco em eficiência e desempenho.',
      fr: 'Modèles IA conversationnels européens axés sur l\'efficacité et la performance.',
      de: 'Europäische konversationelle KI-Modelle mit Fokus auf Effizienz und Leistung.',
      it: 'Modelli AI conversazionali europei con focus su efficienza e prestazioni.',
      zh: '专注于效率和性能的欧洲对话式AI模型。',
      ja: '効率性と性能に焦点を当てたヨーロッパの对话型AIモデル。',
      ko: '효율성과 성능에 중점을 둔 유럽의 대화형 AI 모델.',
      pl: 'Europejskie konwersacyjne modele AI z naciskiem na wydajność i skuteczność.',
      ro: 'Modele AI conversaționale europene cu accent pe eficiență și performanță.'
    },
    url: 'https://mistral.ai',
    category: 'Chatbots',
    favicon: 'https://mistral.ai/favicon.ico',
    tags: {
      es: ['Europeos', 'Eficiencia', 'Rendimiento', 'Modelos'],
      en: ['European', 'Efficiency', 'Performance', 'Models'],
      pt: ['Europeus', 'Eficiência', 'Desempenho', 'Modelos'],
      fr: ['Européens', 'Efficacité', 'Performance', 'Modèles'],
      de: ['Europäisch', 'Effizienz', 'Leistung', 'Modelle'],
      it: ['Europei', 'Efficienza', 'Prestazioni', 'Modelli'],
      zh: ['欧洲', '效率', '性能', '模型'],
      ja: ['ヨーロッパ', '効率性', '性能', 'モデル'],
      ko: ['유럽', '효율성', '성능', '모델'],
      pl: ['Europejskie', 'Wydajność', 'Skuteczność', 'Modele'],
      ro: ['Europene', 'Eficiență', 'Performanță', 'Modele']
    },
    rating: 4.4
  },
  {
    id: 'poe',
    name: 'Poe',
    description: {
      es: 'Acceso a múltiples modelos de IA como ChatGPT, Claude, y otros en una sola plataforma.',
      en: 'Access to multiple AI models like ChatGPT, Claude, and others in a single platform.',
      pt: 'Acesso a múltiplos modelos de IA como ChatGPT, Claude e outros em uma única plataforma.',
      fr: 'Accès à plusieurs modèles IA comme ChatGPT, Claude et autres sur une seule plateforme.',
      de: 'Zugang zu mehreren KI-Modellen wie ChatGPT, Claude und anderen auf einer einzigen Plattform.',
      it: 'Accesso a più modelli AI come ChatGPT, Claude e altri in un\'unica piattaforma.',
      zh: '在单个平台上访问ChatGPT、Claude等多个AI模型。',
      ja: 'ChatGPT、Claudeなど複数のAIモデルに単一プラットフォームでアクセス。',
      ko: '단일 플랫폼에서 ChatGPT, Claude 등 여러 AI 모델에 액세스.',
      pl: 'Dostęp do wielu modeli AI jak ChatGPT, Claude i innych na jednej platformie.',
      ro: 'Acces la multiple modele AI precum ChatGPT, Claude și altele pe o singură platformă.'
    },
    url: 'https://poe.com',
    category: 'Chatbots',
    favicon: 'https://poe.com/favicon.ico',
    tags: {
      es: ['Múltiples modelos', 'Plataforma', 'ChatGPT', 'Claude'],
      en: ['Multiple models', 'Platform', 'ChatGPT', 'Claude'],
      pt: ['Múltiplos modelos', 'Plataforma', 'ChatGPT', 'Claude'],
      fr: ['Multiples modèles', 'Plateforme', 'ChatGPT', 'Claude'],
      de: ['Mehrere Modelle', 'Plattform', 'ChatGPT', 'Claude'],
      it: ['Modelli multipli', 'Piattaforma', 'ChatGPT', 'Claude'],
      zh: ['多个模型', '平台', 'ChatGPT', 'Claude'],
      ja: ['複数モデル', 'プラットフォーム', 'ChatGPT', 'Claude'],
      ko: ['여러 모델', '플랫폼', 'ChatGPT', 'Claude'],
      pl: ['Wiele modeli', 'Platforma', 'ChatGPT', 'Claude'],
      ro: ['Modele multiple', 'Platformă', 'ChatGPT', 'Claude']
    },
    rating: 4.5
  },
  {
    id: 'qwen-ai',
    name: 'Qwen',
    description: {
      es: 'Modelo de IA conversacional multimodal desarrollado por Alibaba Cloud.',
      en: 'Multimodal conversational AI model developed by Alibaba Cloud.',
      pt: 'Modelo de IA conversacional multimodal desenvolvido pela Alibaba Cloud.',
      fr: 'Modèle IA conversationnel multimodal développé par Alibaba Cloud.',
      de: 'Multimodales konversationelles KI-Modell, entwickelt von Alibaba Cloud.',
      it: 'Modello AI conversazionale multimodale sviluppato da Alibaba Cloud.',
      zh: '阿里巴巴云开发的多模态对话式AI模型。',
      ja: 'Alibaba Cloudが開发したマルチモーダル対話型AIモデル。',
      ko: 'Alibaba Cloud에서 개발한 멀티모달 대화형 AI 모델.',
      pl: 'Multimodalny konwersacyjny model AI opracowany przez Alibaba Cloud.',
      ro: 'Model AI conversațional multimodal dezvoltat de Alibaba Cloud.'
    },
    url: 'https://chat.qwen.ai',
    category: 'Chatbots',
    favicon: 'https://chat.qwen.ai/favicon.ico',
    tags: {
      es: ['Multimodal', 'Alibaba Cloud', 'Conversacional', 'Desarrollado'],
      en: ['Multimodal', 'Alibaba Cloud', 'Conversational', 'Developed'],
      pt: ['Multimodal', 'Alibaba Cloud', 'Conversacional', 'Desenvolvido'],
      fr: ['Multimodal', 'Alibaba Cloud', 'Conversationnel', 'Développé'],
      de: ['Multimodal', 'Alibaba Cloud', 'Konversational', 'Entwickelt'],
      it: ['Multimodale', 'Alibaba Cloud', 'Conversazionale', 'Sviluppato'],
      zh: ['多模态', '阿里巴巴云', '对话式', '开发'],
      ja: ['マルチモーダル', 'Alibaba Cloud', '対話型', '開发'],
      ko: ['멀티모달', 'Alibaba Cloud', '대화형', '개발'],
      pl: ['Multimodalny', 'Alibaba Cloud', 'Konwersacyjny', 'Opracowany'],
      ro: ['Multimodal', 'Alibaba Cloud', 'Conversațional', 'Dezvoltat']
    },
    rating: 4.3
  },
  {
    id: 'venice-ai',
    name: 'Venice AI',
    description: {
      es: 'Plataforma de IA conversacional con enfoque en privacidad y descentralización.',
      en: 'Conversational AI platform with focus on privacy and decentralization.',
      pt: 'Plataforma de IA conversacional com foco em privacidade e descentralização.',
      fr: 'Plateforme IA conversationnelle axée sur la confidentialité et la décentralisation.',
      de: 'Konversationelle KI-Plattform mit Fokus auf Privatsphäre und Dezentralisierung.',
      it: 'Piattaforma AI conversazionale con focus su privacy e decentralizzazione.',
      zh: '专注于隐私和去中心化的对话式AI平台。',
      ja: 'プライバシーと分散化に焦点を当てた对话型AIプラットフォーム。',
      ko: '프라이버시와 탈중앙화에 중점을 둔 대화형 AI 플랫폼.',
      pl: 'Platforma konwersacyjnej AI z naciskiem na prywatność i decentralizację.',
      ro: 'Platformă AI conversațională cu accent pe confidențialitate și descentralizare.'
    },
    url: 'https://venice.ai',
    category: 'Chatbots',
    favicon: 'https://venice.ai/favicon.ico',
    tags: {
      es: ['Privacidad', 'Descentralización', 'Conversacional', 'Plataforma'],
      en: ['Privacy', 'Decentralization', 'Conversational', 'Platform'],
      pt: ['Privacidade', 'Descentralização', 'Conversacional', 'Plataforma'],
      fr: ['Confidentialité', 'Décentralisation', 'Conversationnel', 'Plateforme'],
      de: ['Privatsphäre', 'Dezentralisierung', 'Konversational', 'Plattform'],
      it: ['Privacy', 'Decentralizzazione', 'Conversazionale', 'Piattaforma'],
      zh: ['隐私', '去中心化', '对话式', '平台'],
      ja: ['プライバシー', '分散化', '対話型', 'プラットフォーム'],
      ko: ['프라이버시', '탈중앙화', '대화형', '플랫폼'],
      pl: ['Prywatność', 'Decentralizacja', 'Konwersacyjny', 'Platforma'],
      ro: ['Confidențialitate', 'Descentralizare', 'Conversațional', 'Platformă']
    },
    rating: 4.1
  },

  // Video (14 recursos)
  {
    id: 'aistudios',
    name: 'AI Studios',
    description: {
      es: 'Plataforma para crear videos con avatares de IA realistas y síntesis de voz avanzada.',
      en: 'Platform to create videos with realistic AI avatars and advanced voice synthesis.',
      pt: 'Plataforma para criar vídeos com avatares de IA realistas e síntese de voz avançada.',
      fr: 'Plateforme pour créer des vidéos avec des avatars IA réalistes et synthèse voc ale avancée.',
      de: 'Plattform zur Erstellung von Videos mit realistischen KI-Avataren und fortgeschrittener Sprachsynthese.',
      it: 'Piattaforma per creare video con avatar AI realistici e sintesi vocale avanzata.',
      zh: '使用逼真的AI头像和高级语音合成创建视频的平台。',
      ja: 'リアルなAIアバターと高度な音声合成でビデオを作成するプラットフォーム。',
      ko: '현실적인 AI 아바타와 고급 음성 합성으로 비디오를 만드는 플랫폼.',
      pl: 'Platforma do tworzenia filmów z realistycznymi awatarami AI i zaawansowaną syntezą mowy.',
      ro: 'Platformă pentru crearea de videoclipuri cu avataruri AI realiste și sinteză vocală avansată.'
    },
    url: 'https://www.aistudios.com',
    category: 'Video',
    favicon: 'https://www.aistudios.com/favicon.ico',
    tags: {
      es: ['Avatares realistas', 'Síntesis voz', 'Plataforma', 'Avanzada'],
      en: ['Realistic avatars', 'Voice synthesis', 'Platform', 'Advanced'],
      pt: ['Avatares realistas', 'Síntese voz', 'Plataforma', 'Avançada'],
      fr: ['Avatars réalistes', 'Synthèse vocale', 'Plateforme', 'Avancée'],
      de: ['Realistische Avatare', 'Sprachsynthese', 'Plattform', 'Fortgeschritten'],
      it: ['Avatar realistici', 'Sintesi vocale', 'Piattaforma', 'Avanzata'],
      zh: ['逼真头像', '语音合成', '平台', '高级'],
      ja: ['リアルアバター', '音声合成', 'プラットフォーム', '高度'],
      ko: ['현실적 아바타', '음성 합성', '플랫폼', '고급'],
      pl: ['Realistyczne awatary', 'Synteza mowy', 'Platforma', 'Zaawansowana'],
      ro: ['Avataruri realiste', 'Sinteză vocală', 'Platformă', 'Avansată']
    },
    rating: 4.6
  },
  {
    id: 'bigvu',
    name: 'BIGVU',
    description: {
      es: 'Herramienta de creación de videos con teleprompter inteligente y edición automática.',
      en: 'Video creation tool with smart teleprompter and automatic editing.',
      pt: 'Ferramenta de criação de vídeos com teleprompter inteligente e edição automática.',
      fr: 'Outil de création vidéo avec télésouffleur intelligent et montage automatique.',
      de: 'Video-Erstellungstool mit intelligentem Teleprompter und automatischer Bearbeitung.',
      it: 'Strumento di creazione video con teleprompter intelligente e editing automatico.',
      zh: '具有智能提词器和自动编辑功能的视频创作工具。',
      ja: 'スマートテレプロンプターと自動編集機能を備えたビデオ作成ツール。',
      ko: '스마트 텔레프롬프터와 자동 편집 기능을 갖춘 비디오 제작 도구.',
      pl: 'Narzędzie do tworzenia filmów z inteligentnym teleprompterem i automatyczną edycją.',
      ro: 'Instrument de creare video cu teleprompter inteligent și editare automată.'
    },
    url: 'https://bigvu.tv',
    category: 'Video',
    favicon: 'https://bigvu.tv/favicon.ico',
    tags: {
      es: ['Teleprompter', 'Edición automática', 'Creación videos', 'Inteligente'],
      en: ['Teleprompter', 'Automatic editing', 'Video creation', 'Smart'],
      pt: ['Teleprompter', 'Edição automática', 'Criação vídeos', 'Inteligente'],
      fr: ['Télésouffleur', 'Montage automatique', 'Création vidéo', 'Intelligent'],
      de: ['Teleprompter', 'Automatische Bearbeitung', 'Video-Erstellung', 'Intelligent'],
      it: ['Teleprompter', 'Editing automatico', 'Creazione video', 'Intelligente'],
      zh: ['提词器', '自动编辑', '视频创作', '智能'],
      ja: ['テレプロンプター', '自動編集', 'ビデオ作成', 'スマート'],
      ko: ['텔레프롬프터', '자동 편집', '비디오 제작', '스마트'],
      pl: ['Teleprompter', 'Automatyczna edycja', 'Tworzenie filmów', 'Inteligentny'],
      ro: ['Teleprompter', 'Editare automată', 'Creare video', 'Inteligent']
    },
    rating: 4.3
  },
  {
    id: 'capcut',
    name: 'CapCut',
    description: {
      es: 'Editor de video con herramientas de IA para efectos, subtítulos automáticos y edición inteligente.',
      en: 'Video editor with AI tools for effects, automatic subtitles and smart editing.',
      pt: 'Editor de vídeo com ferramentas de IA para efeitos, legendas automáticas e edição inteligente.',
      fr: 'Éditeur vidéo avec outils IA pour effets, sous-titres automatiques et montage intelligent.',
      de: 'Video-Editor mit KI-Tools für Effekte, automatische Untertitel und intelligente Bearbeitung.',
      it: 'Editor video con strumenti AI per effetti, sottotitoli automatici e editing intelligente.',
      zh: '具有AI工具的视频编辑器，用于特效、自动字幕和智能编辑。',
      ja: 'エフェクト、自動字幕、スマート編集のためのAIツールを備えたビデオエディター。',
      ko: '효과, 자동 자막 및 스마트 편집을 위한 AI 도구가 있는 비디오 편집기.',
      pl: 'Edytor wideo z narzędziami AI do efektów, automatycznych napisów i inteligentnej edycji.',
      ro: 'Editor video cu instrumente AI pentru efecte, subtitrări automate și editare inteligentă.'
    },
    url: 'https://www.capcut.com',
    category: 'Video',
    favicon: 'https://www.capcut.com/favicon.ico',
    tags: {
      es: ['Editor video', 'Efectos', 'Subtítulos automáticos', 'Edición inteligente'],
      en: ['Video editor', 'Effects', 'Automatic subtitles', 'Smart editing'],
      pt: ['Editor vídeo', 'Efeitos', 'Legendas automáticas', 'Edição inteligente'],
      fr: ['Éditeur vidéo', 'Effets', 'Sous-titres automatiques', 'Montage intelligent'],
      de: ['Video-Editor', 'Effekte', 'Automatische Untertitel', 'Intelligente Bearbeitung'],
      it: ['Editor video', 'Effetti', 'Sottotitoli automatici', 'Editing intelligente'],
      zh: ['视频编辑器', '特效', '自动字幕', '智能编辑'],
      ja: ['ビデオエディター', 'エフェクト', '自動字幕', 'スマート編集'],
      ko: ['비디오 편집기', '효과', '자동 자막', '스마트 편집'],
      pl: ['Edytor wideo', 'Efekty', 'Automatyczne napisy', 'Inteligentna edycja'],
      ro: ['Editor video', 'Efecte', 'Subtitrări automate', 'Editare inteligentă']
    },
    rating: 4.5
  },
  {
    id: 'clipchamp',
    name: 'Clipchamp',
    description: {
      es: 'Editor de video de Microsoft con herramientas de IA para creación y edición automática.',
      en: 'Microsoft video editor with AI tools for creation and automatic editing.',
      pt: 'Editor de vídeo da Microsoft com ferramentas de IA para criação e edição automática.',
      fr: 'Éditeur vidéo Microsoft avec outils IA pour création et montage automatique.',
      de: 'Microsoft Video-Editor mit KI-Tools für Erstellung und automatische Bearbeitung.',
      it: 'Editor video Microsoft con strumenti AI per creazione e editing automatico.',
      zh: '微软视频编辑器，具有用于创建和自动编辑的AI工具。',
      ja: '作成と自動編集のためのAIツールを備えたMicrosoftビデオエディター。',
      ko: '생성 및 자동 편집을 위한 AI 도구가 있는 Microsoft 비디오 편집기.',
      pl: 'Edytor wideo Microsoft z narzędziami AI do tworzenia i automatycznej edycji.',
      ro: 'Editor video Microsoft cu instrumente AI pentru crearea și editarea automată.'
    },
    url: 'https://clipchamp.com',
    category: 'Video',
    favicon: 'https://clipchamp.com/favicon.ico',
    tags: {
      es: ['Microsoft', 'Editor video', 'Creación', 'Edición automática'],
      en: ['Microsoft', 'Video editor', 'Creation', 'Automatic editing'],
      pt: ['Microsoft', 'Editor vídeo', 'Criação', 'Edição automática'],
      fr: ['Microsoft', 'Éditeur vidéo', 'Création', 'Montage automatique'],
      de: ['Microsoft', 'Video-Editor', 'Erstellung', 'Automatische Bearbeitung'],
      it: ['Microsoft', 'Editor video', 'Creazione', 'Editing automatico'],
      zh: ['微软', '视频编辑器', '创建', '自动编辑'],
      ja: ['Microsoft', 'ビデオエディター', '作成', '自動編集'],
      ko: ['마이크로소프트', '비디오 편집기', '생성', '자동 편집'],
      pl: ['Microsoft', 'Edytor wideo', 'Tworzenie', 'Automatyczna edycja'],
      ro: ['Microsoft', 'Editor video', 'Creare', 'Editare automată']
    },
    rating: 4.4
  },
  {
    id: 'flexclip',
    name: 'FlexClip',
    description: {
      es: 'Creador de videos online con plantillas y herramientas de IA para marketing y redes sociales.',
      en: 'Online video creator with templates and AI tools for marketing and social media.',
      pt: 'Criador de vídeos online com modelos e ferramentas de IA para marketing e redes sociais.',
      fr: 'Créateur de vidéos en ligne avec modèles et outils IA pour marketing et réseaux sociaux.',
      de: 'Online-Video-Creator mit Vorlagen und KI-Tools für Marketing und soziale Medien.',
      it: 'Creatore video online con template e strumenti AI per marketing e social media.',
      zh: '在线视频创作工具，具有用于营销和社交媒体的模板和AI工具。',
      ja: 'マーケティングとソーシャルメディア用のテンプレートとAIツールを備えたオンラインビデオクリエーター。',
      ko: '마케팅과 소셜 미디어를 위한 템플릿과 AI 도구가 있는 온라인 비디오 제작 도구.',
      pl: 'Internetowy kreator filmów z szablonami i narzędziami AI do marketingu i mediów społecznościowych.',
      ro: 'Creator video online cu șabloane și instrumente AI pentru marketing și rețele sociale.'
    },
    url: 'https://www.flexclip.com',
    category: 'Video',
    favicon: 'https://www.flexclip.com/favicon.ico',
    tags: {
      es: ['Creador videos', 'Plantillas', 'Marketing', 'Redes sociales'],
      en: ['Video creator', 'Templates', 'Marketing', 'Social media'],
      pt: ['Criador vídeos', 'Modelos', 'Marketing', 'Redes sociais'],
      fr: ['Créateur vidéo', 'Modèles', 'Marketing', 'Réseaux sociaux'],
      de: ['Video-Creator', 'Vorlagen', 'Marketing', 'Soziale Medien'],
      it: ['Creatore video', 'Template', 'Marketing', 'Social media'],
      zh: ['视频创作者', '模板', '营销', '社交媒体'],
      ja: ['ビデオクリエーター', 'テンプレート', 'マーケティング', 'ソーシャルメディア'],
      ko: ['비디오 제작자', '템플릿', '마케팅', '소셜 미디어'],
      pl: ['Kreator wideo', 'Szablony', 'Marketing', 'Media społecznościowe'],
      ro: ['Creator video', 'Șabloane', 'Marketing', 'Rețele sociale']
    },
    rating: 4.3
  },
  {
    id: 'invideo',
    name: 'InVideo',
    description: {
      es: 'Creación de videos profesionales usando IA con plantillas y edición automática.',
      en: 'Professional video creation using AI with templates and automatic editing.',
      pt: 'Criação de vídeos profissionais usando IA com modelos e edição automática.',
      fr: 'Création de vidéos professionnelles utilisant l\'IA avec modèles et montage automatique.',
      de: 'Professionelle Video-Erstellung mit KI mit Vorlagen und automatischer Bearbeitung.',
      it: 'Creazione video professionale utilizzando AI con template e editing automatico.',
      zh: '使用AI进行专业视频创作，具有模板和自动编辑功能。',
      ja: 'テンプレートと自動編集機能を備えたAIを使用したプロフェッショナルビデオ作成。',
      ko: '템플릿과 자동 편집 기능을 갖춘 AI를 사용한 전문 비디오 제작.',
      pl: 'Profesjonalne tworzenie filmów przy użyciu AI z szablonami i automatyczną edycją.',
      ro: 'Crearea de videoclipuri profesionale folosind AI cu șabloane și editare automată.'
    },
    url: 'https://invideo.io',
    category: 'Video',
    favicon: 'https://invideo.io/favicon.ico',
    tags: {
      es: ['Videos profesionales', 'Plantillas', 'Edición automática'],
      en: ['Professional videos', 'Templates', 'Automatic editing'],
      pt: ['Vídeos profissionais', 'Modelos', 'Edição automática'],
      fr: ['Vidéos professionnelles', 'Modèles', 'Montage automatique'],
      de: ['Professionelle Videos', 'Vorlagen', 'Automatische Bearbeitung'],
      it: ['Video professionali', 'Template', 'Editing automatico'],
      zh: ['专业视频', '模板', '自动编辑'],
      ja: ['プロフェッショナルビデオ', 'テンプレート', '自動編集'],
      ko: ['전문 비디오', '템플릿', '자동 편집'],
      pl: ['Profesjonalne filmy', 'Szablony', 'Automatyczna edycja'],
      ro: ['Videoclipuri profesionale', 'Șabloane', 'Editare automată']
    },
    rating: 4.3
  },
  {
    id: 'jogg-ai',
    name: 'Jogg AI',
    description: {
      es: 'Generador de videos publicitarios con IA para comercio electrónico y marketing digital.',
      en: 'AI advertising video generator for e-commerce and digital marketing.',
      pt: 'Gerador de vídeos publicitários com IA para comércio eletrônico e marketing digital.',
      fr: 'Générateur de vidéos publicitaires IA pour e-commerce et marketing digital.',
      de: 'KI-Werbevideo-Generator für E-Commerce und digitales Marketing.',
      it: 'Generatore video pubblicitari AI per e-commerce e marketing digitale.',
      zh: '用于电子商务和数字营销的AI广告视频生成器。',
      ja: 'Eコマースとデジタルマーケティング用のAI広告ビデオジェネレーター。',
      ko: '전자상거래 및 디지털 마케팅을 위한 AI 광고 비디오 생성기.',
      pl: 'Generator filmów reklamowych AI dla e-commerce i marketingu cyfrowego.',
      ro: 'Generator video publicitare AI pentru e-commerce și marketing digital.'
    },
    url: 'https://www.jogg.ai',
    category: 'Video',
    favicon: 'https://www.jogg.ai/favicon.ico',
    tags: {
      es: ['Videos publicitarios', 'Comercio electrónico', 'Marketing digital', 'Generador'],
      en: ['Advertising videos', 'E-commerce', 'Digital marketing', 'Generator'],
      pt: ['Vídeos publicitários', 'Comércio eletrônico', 'Marketing digital', 'Gerador'],
      fr: ['Vidéos publicitaires', 'E-commerce', 'Marketing digital', 'Générateur'],
      de: ['Werbevideos', 'E-Commerce', 'Digitales Marketing', 'Generator'],
      it: ['Video pubblicitari', 'E-commerce', 'Marketing digitale', 'Generatore'],
      zh: ['广告视频', '电子商务', '数字营销', '生成器'],
      ja: ['広告ビデオ', 'Eコマース', 'デジタルマーケティング', 'ジェネレーター'],
      ko: ['광고 비디오', '전자상거래', '디지털 마케팅', '생성기'],
      pl: ['Filmy reklamowe', 'E-commerce', 'Marketing cyfrowy', 'Generator'],
      ro: ['Video publicitare', 'E-commerce', 'Marketing digital', 'Generator']
    },
    rating: 4.2
  },
  {
    id: 'jupitrr',
    name: 'Jupitrr',
    description: {
      es: 'Plataforma de IA para añadir automáticamente elementos visuales y gráficos a videos.',
      en: 'AI platform to automatically add visual elements and graphics to videos.',
      pt: 'Plataforma de IA para adicionar automaticamente elementos visuais e gráficos a vídeos.',
      fr: 'Plateforme IA pour ajouter automatiquement des éléments visuels et graphiques aux vidéos.',
      de: 'KI-Plattform zum automatischen Hinzufügen visueller Elemente und Grafiken zu Videos.',
      it: 'Piattaforma AI per aggiungere automaticamente elementi visivi e grafici ai video.',
      zh: '自动为视频添加视觉元素和图形的AI平台。',
      ja: 'ビデオに視覚的要素とグラフィックを自動的に追加するAIプラットフォーム。',
      ko: '비디오에 시각적 요소와 그래픽을 자동으로 추가하는 AI 플랫폼.',
      pl: 'Platforma AI do automatycznego dodawania elementów wizualnych i grafik do filmów.',
      ro: 'Platformă AI pentru adăugarea automată de elemente vizuale și grafice la videoclipuri.'
    },
    url: 'https://jupitrr.com',
    category: 'Video',
    favicon: 'https://jupitrr.com/favicon.ico',
    tags: {
      es: ['Elementos visuales', 'Gráficos', 'Automático', 'Plataforma'],
      en: ['Visual elements', 'Graphics', 'Automatic', 'Platform'],
      pt: ['Elementos visuais', 'Gráficos', 'Automático', 'Plataforma'],
      fr: ['Éléments visuels', 'Graphiques', 'Automatique', 'Plateforme'],
      de: ['Visuelle Elemente', 'Grafiken', 'Automatisch', 'Plattform'],
      it: ['Elementi visivi', 'Grafici', 'Automatico', 'Piattaforma'],
      zh: ['视觉元素', '图形', '自动', '平台'],
      ja: ['視覚的要素', 'グラフィック', '自動', 'プラットフォーム'],
      ko: ['시각적 요소', '그래픽', '자동', '플랫폼'],
      pl: ['Elementy wizualne', 'Grafiki', 'Automatyczny', 'Platforma'],
      ro: ['Elemente vizuale', 'Grafice', 'Automat', 'Platformă']
    },
    rating: 4.1
  },
  {
    id: 'lumen5',
    name: 'Lumen5',
    description: {
      es: 'Transformación automática de contenido de blog y texto en videos atractivos usando IA.',
      en: 'Automatic transformation of blog content and text into engaging videos using AI.',
      pt: 'Transformação automática de conteúdo de blog e texto em vídeos envolventes usando IA.',
      fr: 'Transformation automatique de contenu de blog et texte en vidéos engageantes utilisant l\'IA.',
      de: 'Automatische Umwandlung von Blog-Inhalten und Text in ansprechende Videos mit KI.',
      it: 'Trasformazione automatica di contenuti blog e testo in video coinvolgenti utilizzando AI.',
      zh: '使用AI自动将博客内容和文本转换为引人入胜的视频。',
      ja: 'AIを使用してブログコンテンツとテキストを魅力的なビデオに自動変換。',
      ko: 'AI를 사용하여 블로그 콘텐츠와 텍스트를 매력적인 비디오로 자동 변환.',
      pl: 'Automatyczna transformacja treści bloga i tekstu w angażujące filmy przy użyciu AI.',
      ro: 'Transformarea automată a conținutului blog și textului în videoclipuri atractive folosind AI.'
    },
    url: 'https://lumen5.com',
    category: 'Video',
    favicon: 'https://lumen5.com/favicon.ico',
    tags: {
      es: ['Blog a video', 'Texto a video', 'Atractivos', 'Transformación'],
      en: ['Blog to video', 'Text to video', 'Engaging', 'Transformation'],
      pt: ['Blog para vídeo', 'Texto para vídeo', 'Envolventes', 'Transformação'],
      fr: ['Blog vers vidéo', 'Texte vers vidéo', 'Engageant', 'Transformation'],
      de: ['Blog zu Video', 'Text zu Video', 'Ansprechend', 'Umwandlung'],
      it: ['Blog a video', 'Testo a video', 'Coinvolgenti', 'Trasformazione'],
      zh: ['博客转视频', '文本转视频', '引人入胜', '转换'],
      ja: ['ブログからビデオ', 'テキストからビデオ', '魅力的', '変換'],
      ko: ['블로그를 비디오로', '텍스트를 비디오로', '매력적', '변환'],
      pl: ['Blog do wideo', 'Tekst do wideo', 'Angażujące', 'Transformacja'],
      ro: ['Blog la video', 'Text la video', 'Atractive', 'Transformare']
    },
    rating: 4.4
  },
  {
    id: 'minvo',
    name: 'Minvo',
    description: {
      es: 'Editor de video con IA para crear clips cortos optimizados para redes sociales.',
      en: 'AI video editor to create short clips optimized for social media.',
      pt: 'Editor de vídeo com IA para criar clipes curtos otimizados para redes sociais.',
      fr: 'Éditeur vidéo IA pour créer des clips courts optimisés pour les réseaux sociaux.',
      de: 'KI-Video-Editor zur Erstellung kurzer Clips, optimiert für soziale Medien.',
      it: 'Editor video AI per creare clip brevi ottimizzati per i social media.',
      zh: '用于创建针对社交媒体优化的短视频的AI视频编辑器。',
      ja: 'ソーシャルメディア向けに最適化された短いクリップを作成するAIビデオエディター。',
      ko: '소셜 미디어에 최적화된 짧은 클립을 만드는 AI 비디오 편집기.',
      pl: 'Edytor wideo AI do tworzenia krótkich klipów zoptymalizowanych dla mediów społecznościowych.',
      ro: 'Editor video AI pentru crearea de clipuri scurte optimizate pentru rețelele sociale.'
    },
    url: 'https://minvo.pro',
    category: 'Video',
    favicon: 'https://minvo.pro/favicon.ico',
    tags: {
      es: ['Clips cortos', 'Redes sociales', 'Editor video', 'Optimizados'],
      en: ['Short clips', 'Social media', 'Video editor', 'Optimized'],
      pt: ['Clipes curtos', 'Redes sociais', 'Editor vídeo', 'Otimizados'],
      fr: ['Clips courts', 'Réseaux sociaux', 'Éditeur vidéo', 'Optimisés'],
      de: ['Kurze Clips', 'Soziale Medien', 'Video-Editor', 'Optimiert'],
      it: ['Clip brevi', 'Social media', 'Editor video', 'Ottimizzati'],
      zh: ['短视频', '社交媒体', '视频编辑器', '优化'],
      ja: ['短いクリップ', 'ソーシャルメディア', 'ビデオエディター', '最適化'],
      ko: ['짧은 클립', '소셜 미디어', '비디오 편집기', '최적화'],
      pl: ['Krótkie klipy', 'Media społecznościowe', 'Edytor wideo', 'Zoptymalizowane'],
      ro: ['Clipuri scurte', 'Rețele sociale', 'Editor video', 'Optimizate']
    },
    rating: 4.2
  },
  {
    id: 'pipio',
    name: 'Pipio',
    description: {
      es: 'Creación de videos con avatares de IA fotorrealistas y voces sintéticas naturales.',
      en: 'Video creation with photorealistic AI avatars and natural synthetic voices.',
      pt: 'Criação de vídeos com avatares de IA fotorrealistas e vozes sintéticas naturais.',
      fr: 'Création de vidéos avec avatars IA photoréalistes et voix synthétiques naturelles.',
      de: 'Video-Erstellung mit fotorealistischen KI-Avataren und natürlichen synthetischen Stimmen.',
      it: 'Creazione video con avatar AI fotorealistici e voci sintetiche naturali.',
      zh: '使用逼真的AI头像和自然合成语音创建视频。',
      ja: 'フォトリアリスティックなAIアバターと自然な合成音声でのビデオ作成。',
      ko: '사실적인 AI 아바타와 자연스러운 합성 음성으로 비디오 제작.',
      pl: 'Tworzenie filmów z fotorealistycznymi awatarami AI i naturalnymi głosami syntetycznymi.',
      ro: 'Crearea de videoclipuri cu avataruri AI fotorealiste și voci sintetice naturale.'
    },
    url: 'https://www.pipio.ai',
    category: 'Video',
    favicon: 'https://www.pipio.ai/favicon.ico',
    tags: {
      es: ['Avatares fotorrealistas', 'Voces sintéticas', 'Naturales', 'Creación videos'],
      en: ['Photorealistic avatars', 'Synthetic voices', 'Natural', 'Video creation'],
      pt: ['Avatares fotorrealistas', 'Vozes sintéticas', 'Naturais', 'Criação vídeos'],
      fr: ['Avatars photoréalistes', 'Voix synthétiques', 'Naturelles', 'Création vidéo'],
      de: ['Fotorealistische Avatare', 'Synthetische Stimmen', 'Natürlich', 'Video-Erstellung'],
      it: ['Avatar fotorealistici', 'Voci sintetiche', 'Naturali', 'Creazione video'],
      zh: ['逼真头像', '合成语音', '自然', '视频创作'],
      ja: ['フォトリアリスティックアバター', '合成音声', '自然', 'ビデオ作成'],
      ko: ['사실적 아바타', '합성 음성', '자연스러운', '비디오 제작'],
      pl: ['Fotorealistyczne awatary', 'Głosy syntetyczne', 'Naturalne', 'Tworzenie filmów'],
      ro: ['Avataruri fotorealiste', 'Voci sintetice', 'Naturale', 'Creare video']
    },
    rating: 4.3
  },
  {
    id: 'skyreels',
    name: 'SkyReels',
    description: {
      es: 'Generador de videos cortos con IA para contenido viral en redes sociales.',
      en: 'AI short video generator for viral content on social media.',
      pt: 'Gerador de vídeos curtos com IA para conteúdo viral em redes sociais.',
      fr: 'Générateur de vidéos courtes IA pour contenu viral sur les réseaux sociaux.',
      de: 'KI-Kurzvideo-Generator für viralen Content in sozialen Medien.',
      it: 'Generatore video brevi AI per contenuti virali sui social media.',
      zh: '用于社交媒体病毒式内容的AI短视频生成器。',
      ja: 'ソーシャルメディアでのバイラルコンテンツ用のAI短編ビデオジェネレーター。',
      ko: '소셜 미디어의 바이럴 콘텐츠를 위한 AI 짧은 비디오 생성기.',
      pl: 'Generator krótkich filmów AI dla wirusowych treści w mediach społecznościowych.',
      ro: 'Generator video scurte AI pentru conținut viral pe rețelele sociale.'
    },
    url: 'https://skyreels.ai',
    category: 'Video',
    favicon: 'https://skyreels.ai/favicon.ico',
    tags: {
      es: ['Videos cortos', 'Contenido viral', 'Redes sociales', 'Generador'],
      en: ['Short videos', 'Viral content', 'Social media', 'Generator'],
      pt: ['Vídeos curtos', 'Conteúdo viral', 'Redes sociais', 'Gerador'],
      fr: ['Vidéos courtes', 'Contenu viral', 'Réseaux sociaux', 'Générateur'],
      de: ['Kurze Videos', 'Viraler Content', 'Soziale Medien', 'Generator'],
      it: ['Video brevi', 'Contenuto virale', 'Social media', 'Generatore'],
      zh: ['短视频', '病毒内容', '社交媒体', '生成器'],
      ja: ['短いビデオ', 'バイラルコンテンツ', 'ソーシャルメディア', 'ジェネレーター'],
      ko: ['짧은 비디오', '바이럴 콘텐츠', '소셜 미디어', '생성기'],
      pl: ['Krótkie filmy', 'Wirusowe treści', 'Media społecznościowe', 'Generator'],
      ro: ['Video scurte', 'Conținut viral', 'Rețele sociale', 'Generator']
    },
    rating: 4.1
  },
  {
    id: 'wave-video',
    name: 'Wave Video',
    description: {
      es: 'Plataforma completa de creación de videos con herramientas de IA y biblioteca de assets.',
      en: 'Complete video creation platform with AI tools and asset library.',
      pt: 'Plataforma completa de criação de vídeos com ferramentas de IA e biblioteca de assets.',
      fr: 'Plateforme complète de création vidéo avec outils IA et bibliothèque d\'assets.',
      de: 'Vollständige Video-Erstellungsplattform mit KI-Tools und Asset-Bibliothek.',
      it: 'Piattaforma completa di creazione video con strumenti AI e libreria di asset.',
      zh: '具有AI工具和资源库的完整视频创作平台。',
      ja: 'AIツールとアセットライブラリを备えた完全なビデオ作成プラットフォーム。',
      ko: 'AI 도구와 에셋 라이브러리를 갖춘 완전한 비디오 제작 플랫폼.',
      pl: 'Kompletna platforma tworzenia filmów z narzędziami AI i biblioteką zasobów.',
      ro: 'Platformă completă de creare video cu instrumente AI și bibliotecă de resurse.'
    },
    url: 'https://wave.video',
    category: 'Video',
    favicon: 'https://wave.video/favicon.ico',
    tags: {
      es: ['Plataforma completa', 'Biblioteca assets', 'Creación videos', 'Herramientas'],
      en: ['Complete platform', 'Asset library', 'Video creation', 'Tools'],
      pt: ['Plataforma completa', 'Biblioteca assets', 'Criação vídeos', 'Ferramentas'],
      fr: ['Plateforme complète', 'Bibliothèque assets', 'Création vidéo', 'Outils'],
      de: ['Vollständige Plattform', 'Asset-Bibliothek', 'Video-Erstellung', 'Werkzeuge'],
      it: ['Piattaforma completa', 'Libreria asset', 'Creazione video', 'Strumenti'],
      zh: ['完整平台', '资源库', '视频创作', '工具'],
      ja: ['完全プラットフォーム', 'アセットライブラリ', 'ビデオ作成', 'ツール'],
      ko: ['완전한 플랫폼', '에셋 라이브러리', '비디오 제작', '도구'],
      pl: ['Kompletna platforma', 'Biblioteka zasobów', 'Tworzenie filmów', 'Narzędzia'],
      ro: ['Platformă completă', 'Bibliotecă resurse', 'Creare video', 'Instrumente']
    },
    rating: 4.4
  },
  {
    id: 'zebracat',
    name: 'ZebraCat',
    description: {
      es: 'Generador de videos de marketing con IA que convierte texto en contenido visual atractivo.',
      en: 'AI marketing video generator that converts text into engaging visual content.',
      pt: 'Gerador de vídeos de marketing com IA que converte texto em conteúdo visual envolvente.',
      fr: 'Générateur de vidéos marketing IA qui convertit le texte en contenu visuel engageant.',
      de: 'KI-Marketing-Video-Generator, der Text in ansprechenden visuellen Content umwandelt.',
      it: 'Generatore video marketing AI che converte testo in contenuto visivo coinvolgente.',
      zh: '将文本转换为引人入胜的视觉内容的AI营销视频生成器。',
      ja: 'テキストを魅力的なビジュアルコンテンツに変換するAIマーケティングビデオジェネレーター。',
      ko: '텍스트를 매력적인 시각적 콘텐츠로 변환하는 AI 마케팅 비디오 생성기.',
      pl: 'Generator filmów marketingowych AI, który konwertuje tekst na angażujące treści wizualne.',
      ro: 'Generator video marketing AI care convertește textul în conținut vizual atrăgător.'
    },
    url: 'https://www.zebracat.ai',
    category: 'Video',
    favicon: 'https://www.zebracat.ai/favicon.ico',
    tags: {
      es: ['Videos marketing', 'Texto a visual', 'Contenido atractivo', 'Generador'],
      en: ['Marketing videos', 'Text to visual', 'Engaging content', 'Generator'],
      pt: ['Vídeos marketing', 'Texto para visual', 'Conteúdo envolvente', 'Gerador'],
      fr: ['Vidéos marketing', 'Texte vers visuel', 'Contenu engageant', 'Générateur'],
      de: ['Marketing-Videos', 'Text zu visuell', 'Ansprechender Content', 'Generator'],
      it: ['Video marketing', 'Testo a visivo', 'Contenuto coinvolgente', 'Generatore'],
      zh: ['营销视频', '文本转视觉', '引人入胜的内容', '生成器'],
      ja: ['マーケティングビデオ', 'テキストからビジュアル', '魅力的コンテンツ', 'ジェネレーター'],
      ko: ['마케팅 비디오', '텍스트를 시각적으로', '매력적 콘텐츠', '생성기'],
      pl: ['Filmy marketingowe', 'Tekst do wizualnego', 'Angażujące treści', 'Generator'],
      ro: ['Video marketing', 'Text la vizual', 'Conținut atrăgător', 'Generator']
    },
    rating: 4.2
  },

  // Mapas mentales (3 recursos)
  {
    id: 'mindmeister',
    name: 'MindMeister',
    description: {
      es: 'Herramienta de mapas mentales colaborativos con funciones de IA para generar ideas y estructura.',
      en: 'Collaborative mind mapping tool with AI functions for idea generation and structure.',
      pt: 'Ferramenta de mapas mentais colaborativos com funções de IA para geração de ideias e estrutura.',
      fr: 'Outil de cartes mentales collaboratives avec fonctions IA pour génération d\'idées et structure.',
      de: 'Kollaboratives Mind-Mapping-Tool mit KI-Funktionen für Ideengenerierung und Struktur.',
      it: 'Strumento di mappe mentali collaborative con funzioni AI per generazione idee e struttura.',
      zh: '具有AI功能的协作思维导图工具，用于创意生成和结构化。',
      ja: 'アイデア生成と構造化のためのAI機能を備えたコラボレーティブマインドマップツール。',
      ko: '아이디어 생성과 구조화를 위한 AI 기능을 갖춘 협업 마인드맵 도구.',
      pl: 'Narzędzie do tworzenia map myśli z funkcjami AI do generowania pomysłów i struktury.',
      ro: 'Instrument de hărți mentale colaborative cu funcții AI pentru generarea ideilor și structură.'
    },
    url: 'https://www.mindmeister.com',
    category: 'Mapas mentales',
    favicon: 'https://www.mindmeister.com/favicon.ico',
    tags: {
      es: ['Colaborativos', 'Generar ideas', 'Estructura', 'Mapas'],
      en: ['Collaborative', 'Idea generation', 'Structure', 'Maps'],
      pt: ['Colaborativos', 'Geração ideias', 'Estrutura', 'Mapas'],
      fr: ['Collaboratif', 'Génération idées', 'Structure', 'Cartes'],
      de: ['Kollaborativ', 'Ideengenerierung', 'Struktur', 'Karten'],
      it: ['Collaborativo', 'Generazione idee', 'Struttura', 'Mappe'],
      zh: ['协作', '创意生成', '结构', '地图'],
      ja: ['コラボレーティブ', 'アイデア生成', '構造', 'マップ'],
      ko: ['협업', '아이디어 생성', '구조', '지도'],
      pl: ['Współpracujący', 'Generowanie pomysłów', 'Struktura', 'Mapy'],
      ro: ['Colaborativ', 'Generare idei', 'Structură', 'Hărți']
    },
    rating: 4.4
  },
  {
    id: 'miro',
    name: 'Miro',
    description: {
      es: 'Pizarra digital colaborativa con herramientas de IA para mapas mentales y lluvia de ideas.',
      en: 'Collaborative digital whiteboard with AI tools for mind maps and brainstorming.',
      pt: 'Quadro digital colaborativo com ferramentas de IA para mapas mentais e brainstorming.',
      fr: 'Tableau blanc numérique collaboratif avec outils IA pour cartes mentales et brainstorming.',
      de: 'Kollaboratives digitales Whiteboard mit KI-Tools für Mind Maps und Brainstorming.',
      it: 'Lavagna digitale collaborativa con strumenti AI per mappe mentali e brainstorming.',
      zh: '具有AI工具的协作数字白板，用于思维导图和头脑风暴。',
      ja: 'マインドマップとブレインストーミング用のAIツールを備えたコラボレーティブデジタルホワイトボード。',
      ko: '마인드맵과 브레인스토밍을 위한 AI 도구를 갖춘 협업 디지털 화이트보드.',
      pl: 'Współpracująca tablica cyfrowa z narzędziami AI do map myśli i burzy mózgów.',
      ro: 'Tablă digitală colaborativă cu instrumente AI pentru hărți mentale și brainstorming.'
    },
    url: 'https://miro.com',
    category: 'Mapas mentales',
    favicon: 'https://miro.com/favicon.ico',
    tags: {
      es: ['Pizarra digital', 'Colaborativa', 'Lluvia de ideas', 'Herramientas'],
      en: ['Digital whiteboard', 'Collaborative', 'Brainstorming', 'Tools'],
      pt: ['Quadro digital', 'Colaborativo', 'Brainstorming', 'Ferramentas'],
      fr: ['Tableau blanc numérique', 'Collaboratif', 'Brainstorming', 'Outils'],
      de: ['Digitales Whiteboard', 'Kollaborativ', 'Brainstorming', 'Werkzeuge'],
      it: ['Lavagna digitale', 'Collaborativo', 'Brainstorming', 'Strumenti'],
      zh: ['数字白板', '协作', '头脑风暴', '工具'],
      ja: ['デジタルホワイトボード', 'コラボレーティブ', 'ブレインストーミング', 'ツール'],
      ko: ['디지털 화이트보드', '협업', '브레인스토밍', '도구'],
      pl: ['Tablica cyfrowa', 'Współpracująca', 'Burza mózgów', 'Narzędzia'],
      ro: ['Tablă digitală', 'Colaborativă', 'Brainstorming', 'Instrumente']
    },
    rating: 4.6
  },
  {
    id: 'nodeland',
    name: 'Nodeland',
    description: {
      es: 'Plataforma de mapas mentales y diagramas con funciones de IA para organización visual.',
      en: 'Mind mapping and diagram platform with AI functions for visual organization.',
      pt: 'Plataforma de mapas mentais e diagramas com funções de IA para organização visual.',
      fr: 'Plateforme de cartes mentales et diagrammes avec fonctions IA pour organisation visuelle.',
      de: 'Mind-Mapping- und Diagramm-Plattform mit KI-Funktionen für visuelle Organisation.',
      it: 'Piattaforma di mappe mentali e diagrammi con funzioni AI per organizzazione visiva.',
      zh: '具有AI功能的思维导图和图表平台，用于视觉组织。',
      ja: '視覚的組織化のためのAI機能を備えたマインドマップと図表プラットフォーム。',
      ko: '시각적 조직화를 위한 AI 기능을 갖춘 마인드맵 및 다이어그램 플랫폼.',
      pl: 'Platforma map myśli i diagramów z funkcjami AI do organizacji wizualnej.',
      ro: 'Platformă de hărți mentale și diagrame cu funcții AI pentru organizarea vizuală.'
    },
    url: 'https://nodeland.io',
    category: 'Mapas mentales',
    favicon: 'https://nodeland.io/favicon.ico',
    tags: {
      es: ['Diagramas', 'Organización visual', 'Plataforma', 'Mapas mentales'],
      en: ['Diagrams', 'Visual organization', 'Platform', 'Mind maps'],
      pt: ['Diagramas', 'Organização visual', 'Plataforma', 'Mapas mentais'],
      fr: ['Diagrammes', 'Organisation visuelle', 'Plateforme', 'Cartes mentales'],
      de: ['Diagramme', 'Visuelle Organisation', 'Plattform', 'Mind Maps'],
      it: ['Diagrammi', 'Organizzazione visiva', 'Piattaforma', 'Mappe mentali'],
      zh: ['图表', '视觉组织', '平台', '思维导图'],
      ja: ['図表', '視覚的組織化', 'プラットフォーム', 'マインドマップ'],
      ko: ['다이어그램', '시각적 조직화', '플랫폼', '마인드맵'],
      pl: ['Diagramy', 'Organizacja wizualna', 'Platforma', 'Mapy myśli'],
      ro: ['Diagrame', 'Organizare vizuală', 'Platformă', 'Hărți mentale']
    },
    rating: 4.2
  },

  // Imágenes (5 recursos)
  {
    id: 'craiyon',
    name: 'Craiyon',
    description: {
      es: 'Generador de imágenes gratuito con IA, anteriormente conocido como DALL-E mini.',
      en: 'Free AI image generator, formerly known as DALL-E mini.',
      pt: 'Gerador de imagens gratuito com IA, anteriormente conhecido como DALL-E mini.',
      fr: 'Générateur d\'images gratuit avec IA, anciennement connu sous le nom de DALL-E mini.',
      de: 'Kostenloser KI-Bildgenerator, früher bekannt als DALL-E mini.',
      it: 'Generatore di immagini gratuito con AI, precedentemente noto come DALL-E mini.',
      zh: '免费的AI图像生成器，以前称为DALL-E mini。',
      ja: '以前DALL-E miniとして知られていた無料のAI画像ジェネレーター。',
      ko: '이전에 DALL-E mini로 알려진 무료 AI 이미지 생성기.',
      pl: 'Darmowy generator obrazów AI, wcześniej znany jako DALL-E mini.',
      ro: 'Generator gratuit de imagini AI, cunoscut anterior ca DALL-E mini.'
    },
    url: 'https://www.craiyon.com',
    category: 'Imágenes',
    favicon: 'https://www.craiyon.com/favicon.ico',
    tags: {
      es: ['Generador gratuito', 'DALL-E mini', 'Imágenes', 'IA'],
      en: ['Free generator', 'DALL-E mini', 'Images', 'AI'],
      pt: ['Gerador gratuito', 'DALL-E mini', 'Imagens', 'IA'],
      fr: ['Générateur gratuit', 'DALL-E mini', 'Images', 'IA'],
      de: ['Kostenloser Generator', 'DALL-E mini', 'Bilder', 'KI'],
      it: ['Generatore gratuito', 'DALL-E mini', 'Immagini', 'IA'],
      zh: ['免费生成器', 'DALL-E mini', '图像', 'AI'],
      ja: ['無料ジェネレーター', 'DALL-E mini', '画像', 'AI'],
      ko: ['무료 생성기', 'DALL-E mini', '이미지', 'AI'],
      pl: ['Darmowy generator', 'DALL-E mini', 'Obrazy', 'AI'],
      ro: ['Generator gratuit', 'DALL-E mini', 'Imagini', 'AI']
    },
    rating: 4.2
  },
  {
    id: 'deepdream',
    name: 'Deep Dream Generator',
    description: {
      es: 'Creador de arte psicodélico y surrealista usando redes neuronales profundas.',
      en: 'Creator of psychedelic and surreal art using deep neural networks.',
      pt: 'Criador de arte psicodélica e surrealista usando redes neurais profundas.',
      fr: 'Créateur d\'art psychédélique et surréaliste utilisant des réseaux de neurones profonds.',
      de: 'Schöpfer psychedelischer und surrealer Kunst mit tiefen neuronalen Netzwerken.',
      it: 'Creatore di arte psichedelica e surreale utilizzando reti neurali profonde.',
      zh: '使用深度神经网络创建迷幻和超现实艺术的创作者。',
      ja: '深層ニューラルネットワークを使用してサイケデリックでシュルレアリスムなアートを作成。',
      ko: '깊은 신경망을 사용하여 사이키델릭하고 초현실적인 예술을 만드는 창작자.',
      pl: 'Twórca sztuki psychodelicznej i surrealistycznej przy użyciu głębokich sieci neuronowych.',
      ro: 'Creator de artă psihedelică și suprarealistă folosind rețele neuronale profunde.'
    },
    url: 'https://deepdreamgenerator.com',
    category: 'Imágenes',
    favicon: 'https://deepdreamgenerator.com/favicon.ico',
    tags: {
      es: ['Arte psicodélico', 'Surrealista', 'Redes neuronales', 'Creador'],
      en: ['Psychedelic art', 'Surreal', 'Neural networks', 'Creator'],
      pt: ['Arte psicodélica', 'Surrealista', 'Redes neurais', 'Criador'],
      fr: ['Art psychédélique', 'Surréaliste', 'Réseaux neuronaux', 'Créateur'],
      de: ['Psychedelische Kunst', 'Surreal', 'Neuronale Netzwerke', 'Schöpfer'],
      it: ['Arte psichedelica', 'Surreale', 'Reti neurali', 'Creatore'],
      zh: ['迷幻艺术', '超现实', '神经网络', '创作者'],
      ja: ['サイケデリックアート', 'シュルレアリスム', 'ニューラルネットワーク', 'クリエーター'],
      ko: ['사이키델릭 아트', '초현실적', '신경망', '창작자'],
      pl: ['Sztuka psychodeliczna', 'Surrealistyczna', 'Sieci neuronowe', 'Twórca'],
      ro: ['Artă psihedelică', 'Suprarealist', 'Rețele neuronale', 'Creator']
    },
    rating: 4.3
  },
  {
    id: 'google-ai-studio',
    name: 'Google AI Studio',
    description: {
      es: 'Plataforma de Google para experimentar con modelos de IA generativa de imágenes.',
      en: 'Google platform to experiment with generative AI image models.',
      pt: 'Plataforma do Google para experimentar com modelos de IA generativa de imagens.',
      fr: 'Plateforme Google pour expérimenter avec des modèles IA génératifs d\'images.',
      de: 'Google-Plattform zum Experimentieren mit generativen KI-Bildmodellen.',
      it: 'Piattaforma Google per sperimentare con modelli AI generativi di immagini.',
      zh: '谷歌平台，用于实验生成式AI图像模型。',
      ja: '生成AIイメージモデルを実験するためのGoogleプラットフォーム。',
      ko: '생성형 AI 이미지 모델을 실험하기 위한 Google 플랫폼.',
      pl: 'Platforma Google do eksperymentowania z generatywnymi modelami AI obrazów.',
      ro: 'Platformă Google pentru experimentarea cu modele AI generative de imagini.'
    },
    url: 'https://aistudio.google.com',
    category: 'Imágenes',
    favicon: 'https://aistudio.google.com/favicon.ico',
    tags: {
      es: ['Google', 'Experimentar', 'Modelos generativos', 'Plataforma'],
      en: ['Google', 'Experiment', 'Generative models', 'Platform'],
      pt: ['Google', 'Experimentar', 'Modelos generativos', 'Plataforma'],
      fr: ['Google', 'Expérimenter', 'Modèles génératifs', 'Plateforme'],
      de: ['Google', 'Experimentieren', 'Generative Modelle', 'Plattform'],
      it: ['Google', 'Sperimentare', 'Modelli generativi', 'Piattaforma'],
      zh: ['谷歌', '实验', '生成模型', '平台'],
      ja: ['Google', '実験', '生成モデル', 'プラットフォーム'],
      ko: ['구글', '실험', '생성 모델', '플랫폼'],
      pl: ['Google', 'Eksperymentować', 'Modele generatywne', 'Platforma'],
      ro: ['Google', 'Experimenta', 'Modele generative', 'Platformă']
    },
    rating: 4.5
  },
  {
    id: 'leonardo-ai',
    name: 'Leonardo AI',
    description: {
      es: 'Plataforma de generación de imágenes con controles avanzados y modelos especializados.',
      en: 'Image generation platform with advanced controls and specialized models.',
      pt: 'Plataforma de geração de imagens com controles avançados e modelos especializados.',
      fr: 'Plateforme de génération d\'images avec contrôles avancés et modèles spécialisés.',
      de: 'Bildgenerierungsplattform mit erweiterten Kontrollen und spezialisierten Modellen.',
      it: 'Piattaforma di generazione immagini con controlli avanzati e modelli specializzati.',
      zh: '具有高级控件和专业模型的图像生成平台。',
      ja: '高度なコントロールと専門モデルを備えた画像生成プラットフォーム。',
      ko: '고급 컨트롤과 전문 모델을 갖춘 이미지 생성 플랫폼.',
      pl: 'Platforma generowania obrazów z zaawansowanymi kontrolami i wyspecjalizowanymi modelami.',
      ro: 'Platformă de generare imagini cu controale avansate și modele specializate.'
    },
    url: 'https://leonardo.ai',
    category: 'Imágenes',
    favicon: 'https://leonardo.ai/favicon.ico',
    tags: {
      es: ['Controles avanzados', 'Modelos especializados', 'Plataforma'],
      en: ['Advanced controls', 'Specialized models', 'Platform'],
      pt: ['Controles avançados', 'Modelos especializados', 'Plataforma'],
      fr: ['Contrôles avancés', 'Modèles spécialisés', 'Plateforme'],
      de: ['Erweiterte Kontrollen', 'Spezialisierte Modelle', 'Plattform'],
      it: ['Controlli avanzati', 'Modelli specializzati', 'Piattaforma'],
      zh: ['高级控件', '专业模型', '平台'],
      ja: ['高度なコントロール', '専門モデル', 'プラットフォーム'],
      ko: ['고급 컨트롤', '전문 모델', '플랫폼'],
      pl: ['Zaawansowane kontrole', 'Wyspecjalizowane modele', 'Platforma'],
      ro: ['Controale avansate', 'Modele specializate', 'Platformă']
    },
    rating: 4.6
  },
  {
    id: 'runway-images',
    name: 'Runway ML',
    description: {
      es: 'Suite creativa de IA para generación y edición de imágenes con herramientas profesionales.',
      en: 'Creative AI suite for image generation and editing with professional tools.',
      pt: 'Suíte criativa de IA para geração e edição de imagens com ferramentas profissionais.',
      fr: 'Suite créative IA pour génération et édition d\'images avec outils professionnels.',
      de: 'Kreative KI-Suite für Bildgenerierung und -bearbeitung mit professionellen Tools.',
      it: 'Suite creativa AI per generazione e editing di immagini con strumenti professionali.',
      zh: '用于图像生成和编辑的创意AI套件，具有专业工具。',
      ja: 'プロフェッショナルツールを備えた画像生成と編集のためのクリエイティブAIスイート。',
      ko: '전문 도구를 갖춘 이미지 생성 및 편집을 위한 창의적 AI 스위트.',
      pl: 'Kreatywny pakiet AI do generowania i edycji obrazów z profesjonalnymi narzędziami.',
      ro: 'Suită creativă AI pentru generarea și editarea imaginilor cu instrumente profesionale.'
    },
    url: 'https://runwayml.com',
    category: 'Imágenes',
    favicon: 'https://runwayml.com/favicon.ico',
    tags: {
      es: ['Suite creativa', 'Edición imágenes', 'Herramientas profesionales', 'Generación'],
      en: ['Creative suite', 'Image editing', 'Professional tools', 'Generation'],
      pt: ['Suíte criativa', 'Edição imagens', 'Ferramentas profissionais', 'Geração'],
      fr: ['Suite créative', 'Édition images', 'Outils professionnels', 'Génération'],
      de: ['Kreative Suite', 'Bildbearbeitung', 'Professionelle Tools', 'Generierung'],
      it: ['Suite creativa', 'Editing immagini', 'Strumenti professionali', 'Generazione'],
      zh: ['创意套件', '图像编辑', '专业工具', '生成'],
      ja: ['クリエイティブスイート', '画像編集', 'プロフェッショナルツール', '生成'],
      ko: ['창의적 스위트', '이미지 편집', '전문 도구', '생성'],
      pl: ['Pakiet kreatywny', 'Edycja obrazów', 'Profesjonalne narzędzia', 'Generowanie'],
      ro: ['Suită creativă', 'Editare imagini', 'Instrumente profesionale', 'Generare']
    },
    rating: 4.8
  },

  // Diseño (7 recursos)
  {
    id: 'canva',
    name: 'Canva',
    description: {
      es: 'Herramientas de IA integradas en Canva para diseño gráfico, generación de imágenes y edición.',
      en: 'AI tools integrated in Canva for graphic design, image generation and editing.',
      pt: 'Ferramentas de IA integradas no Canva para design gráfico, geração de imagens e edição.',
      fr: 'Outils IA intégrés dans Canva pour design graphique, génération d\'images et édition.',
      de: 'In Canva integrierte KI-Tools für Grafikdesign, Bildgenerierung und -bearbeitung.',
      it: 'Strumenti AI integrati in Canva per design grafico, generazione immagini e editing.',
      zh: '集成在Canva中的AI工具，用于图形设计、图像生成和编辑。',
      ja: 'グラフィックデザイン、画像生成、編集のためにCanvaに統合されたAIツール。',
      ko: '그래픽 디자인, 이미지 생성 및 편집을 위해 Canva에 통합된 AI 도구.',
      pl: 'Narzędzia AI zintegrowane w Canva do projektowania graficznego, generowania obrazów i edycji.',
      ro: 'Instrumente AI integrate în Canva pentru design grafic, generarea imaginilor și editare.'
    },
    url: 'https://www.canva.com',
    category: 'Diseño',
    favicon: 'https://www.canva.com/favicon.ico',
    tags: {
      es: ['Diseño gráfico', 'Edición', 'Fácil uso', 'Herramientas'],
      en: ['Graphic design', 'Editing', 'Easy to use', 'Tools'],
      pt: ['Design gráfico', 'Edição', 'Fácil uso', 'Ferramentas'],
      fr: ['Design graphique', 'Édition', 'Facile à utiliser', 'Outils'],
      de: ['Grafikdesign', 'Bearbeitung', 'Einfach zu bedienen', 'Werkzeuge'],
      it: ['Design grafico', 'Editing', 'Facile da usare', 'Strumenti'],
      zh: ['图形设计', '编辑', '易于使用', '工具'],
      ja: ['グラフィックデザイン', '編集', '使いやすい', 'ツール'],
      ko: ['그래픽 디자인', '편집', '사용하기 쉬운', '도구'],
      pl: ['Projektowanie graficzne', 'Edycja', 'Łatwy w użyciu', 'Narzędzia'],
      ro: ['Design grafic', 'Editare', 'Ușor de folosit', 'Instrumente']
    },
    rating: 4.6
  },
  {
    id: 'chatslide',
    name: 'ChatSlide',
    description: {
      es: 'Creador de presentaciones con IA que genera slides automáticamente desde texto.',
      en: 'AI presentation creator that automatically generates slides from text.',
      pt: 'Criador de apresentações com IA que gera slides automaticamente a partir de texto.',
      fr: 'Créateur de présentations IA qui génère automatiquement des slides à partir de texte.',
      de: 'KI-Präsentationsersteller, der automatisch Folien aus Text generiert.',
      it: 'Creatore di presentazioni AI che genera automaticamente slide da testo.',
      zh: '从文本自动生成幻灯片的AI演示文稿创建器。',
      ja: 'テキストから自動的にスライドを生成するAIプレゼンテーション作成ツール。',
      ko: '텍스트에서 자동으로 슬라이드를 생성하는 AI 프레젠테이션 제작 도구.',
      pl: 'Kreator prezentacji AI, który automatycznie generuje slajdy z tekstu.',
      ro: 'Creator de prezentări AI care generează automat slide-uri din text.'
    },
    url: 'https://www.chatslide.ai',
    category: 'Diseño',
    favicon: 'https://www.chatslide.ai/favicon.ico',
    tags: {
      es: ['Presentaciones', 'Slides automáticos', 'Texto', 'Creador'],
      en: ['Presentations', 'Automatic slides', 'Text', 'Creator'],
      pt: ['Apresentações', 'Slides automáticos', 'Texto', 'Criador'],
      fr: ['Présentations', 'Slides automatiques', 'Texte', 'Créateur'],
      de: ['Präsentationen', 'Automatische Folien', 'Text', 'Ersteller'],
      it: ['Presentazioni', 'Slide automatiche', 'Testo', 'Creatore'],
      zh: ['演示文稿', '自动幻灯片', '文本', '创建器'],
      ja: ['プレゼンテーション', '自動スライド', 'テキスト', 'クリエーター'],
      ko: ['프레젠테이션', '자동 슬라이드', '텍스트', '제작자'],
      pl: ['Prezentacje', 'Automatyczne slajdy', 'Tekst', 'Kreator'],
      ro: ['Prezentări', 'Slide-uri automate', 'Text', 'Creator']
    },
    rating: 4.3
  },
  {
    id: 'gamma',
    name: 'Gamma',
    description: {
      es: 'Creación de presentaciones, documentos y sitios web usando IA de forma automática.',
      en: 'Creation of presentations, documents and websites using AI automatically.',
      pt: 'Criação de apresentações, documentos e sites usando IA de forma automática.',
      fr: 'Création de présentations, documents et sites web utilisant l\'IA automatiquement.',
      de: 'Automatische Erstellung von Präsentationen, Dokumenten und Websites mit KI.',
      it: 'Creazione di presentazioni, documenti e siti web utilizzando AI automaticamente.',
      zh: '使用AI自动创建演示文稿、文档和网站。',
      ja: 'AIを使用してプレゼンテーション、文書、ウェブサイトを自動的に作成。',
      ko: 'AI를 사용하여 프레젠테이션, 문서 및 웹사이트를 자동으로 생성.',
      pl: 'Automatyczne tworzenie prezentacji, dokumentów i stron internetowych przy użyciu AI.',
      ro: 'Crearea automată de prezentări, documente și site-uri web folosind AI.'
    },
    url: 'https://gamma.app',
    category: 'Diseño',
    favicon: 'https://gamma.app/favicon.ico',
    tags: {
      es: ['Presentaciones', 'Documentos', 'Sitios web', 'Automática'],
      en: ['Presentations', 'Documents', 'Websites', 'Automatic'],
      pt: ['Apresentações', 'Documentos', 'Sites web', 'Automática'],
      fr: ['Présentations', 'Documents', 'Sites web', 'Automatique'],
      de: ['Präsentationen', 'Dokumente', 'Websites', 'Automatisch'],
      it: ['Presentazioni', 'Documenti', 'Siti web', 'Automatico'],
      zh: ['演示文稿', '文档', '网站', '自动'],
      ja: ['プレゼンテーション', '文書', 'ウェブサイト', '自動'],
      ko: ['프레젠테이션', '문서', '웹사이트', '자동'],
      pl: ['Prezentacje', 'Dokumenty', 'Strony internetowe', 'Automatyczny'],
      ro: ['Prezentări', 'Documente', 'Site-uri web', 'Automat']
    },
    rating: 4.5
  },
  {
    id: 'popai',
    name: 'PopAI',
    description: {
      es: 'Generador de presentaciones y contenido visual con inteligencia artificial.',
      en: 'Presentation and visual content generator with artificial intelligence.',
      pt: 'Gerador de apresentações e conteúdo visual com inteligência artificial.',
      fr: 'Générateur de présentations et contenu visuel avec intelligence artificielle.',
      de: 'Generator für Präsentationen und visuellen Content mit künstlicher Intelligenz.',
      it: 'Generatore di presentazioni e contenuti visivi con intelligenza artificiale.',
      zh: '具有人工智能的演示文稿和视觉内容生成器。',
      ja: '人工知能を使用したプレゼンテーションと視覚的コンテンツジェネレーター。',
      ko: '인공지능을 사용한 프레젠테이션 및 시각적 콘텐츠 생성기.',
      pl: 'Generator prezentacji i treści wizualnych ze sztuczną inteligencją.',
      ro: 'Generator de prezentări și conținut vizual cu inteligență artificială.'
    },
    url: 'https://www.popai.pro',
    category: 'Diseño',
    favicon: 'https://www.popai.pro/favicon.ico',
    tags: {
      es: ['Presentaciones', 'Contenido visual', 'Generador', 'Inteligencia artificial'],
      en: ['Presentations', 'Visual content', 'Generator', 'Artificial intelligence'],
      pt: ['Apresentações', 'Conteúdo visual', 'Gerador', 'Inteligência artificial'],
      fr: ['Présentations', 'Contenu visuel', 'Générateur', 'Intelligence artificielle'],
      de: ['Präsentationen', 'Visueller Content', 'Generator', 'Künstliche Intelligenz'],
      it: ['Presentazioni', 'Contenuto visivo', 'Generatore', 'Intelligenza artificiale'],
      zh: ['演示文稿', '视觉内容', '生成器', '人工智能'],
      ja: ['プレゼンテーション', '視覚的コンテンツ', 'ジェネレーター', '人工知能'],
      ko: ['프레젠테이션', '시각적 콘텐츠', '생성기', '인공지능'],
      pl: ['Prezentacje', 'Treść wizualna', 'Generator', 'Sztuczna inteligencja'],
      ro: ['Prezentări', 'Conținut vizual', 'Generator', 'Inteligență artificială']
    },
    rating: 4.2
  },
  {
    id: 'presenti',
    name: 'Presenti',
    description: {
      es: 'Asistente de IA para crear presentaciones profesionales de forma rápida y eficiente.',
      en: 'AI assistant to create professional presentations quickly and efficiently.',
      pt: 'Assistente de IA para criar apresentações profissionais de forma rápida e eficiente.',
      fr: 'Assistant IA pour créer des présentations professionnelles rapidement et efficacement.',
      de: 'KI-Assistent zur schnellen und effizienten Erstellung professioneller Präsentationen.',
      it: 'Assistente AI per creare presentazioni professionali in modo rapido ed efficiente.',
      zh: '快速高效创建专业演示文稿的AI助手。',
      ja: 'プロフェッショナルなプレゼンテーションを迅速かつ効率的に作成するAIアシスタント。',
      ko: '전문적인 프레젠테이션을 빠르고 효율적으로 만드는 AI 어시스턴트.',
      pl: 'Asystent AI do szybkiego i wydajnego tworzenia profesjonalnych prezentacji.',
      ro: 'Asistent AI pentru crearea rapidă și eficientă de prezentări profesionale.'
    },
    url: 'https://presenti.ai',
    category: 'Diseño',
    favicon: 'https://presenti.ai/favicon.ico',
    tags: {
      es: ['Presentaciones profesionales', 'Rápida', 'Eficiente', 'Asistente'],
      en: ['Professional presentations', 'Quick', 'Efficient', 'Assistant'],
      pt: ['Apresentações profissionais', 'Rápida', 'Eficiente', 'Assistente'],
      fr: ['Présentations professionnelles', 'Rapide', 'Efficace', 'Assistant'],
      de: ['Professionelle Präsentationen', 'Schnell', 'Effizient', 'Assistent'],
      it: ['Presentazioni professionali', 'Veloce', 'Efficiente', 'Assistente'],
      zh: ['专业演示', '快速', '高效', '助手'],
      ja: ['プロフェッショナルプレゼンテーション', '迅速', '効率的', 'アシスタント'],
      ko: ['전문 프레젠테이션', '빠른', '효율적', '어시스턴트'],
      pl: ['Profesjonalne prezentacje', 'Szybki', 'Wydajny', 'Asystent'],
      ro: ['Prezentări profesionale', 'Rapid', 'Eficient', 'Asistent']
    },
    rating: 4.1
  },
  {
    id: 'slidesgo',
    name: 'Slidesgo',
    description: {
      es: 'Plantillas de presentación gratuitas con herramientas de IA para personalización.',
      en: 'Free presentation templates with AI tools for customization.',
      pt: 'Modelos de apresentação gratuitos com ferramentas de IA para personalização.',
      fr: 'Modèles de présentation gratuits avec outils IA pour personnalisation.',
      de: 'Kostenlose Präsentationsvorlagen mit KI-Tools zur Anpassung.',
      it: 'Template di presentazione gratuiti con strumenti AI per personalizzazione.',
      zh: '具有AI定制工具的免费演示模板。',
      ja: 'カスタマイズのためのAIツールを備えた無料プレゼンテーションテンプレート。',
      ko: '맞춤화를 위한 AI 도구가 있는 무료 프레젠테이션 템플릿.',
      pl: 'Darmowe szablony prezentacji z narzędziami AI do personalizacji.',
      ro: 'Șabloane de prezentare gratuite cu instrumente AI pentru personalizare.'
    },
    url: 'https://slidesgo.com',
    category: 'Diseño',
    favicon: 'https://slidesgo.com/favicon.ico',
    tags: {
      es: ['Plantillas gratuitas', 'Personalización', 'Presentación', 'Herramientas'],
      en: ['Free templates', 'Customization', 'Presentation', 'Tools'],
      pt: ['Modelos gratuitos', 'Personalização', 'Apresentação', 'Ferramentas'],
      fr: ['Modèles gratuits', 'Personnalisation', 'Présentation', 'Outils'],
      de: ['Kostenlose Vorlagen', 'Anpassung', 'Präsentation', 'Werkzeuge'],
      it: ['Template gratuiti', 'Personalizzazione', 'Presentazione', 'Strumenti'],
      zh: ['免费模板', '定制', '演示', '工具'],
      ja: ['無料テンプレート', 'カスタマイズ', 'プレゼンテーション', 'ツール'],
      ko: ['무료 템플릿', '맞춤화', '프레젠테이션', '도구'],
      pl: ['Darmowe szablony', 'Personalizacja', 'Prezentacja', 'Narzędzia'],
      ro: ['Șabloane gratuite', 'Personalizare', 'Prezentare', 'Instrumente']
    },
    rating: 4.4
  },
  {
    id: 'vista-create',
    name: 'Vista Create',
    description: {
      es: 'Herramienta de diseño con IA para crear contenido visual para redes sociales y marketing.',
      en: 'AI design tool to create visual content for social media and marketing.',
      pt: 'Ferramenta de design com IA para criar conteúdo visual para redes sociais e marketing.',
      fr: 'Outil de design IA pour créer du contenu visuel pour les réseaux sociaux et le marketing.',
      de: 'KI-Design-Tool zur Erstellung visueller Inhalte für soziale Medien und Marketing.',
      it: 'Strumento di design AI per creare contenuti visivi per social media e marketing.',
      zh: '用于为社交媒体和营销创建视觉内容的AI设计工具。',
      ja: 'ソーシャルメディアとマーケティング用の視覚的コンテンツを作成するAIデザインツール。',
      ko: '소셜 미디어와 마케팅을 위한 시각적 콘텐츠를 만드는 AI 디자인 도구.',
      pl: 'Narzędzie projektowe AI do tworzenia treści wizualnych dla mediów społecznościowych i marketingu.',
      ro: 'Instrument de design AI pentru crearea de conținut vizual pentru rețelele sociale și marketing.'
    },
    url: 'https://create.vista.com',
    category: 'Diseño',
    favicon: 'https://create.vista.com/favicon.ico',
    tags: {
      es: ['Contenido visual', 'Redes sociales', 'Marketing', 'Diseño'],
      en: ['Visual content', 'Social media', 'Marketing', 'Design'],
      pt: ['Conteúdo visual', 'Redes sociais', 'Marketing', 'Design'],
      fr: ['Contenu visuel', 'Réseaux sociaux', 'Marketing', 'Design'],
      de: ['Visueller Content', 'Soziale Medien', 'Marketing', 'Design'],
      it: ['Contenuto visivo', 'Social media', 'Marketing', 'Design'],
      zh: ['视觉内容', '社交媒体', '营销', '设计'],
      ja: ['視覚的コンテンツ', 'ソーシャルメディア', 'マーケティング', 'デザイン'],
      ko: ['시각적 콘텐츠', '소셜 미디어', '마케팅', '디자인'],
      pl: ['Treść wizualna', 'Media społecznościowe', 'Marketing', 'Design'],
      ro: ['Conținut vizual', 'Rețele sociale', 'Marketing', 'Design']
    },
    rating: 4.3
  },

  // Generador de asistentes virtuales (6 recursos)
  {
    id: 'botpress',
    name: 'Botpress',
    description: {
      es: 'Plataforma open-source para construir asistentes virtuales inteligentes y chatbots empresariales.',
      en: 'Open-source platform to build intelligent virtual assistants and enterprise chatbots.',
      pt: 'Plataforma open-source para construir assistentes virtuais inteligentes e chatbots empresariais.',
      fr: 'Plateforme open-source pour construire des assistants virtuels intelligents et chatbots d\'entreprise.',
      de: 'Open-Source-Plattform zum Aufbau intelligenter virtueller Assistenten und Unternehmens-Chatbots.',
      it: 'Piattaforma open-source per costruire assistenti virtuali intelligenti e chatbot aziendali.',
      zh: '用于构建智能虚拟助手和企业聊天机器人的开源平台。',
      ja: 'インテリジェントな仮想アシスタントと企业チャットボットを構築するためのオープンソースプラットフォーム。',
      ko: '지능형 가상 어시스턴트와 기업 챗봇을 구축하기 위한 오픈소스 플랫폼.',
      pl: 'Platforma open-source do budowania inteligentnych asystentów wirtualnych i chatbotów korporacyjnych.',
      ro: 'Platformă open-source pentru construirea asistenților virtuali inteligenți și chatbots-urilor enterprise.'
    },
    url: 'https://botpress.com',
    category: 'Generador de asistentes virtuales',
    favicon: 'https://botpress.com/favicon.ico',
    tags: {
      es: ['Open source', 'Inteligentes', 'Empresariales', 'Construir'],
      en: ['Open source', 'Intelligent', 'Enterprise', 'Build'],
      pt: ['Open source', 'Inteligentes', 'Empresariais', 'Construir'],
      fr: ['Open source', 'Intelligents', 'Entreprise', 'Construire'],
      de: ['Open Source', 'Intelligent', 'Unternehmen', 'Aufbauen'],
      it: ['Open source', 'Intelligenti', 'Aziendali', 'Costruire'],
      zh: ['开源', '智能', '企业', '构建'],
      ja: ['オープンソース', 'インテリジェント', '企業', '構築'],
      ko: ['오픈소스', '지능형', '기업', '구축'],
      pl: ['Open source', 'Inteligentne', 'Korporacyjne', 'Budować'],
      ro: ['Open source', 'Inteligenți', 'Enterprise', 'Construi']
    },
    rating: 4.4
  },
  {
    id: 'charla',
    name: 'Charla',
    description: {
      es: 'Plataforma para crear chatbots conversacionales con IA para atención al cliente.',
      en: 'Platform to create conversational AI chatbots for customer service.',
      pt: 'Plataforma para criar chatbots conversacionais com IA para atendimento ao cliente.',
      fr: 'Plateforme pour créer des chatbots conversationnels IA pour service client.',
      de: 'Plattform zur Erstellung konversationeller KI-Chatbots für Kundenservice.',
      it: 'Piattaforma per creare chatbot conversazionali AI per servizio clienti.',
      zh: '用于创建客户服务对话式AI聊天机器人的平台。',
      ja: 'カスタマーサービス用の对话型AIチャットボットを作成するプラットフォーム。',
      ko: '고객 서비스를 위한 대화형 AI 챗봇을 만드는 플랫폼.',
      pl: 'Platforma do tworzenia konwersacyjnych chatbotów AI dla obsługi klienta.',
      ro: 'Platformă pentru crearea chatbot-urilor conversaționale AI pentru serviciul clienților.'
    },
    url: 'https://charla.com',
    category: 'Generador de asistentes virtuales',
    favicon: 'https://charla.com/favicon.ico',
    tags: {
      es: ['Chatbots conversacionales', 'Atención cliente', 'Plataforma', 'IA'],
      en: ['Conversational chatbots', 'Customer service', 'Platform', 'AI'],
      pt: ['Chatbots conversacionais', 'Atendimento cliente', 'Plataforma', 'IA'],
      fr: ['Chatbots conversationnels', 'Service client', 'Plateforme', 'IA'],
      de: ['Konversationelle Chatbots', 'Kundenservice', 'Plattform', 'KI'],
      it: ['Chatbot conversazionali', 'Servizio clienti', 'Piattaforma', 'IA'],
      zh: ['对话聊天机器人', '客户服务', '平台', 'AI'],
      ja: ['対話型チャットボット', 'カスタマーサービス', 'プラットフォーム', 'AI'],
      ko: ['대화형 챗봇', '고객 서비스', '플랫폼', 'AI'],
      pl: ['Konwersacyjne chatboty', 'Obsługa klienta', 'Platforma', 'AI'],
      ro: ['Chatbot-uri conversaționale', 'Serviciul clienților', 'Platformă', 'AI']
    },
    rating: 4.2
  },
  {
    id: 'chatbase',
    name: 'Chatbase',
    description: {
      es: 'Creador de chatbots con IA entrenados con datos personalizados para sitios web.',
      en: 'AI chatbot creator trained with custom data for websites.',
      pt: 'Criador de chatbots com IA treinados com dados personalizados para sites.',
      fr: 'Créateur de chatbots IA entraînés avec données personnalisées pour sites web.',
      de: 'KI-Chatbot-Ersteller, trainiert mit benutzerdefinierten Daten für Websites.',
      it: 'Creatore di chatbot AI addestrati con dati personalizzati per siti web.',
      zh: '使用自定义数据训练的网站AI聊天机器人创建器。',
      ja: 'ウェブサイト用のカスタムデータで訓練されたAIチャットボット作成ツール。',
      ko: '웹사이트용 맞춤 데이터로 훈련된 AI 챗봇 제작 도구.',
      pl: 'Kreator chatbotów AI wytrenowanych na niestandardowych danych dla stron internetowych.',
      ro: 'Creator de chatbot-uri AI antrenați cu date personalizate pentru site-uri web.'
    },
    url: 'https://www.chatbase.co',
    category: 'Generador de asistentes virtuales',
    favicon: 'https://www.chatbase.co/favicon.ico',
    tags: {
      es: ['Datos personalizados', 'Sitios web', 'Creador chatbots', 'Entrenados'],
      en: ['Custom data', 'Websites', 'Chatbot creator', 'Trained'],
      pt: ['Dados personalizados', 'Sites web', 'Criador chatbots', 'Treinados'],
      fr: ['Données personnalisées', 'Sites web', 'Créateur chatbots', 'Entraînés'],
      de: ['Benutzerdefinierte Daten', 'Websites', 'Chatbot-Ersteller', 'Trainiert'],
      it: ['Dati personalizzati', 'Siti web', 'Creatore chatbot', 'Addestrati'],
      zh: ['自定义数据', '网站', '聊天机器人创建器', '训练'],
      ja: ['カスタムデータ', 'ウェブサイト', 'チャットボット作成ツール', '訓練済み'],
      ko: ['맞춤 데이터', '웹사이트', '챗봇 제작 도구', '훈련됨'],
      pl: ['Niestandardowe dane', 'Strony internetowe', 'Kreator chatbotów', 'Wytrenowane'],
      ro: ['Date personalizate', 'Site-uri web', 'Creator chatbot', 'Antrenați']
    },
    rating: 4.3
  },
  {
    id: 'cxgenie',
    name: 'CX Genie',
    description: {
      es: 'Plataforma de IA para crear asistentes virtuales de experiencia del cliente.',
      en: 'AI platform to create customer experience virtual assistants.',
      pt: 'Plataforma de IA para criar assistentes virtuais de experiência do cliente.',
      fr: 'Plateforme IA pour créer des assistants virtuels d\'expérience client.',
      de: 'KI-Plattform zur Erstellung virtueller Assistenten für Kundenerfahrung.',
      it: 'Piattaforma AI per creare assistenti virtuali dell\'esperienza cliente.',
      zh: '用于创建客户体验虚拟助手的AI平台。',
      ja: 'カスタマーエクスペリエンス仮想アシスタントを作成するためのAIプラットフォーム。',
      ko: '고객 경험 가상 어시스턴트를 만들기 위한 AI 플랫폼.',
      pl: 'Platforma AI do tworzenia wirtualnych asystentów doświadczenia klienta.',
      ro: 'Platformă AI pentru crearea asistenților virtuali de experiență client.'
    },
    url: 'https://www.cxgenie.ai',
    category: 'Generador de asistentes virtuales',
    favicon: 'https://www.cxgenie.ai/favicon.ico',
    tags: {
      es: ['Experiencia cliente', 'Asistentes virtuales', 'Plataforma', 'CX'],
      en: ['Customer experience', 'Virtual assistants', 'Platform', 'CX'],
      pt: ['Experiência cliente', 'Assistentes virtuais', 'Plataforma', 'CX'],
      fr: ['Expérience client', 'Assistants virtuels', 'Plateforme', 'CX'],
      de: ['Kundenerfahrung', 'Virtuelle Assistenten', 'Plattform', 'CX'],
      it: ['Esperienza cliente', 'Assistenti virtuali', 'Piattaforma', 'CX'],
      zh: ['客户体验', '虚拟助手', '平台', 'CX'],
      ja: ['カスタマーエクスペリエンス', '仮想アシスタント', 'プラットフォーム', 'CX'],
      ko: ['고객 경험', '가상 어시스턴트', '플랫폼', 'CX'],
      pl: ['Doświadczenie klienta', 'Wirtualni asystenci', 'Platforma', 'CX'],
      ro: ['Experiența clientului', 'Asistenți virtuali', 'Platformă', 'CX']
    },
    rating: 4.1
  },
  {
    id: 'dialogflow',
    name: 'Dialogflow',
    description: {
      es: 'Plataforma de Google para crear interfaces conversacionales y asistentes virtuales.',
      en: 'Google platform to create conversational interfaces and virtual assistants.',
      pt: 'Plataforma do Google para criar interfaces conversacionais e assistentes virtuais.',
      fr: 'Plateforme Google pour créer des interfaces conversationnelles et assistants virtuels.',
      de: 'Google-Plattform zur Erstellung konversationeller Schnittstellen und virtueller Assistenten.',
      it: 'Piattaforma Google per creare interfacce conversazionali e assistenti virtuali.',
      zh: '谷歌平台，用于创建对话界面和虚拟助手。',
      ja: '対話インターフェースと仮想アシスタントを作成するためのGoogleプラットフォーム。',
      ko: '대화형 인터페이스와 가상 어시스턴트를 만들기 위한 Google 플랫폼.',
      pl: 'Platforma Google do tworzenia interfejsów konwersacyjnych i wirtualnych asystentów.',
      ro: 'Platformă Google pentru crearea interfețelor conversaționale și asistenților virtuali.'
    },
    url: 'https://dialogflow.cloud.google.com',
    category: 'Generador de asistentes virtuales',
    favicon: 'https://dialogflow.cloud.google.com/favicon.ico',
    tags: {
      es: ['Google', 'Interfaces conversacionales', 'Asistentes virtuales', 'Plataforma'],
      en: ['Google', 'Conversational interfaces', 'Virtual assistants', 'Platform'],
      pt: ['Google', 'Interfaces conversacionais', 'Assistentes virtuais', 'Plataforma'],
      fr: ['Google', 'Interfaces conversationnelles', 'Assistants virtuels', 'Plateforme'],
      de: ['Google', 'Konversationelle Schnittstellen', 'Virtuelle Assistenten', 'Plattform'],
      it: ['Google', 'Interfacce conversazionali', 'Assistenti virtuali', 'Piattaforma'],
      zh: ['谷歌', '对话界面', '虚拟助手', '平台'],
      ja: ['Google', '対話インターフェース', '仮想アシスタント', 'プラットフォーム'],
      ko: ['구글', '대화형 인터페이스', '가상 어시스턴트', '플랫폼'],
      pl: ['Google', 'Interfejsy konwersacyjne', 'Wirtualni asystenci', 'Platforma'],
      ro: ['Google', 'Interfețe conversaționale', 'Asistenți virtuali', 'Platformă']
    },
    rating: 4.5
  },
  {
    id: 'landbot',
    name: 'Landbot',
    description: {
      es: 'Constructor de chatbots conversacionales con IA para generar leads y automatizar conversaciones.',
      en: 'Conversational chatbot builder with AI for lead generation and conversation automation.',
      pt: 'Construtor de chatbots conversacionais com IA para geração de leads e automação de conversas.',
      fr: 'Constructeur de chatbots conversationnels avec IA pour génération de leads et automatisation des conversations.',
      de: 'Konversationeller Chatbot-Builder mit KI für Lead-Generierung und Gesprächsautomatisierung.',
      it: 'Costruttore di chatbot conversazionali con AI per generazione lead e automazione conversazioni.',
      zh: '具有AI功能的对话聊天机器人构建器，用于潜在客户生成和对话自动化。',
      ja: 'リード生成と会話自動化のためのAIを备えた対話型チャットボットビルダー。',
      ko: '리드 생성과 대화 자동화를 위한 AI 기반 대화형 챗봇 빌더.',
      pl: 'Konstruktor konwersacyjnych chatbotów z AI do generowania leadów i automatyzacji rozmów.',
      ro: 'Constructor de chatbot-uri conversaționale cu AI pentru generarea lead-urilor și automatizarea conversațiilor.'
    },
    url: 'https://landbot.io',
    category: 'Generador de asistentes virtuales',
    favicon: 'https://landbot.io/favicon.ico',
    tags: {
      es: ['Constructor', 'Generar leads', 'Automatizar', 'Conversaciones'],
      en: ['Builder', 'Lead generation', 'Automate', 'Conversations'],
      pt: ['Construtor', 'Geração leads', 'Automatizar', 'Conversas'],
      fr: ['Constructeur', 'Génération leads', 'Automatiser', 'Conversations'],
      de: ['Builder', 'Lead-Generierung', 'Automatisieren', 'Gespräche'],
      it: ['Costruttore', 'Generazione lead', 'Automatizzare', 'Conversazioni'],
      zh: ['构建器', '潜在客户生成', '自动化', '对话'],
      ja: ['ビルダー', 'リード生成', '自動化', '会話'],
      ko: ['빌더', '리드 생성', '자동화', '대화'],
      pl: ['Konstruktor', 'Generowanie leadów', 'Automatyzować', 'Rozmowy'],
      ro: ['Constructor', 'Generare lead-uri', 'Automatiza', 'Conversații']
    },
    rating: 4.1
  },

  // Detector de contenidos de IA (5 recursos)
  {
    id: 'copyleaks',
    name: 'Copyleaks',
    description: {
      es: 'Plataforma de detección de plagio y contenido de IA para instituciones educativas y empresas.',
      en: 'Plagiarism and AI content detection platform for educational institutions and businesses.',
      pt: 'Plataforma de detecção de plágio e conteúdo de IA para instituições educacionais e empresas.',
      fr: 'Plateforme de détection de plagiat et contenu IA pour institutions éducatives et entreprises.',
      de: 'Plagiat- und KI-Inhaltserkennung für Bildungseinrichtungen und Unternehmen.',
      it: 'Piattaforma di rilevamento plagio e contenuti AI per istituzioni educative e aziende.',
      zh: '面向教育机构和企业的抄袭和AI内容检测平台。',
      ja: '教育機関と企業向けの盗作とAIコンテンツ検出プラットフォーム。',
      ko: '교육 기관과 기업을 위한 표절 및 AI 콘텐츠 감지 플랫폼.',
      pl: 'Platforma wykrywania plagiatu i treści AI dla instytucji edukacyjnych i firm.',
      ro: 'Platformă de detectare a plagiatului și conținutului AI pentru instituții educaționale și companii.'
    },
    url: 'https://copyleaks.com',
    category: 'Detector de contenidos de IA',
    favicon: 'https://copyleaks.com/favicon.ico',
    tags: {
      es: ['Plagio', 'Instituciones educativas', 'Empresas', 'Plataforma'],
      en: ['Plagiarism', 'Educational institutions', 'Businesses', 'Platform'],
      pt: ['Plágio', 'Instituições educacionais', 'Empresas', 'Plataforma'],
      fr: ['Plagiat', 'Institutions éducatives', 'Entreprises', 'Plateforme'],
      de: ['Plagiat', 'Bildungseinrichtungen', 'Unternehmen', 'Plattform'],
      it: ['Plagio', 'Istituzioni educative', 'Aziende', 'Piattaforma'],
      zh: ['抄袭', '教育机构', '企业', '平台'],
      ja: ['盗作', '教育機関', '企業', 'プラットフォーム'],
      ko: ['표절', '교육 기관', '기업', '플랫폼'],
      pl: ['Plagiat', 'Instytucje edukacyjne', 'Firmy', 'Platforma'],
      ro: ['Plagiat', 'Instituții educaționale', 'Companii', 'Platformă']
    },
    rating: 4.3
  },
  {
    id: 'corrector-app',
    name: 'Corrector App',
    description: {
      es: 'Detector de contenido generado por IA con análisis detallado y verificación de autenticidad.',
      en: 'AI-generated content detector with detailed analysis and authenticity verification.',
      pt: 'Detector de conteúdo gerado por IA com análise detalhada e verificação de autenticidade.',
      fr: 'Détecteur de contenu généré par IA avec analyse détaillée et vérification d\'authenticité.',
      de: 'KI-generierter Inhaltsdetektor mit detaillierter Analyse und Authentizitätsprüfung.',
      it: 'Rilevatore di contenuti generati da AI con analisi dettagliata e verifica di autenticità.',
      zh: 'AI生成内容检测器，具有详细分析和真实性验证功能。',
      ja: '詳細な分析と真正性検証機能を備えたAI生成コンテンツ検出器。',
      ko: '상세한 분석과 진위 검증 기능을 갖춘 AI 생성 콘텐츠 감지기.',
      pl: 'Detektor treści generowanych przez AI z szczegółową analizą i weryfikacją autentyczności.',
      ro: 'Detector de conținut generat de AI cu analiză detaliată și verificarea autenticității.'
    },
    url: 'https://corrector.app/es/detector-contenido-ia',
    category: 'Detector de contenidos de IA',
    favicon: 'https://corrector.app/favicon.ico',
    tags: {
      es: ['Análisis detallado', 'Verificación autenticidad', 'Detector', 'Contenido IA'],
      en: ['Detailed analysis', 'Authenticity verification', 'Detector', 'AI content'],
      pt: ['Análise detalhada', 'Verificação autenticidade', 'Detector', 'Conteúdo IA'],
      fr: ['Analyse détaillée', 'Vérification authenticité', 'Détecteur', 'Contenu IA'],
      de: ['Detaillierte Analyse', 'Authentizitätsprüfung', 'Detektor', 'KI-Inhalt'],
      it: ['Analisi dettagliata', 'Verifica autenticità', 'Rilevatore', 'Contenuto AI'],
      zh: ['详细分析', '真实性验证', '检测器', 'AI内容'],
      ja: ['詳細分析', '真正性検証', '検出器', 'AIコンテンツ'],
      ko: ['상세 분석', '진위 검증', '감지기', 'AI 콘텐츠'],
      pl: ['Szczegółowa analiza', 'Weryfikacja autentyczności', 'Detektor', 'Treść AI'],
      ro: ['Analiză detaliată', 'Verificare autenticitate', 'Detector', 'Conținut AI']
    },
    rating: 4.2
  },
  {
    id: 'gptzero',
    name: 'GPTZero',
    description: {
      es: 'Detector de contenido generado por IA que identifica texto escrito por modelos de lenguaje.',
      en: 'AI-generated content detector that identifies text written by language models.',
      pt: 'Detector de conteúdo gerado por IA que identifica texto escrito por modelos de linguagem.',
      fr: 'Détecteur de contenu généré par IA qui identifie le texte écrit par des modèles de langage.',
      de: 'KI-generierter Inhaltsdetektor, der von Sprachmodellen geschriebenen Text identifiziert.',
      it: 'Rilevatore di contenuti generati da AI che identifica testo scritto da modelli linguistici.',
      zh: 'AI生成内容检测器，识别语言模型编写的文本。',
      ja: '言語モデルによって書かれたテキストを識別するAI生成コンテンツ検出器。',
      ko: '언어 모델이 작성한 텍스트를 식별하는 AI 생성 콘텐츠 감지기.',
      pl: 'Detektor treści generowanych przez AI, który identyfikuje tekst napisany przez modele językowe.',
      ro: 'Detector de conținut generat de AI care identifică textul scris de modelele de limbaj.'
    },
    url: 'https://gptzero.me',
    category: 'Detector de contenidos de IA',
    favicon: 'https://gptzero.me/favicon.ico',
    tags: {
      es: ['Detector', 'Contenido IA', 'Modelos lenguaje', 'Identificar'],
      en: ['Detector', 'AI content', 'Language models', 'Identify'],
      pt: ['Detector', 'Conteúdo IA', 'Modelos linguagem', 'Identificar'],
      fr: ['Détecteur', 'Contenu IA', 'Modèles langage', 'Identifier'],
      de: ['Detektor', 'KI-Inhalt', 'Sprachmodelle', 'Identifizieren'],
      it: ['Rilevatore', 'Contenuto AI', 'Modelli linguistici', 'Identificare'],
      zh: ['检测器', 'AI内容', '语言模型', '识别'],
      ja: ['検出器', 'AIコンテンツ', '言語モデル', '識別'],
      ko: ['감지기', 'AI 콘텐츠', '언어 모델', '식별'],
      pl: ['Detektor', 'Treść AI', 'Modele językowe', 'Identyfikować'],
      ro: ['Detector', 'Conținut AI', 'Modele limbaj', 'Identifica']
    },
    rating: 4.6
  },
  {
    id: 'merlin-detector',
    name: 'Merlin AI Detector',
    description: {
      es: 'Herramienta de detección de contenido de IA con alta precisión y análisis multiidioma.',
      en: 'AI content detection tool with high precision and multilingual analysis.',
      pt: 'Ferramenta de detecção de conteúdo de IA com alta precisão e análise multilíngue.',
      fr: 'Outil de détection de contenu IA avec haute précision et analyse multilingue.',
      de: 'KI-Inhaltserkennung mit hoher Präzision und mehrsprachiger Analyse.',
      it: 'Strumento di rilevamento contenuti AI con alta precisione e analisi multilingue.',
      zh: '具有高精度和多语言分析的AI内容检测工具。',
      ja: '高精度と多言語分析を备えたAIコンテンツ検出ツール。',
      ko: '고정밀도와 다국어 분석을 갖춘 AI 콘텐츠 감지 도구.',
      pl: 'Narzędzie wykrywania treści AI o wysokiej precyzji i analizie wielojęzycznej.',
      ro: 'Instrument de detectare conținut AI cu precizie înaltă și analiză multilingvă.'
    },
    url: 'https://www.getmerlin.in/es/ai-detection',
    category: 'Detector de contenidos de IA',
    favicon: 'https://www.getmerlin.in/favicon.ico',
    tags: {
      es: ['Alta precisión', 'Multiidioma', 'Análisis', 'Detección'],
      en: ['High precision', 'Multilingual', 'Analysis', 'Detection'],
      pt: ['Alta precisão', 'Multilíngue', 'Análise', 'Detecção'],
      fr: ['Haute précision', 'Multilingue', 'Analyse', 'Détection'],
      de: ['Hohe Präzision', 'Mehrsprachig', 'Analyse', 'Erkennung'],
      it: ['Alta precisione', 'Multilingue', 'Analisi', 'Rilevamento'],
      zh: ['高精度', '多语言', '分析', '检测'],
      ja: ['高精度', '多言語', '分析', '検出'],
      ko: ['고정밀도', '다국어', '분석', '감지'],
      pl: ['Wysoka precyzja', 'Wielojęzyczny', 'Analiza', 'Wykrywanie'],
      ro: ['Precizie înaltă', 'Multilingv', 'Analiză', 'Detectare']
    },
    rating: 4.4
  },
  {
    id: 'zerogpt',
    name: 'ZeroGPT',
    description: {
      es: 'Detector gratuito de texto generado por IA con análisis rápido y resultados precisos.',
      en: 'Free AI-generated text detector with fast analysis and accurate results.',
      pt: 'Detector gratuito de texto gerado por IA com análise rápida e resultados precisos.',
      fr: 'Détecteur gratuit de texte généré par IA avec analyse rapide et résultats précis.',
      de: 'Kostenloser KI-generierter Textdetektor mit schneller Analyse und präzisen Ergebnissen.',
      it: 'Rilevatore gratuito di testo generato da AI con analisi rapida e risultati precisi.',
      zh: '免费的AI生成文本检测器，具有快速分析和准确结果。',
      ja: '高速分析と正確な結果を提供する無料のAI生成テキスト検出器。',
      ko: '빠른 분석과 정확한 결과를 제공하는 무료 AI 생성 텍스트 감지기.',
      pl: 'Darmowy detektor tekstu generowanego przez AI z szybką analizą i dokładnymi wynikami.',
      ro: 'Detector gratuit de text generat de AI cu analiză rapidă și rezultate precise.'
    },
    url: 'https://www.zerogpt.com',
    category: 'Detector de contenidos de IA',
    favicon: 'https://www.zerogpt.com/favicon.ico',
    tags: {
      es: ['Gratuito', 'Análisis rápido', 'Resultados precisos', 'Texto generado'],
      en: ['Free', 'Fast analysis', 'Accurate results', 'Generated text'],
      pt: ['Gratuito', 'Análise rápida', 'Resultados precisos', 'Texto gerado'],
      fr: ['Gratuit', 'Analyse rapide', 'Résultats précis', 'Texte généré'],
      de: ['Kostenlos', 'Schnelle Analyse', 'Präzise Ergebnisse', 'Generierter Text'],
      it: ['Gratuito', 'Analisi rapida', 'Risultati precisi', 'Testo generato'],
      zh: ['免费', '快速分析', '准确结果', '生成文本'],
      ja: ['無料', '高速分析', '正確な結果', '生成テキスト'],
      ko: ['무료', '빠른 분석', '정확한 결과', '생성된 텍스트'],
      pl: ['Darmowy', 'Szybka analiza', 'Dokładne wyniki', 'Generowany tekst'],
      ro: ['Gratuit', 'Analiză rapidă', 'Rezultate precise', 'Text generat']
    },
    rating: 4.3
  },

  // Música (5 recursos)
  {
    id: 'aiva',
    name: 'AIVA',
    description: {
      es: 'Compositor de música clásica y cinematográfica usando inteligencia artificial.',
      en: 'Classical and cinematic music composer using artificial intelligence.',
      pt: 'Compositor de música clássica e cinematográfica usando inteligência artificial.',
      fr: 'Compositeur de musique classique et cinématographique utilisant l\'intelligence artificielle.',
      de: 'Klassischer und Filmmusik-Komponist mit künstlicher Intelligenz.',
      it: 'Compositore di musica classica e cinematografica utilizzando intelligenza artificiale.',
      zh: '使用人工智能的古典和电影音乐作曲家。',
      ja: '人工知能を使用したクラシックと映画音楽の作曲家。',
      ko: '인공지능을 사용한 클래식 및 영화 음악 작곡가.',
      pl: 'Kompozytor muzyki klasycznej i filmowej wykorzystujący sztuczną inteligencję.',
      ro: 'Compozitor de muzică clasică și cinematografică folosind inteligența artificială.'
    },
    url: 'https://www.aiva.ai',
    category: 'Música',
    favicon: 'https://www.aiva.ai/favicon.ico',
    tags: {
      es: ['Música clásica', 'Cinematográfica', 'Compositor', 'IA'],
      en: ['Classical music', 'Cinematic', 'Composer', 'AI'],
      pt: ['Música clássica', 'Cinematográfica', 'Compositor', 'IA'],
      fr: ['Musique classique', 'Cinématographique', 'Compositeur', 'IA'],
      de: ['Klassische Musik', 'Filmmusik', 'Komponist', 'KI'],
      it: ['Musica classica', 'Cinematografica', 'Compositore', 'IA'],
      zh: ['古典音乐', '电影', '作曲家', 'AI'],
      ja: ['クラシック音楽', '映画', '作曲家', 'AI'],
      ko: ['클래식 음악', '영화', '작곡가', 'AI'],
      pl: ['Muzyka klasyczna', 'Filmowa', 'Kompozytor', 'AI'],
      ro: ['Muzică clasică', 'Cinematografică', 'Compozitor', 'AI']
    },
    rating: 4.5
  },
  {
    id: 'beatoven',
    name: 'Beatoven',
    description: {
      es: 'Generador de música personalizada con IA para videos, podcasts y contenido multimedia.',
      en: 'AI custom music generator for videos, podcasts and multimedia content.',
      pt: 'Gerador de música personalizada com IA para vídeos, podcasts e conteúdo multimídia.',
      fr: 'Générateur de musique personnalisée IA pour vidéos, podcasts et contenu multimédia.',
      de: 'KI-personalisierter Musikgenerator für Videos, Podcasts und Multimedia-Inhalte.',
      it: 'Generatore di musica personalizzata AI per video, podcast e contenuti multimediali.',
      zh: '用于视频、播客和多媒体内容的AI定制音乐生成器。',
      ja: 'ビデオ、ポッドキャスト、マルチメディアコンテンツ用のAIカスタム音楽ジェネレーター。',
      ko: '비디오, 팟캐스트 및 멀티미디어 콘텐츠용 AI 맞춤 음악 생성기.',
      pl: 'Generator spersonalizowanej muzyki AI dla filmów, podcastów i treści multimedialnych.',
      ro: 'Generator de muzică personalizată AI pentru videoclipuri, podcast-uri și conținut multimedia.'
    },
    url: 'https://www.beatoven.ai',
    category: 'Música',
    favicon: 'https://www.beatoven.ai/favicon.ico',
    tags: {
      es: ['Música personalizada', 'Videos', 'Podcasts', 'Multimedia'],
      en: ['Custom music', 'Videos', 'Podcasts', 'Multimedia'],
      pt: ['Música personalizada', 'Vídeos', 'Podcasts', 'Multimídia'],
      fr: ['Musique personnalisée', 'Vidéos', 'Podcasts', 'Multimédia'],
      de: ['Personalisierte Musik', 'Videos', 'Podcasts', 'Multimedia'],
      it: ['Musica personalizzata', 'Video', 'Podcast', 'Multimediale'],
      zh: ['定制音乐', '视频', '播客', '多媒体'],
      ja: ['カスタム音楽', 'ビデオ', 'ポッドキャスト', 'マルチメディア'],
      ko: ['맞춤 음악', '비디오', '팟캐스트', '멀티미디어'],
      pl: ['Spersonalizowana muzyka', 'Filmy', 'Podcasty', 'Multimedia'],
      ro: ['Muzică personalizată', 'Videoclipuri', 'Podcast-uri', 'Multimedia']
    },
    rating: 4.3
  },
  {
    id: 'loudly',
    name: 'Loudly',
    description: {
      es: 'Plataforma de música generada por IA para creadores de contenido y profesionales.',
      en: 'AI-generated music platform for content creators and professionals.',
      pt: 'Plataforma de música gerada por IA para criadores de conteúdo e profissionais.',
      fr: 'Plateforme de musique générée par IA pour créateurs de contenu et professionnels.',
      de: 'KI-generierte Musikplattform für Content-Ersteller und Profis.',
      it: 'Piattaforma di musica generata da AI per creatori di contenuti e professionisti.',
      zh: '面向内容创作者和专业人士的AI生成音乐平台。',
      ja: 'コンテンツクリエーターとプロフェッショナル向けのAI生成音楽プラットフォーム。',
      ko: '콘텐츠 제작자와 전문가를 위한 AI 생성 음악 플랫폼.',
      pl: 'Platforma muzyki generowanej przez AI dla twórców treści i profesjonalistów.',
      ro: 'Platformă de muzică generată de AI pentru creatorii de conținut și profesioniști.'
    },
    url: 'https://www.loudly.com',
    category: 'Música',
    favicon: 'https://www.loudly.com/favicon.ico',
    tags: {
      es: ['Creadores contenido', 'Profesionales', 'Plataforma', 'Música generada'],
      en: ['Content creators', 'Professionals', 'Platform', 'Generated music'],
      pt: ['Criadores conteúdo', 'Profissionais', 'Plataforma', 'Música gerada'],
      fr: ['Créateurs contenu', 'Professionnels', 'Plateforme', 'Musique générée'],
      de: ['Content-Ersteller', 'Profis', 'Plattform', 'Generierte Musik'],
      it: ['Creatori contenuti', 'Professionisti', 'Piattaforma', 'Musica generata'],
      zh: ['内容创作者', '专业人士', '平台', '生成音乐'],
      ja: ['コンテンツクリエーター', 'プロフェッショナル', 'プラットフォーム', '生成音楽'],
      ko: ['콘텐츠 제작자', '전문가', '플랫폼', '생성 음악'],
      pl: ['Twórcy treści', 'Profesjonaliści', 'Platforma', 'Generowana muzyka'],
      ro: ['Creatori conținut', 'Profesioniști', 'Platformă', 'Muzică generată']
    },
    rating: 4.4
  },
  {
    id: 'soundverse',
    name: 'Soundverse',
    description: {
      es: 'Asistente de IA para producción musical con generación de beats, melodías y efectos.',
      en: 'AI assistant for music production with generation of beats, melodies and effects.',
      pt: 'Assistente de IA para produção musical com geração de beats, melodias e efeitos.',
      fr: 'Assistant IA pour production musicale avec génération de beats, mélodies et effets.',
      de: 'KI-Assistent für Musikproduktion mit Generierung von Beats, Melodien und Effekten.',
      it: 'Assistente AI per produzione musicale con generazione di beat, melodie ed effetti.',
      zh: '用于音乐制作的AI助手，可生成节拍、旋律和效果。',
      ja: 'ビート、メロディ、エフェクトの生成を備えた音楽制作用AIアシスタント。',
      ko: '비트, 멜로디 및 효과 생성 기능을 갖춘 음악 제작용 AI 어시스턴트.',
      pl: 'Asystent AI do produkcji muzycznej z generowaniem beatów, melodii i efektów.',
      ro: 'Asistent AI pentru producția muzicală cu generarea de beat-uri, melodii și efecte.'
    },
    url: 'https://www.soundverse.ai',
    category: 'Música',
    favicon: 'https://www.soundverse.ai/favicon.ico',
    tags: {
      es: ['Producción musical', 'Beats', 'Melodías', 'Efectos'],
      en: ['Music production', 'Beats', 'Melodies', 'Effects'],
      pt: ['Produção musical', 'Beats', 'Melodias', 'Efeitos'],
      fr: ['Production musicale', 'Beats', 'Mélodies', 'Effets'],
      de: ['Musikproduktion', 'Beats', 'Melodien', 'Effekte'],
      it: ['Produzione musicale', 'Beat', 'Melodie', 'Effetti'],
      zh: ['音乐制作', '节拍', '旋律', '效果'],
      ja: ['音楽制作', 'ビート', 'メロディ', 'エフェクト'],
      ko: ['음악 제작', '비트', '멜로디', '효과'],
      pl: ['Produkcja muzyczna', 'Beaty', 'Melodie', 'Efekty'],
      ro: ['Producție muzicală', 'Beat-uri', 'Melodii', 'Efecte']
    },
    rating: 4.2
  },
  {
    id: 'suno',
    name: 'Suno',
    description: {
      es: 'Creación de canciones completas con letras y música a partir de prompts de texto.',
      en: 'Complete song creation with lyrics and music from text prompts.',
      pt: 'Criação de músicas completas com letras e música a partir de prompts de texto.',
      fr: 'Création de chansons complètes avec paroles et musique à partir de prompts texte.',
      de: 'Vollständige Liedkomposition mit Texten und Musik aus Text-Prompts.',
      it: 'Creazione di canzoni complete con testi e musica da prompt testuali.',
      zh: '根据文本提示创建包含歌词和音乐的完整歌曲。',
      ja: 'テキストプロンプトから歌詞と音楽を含む完全な楽曲作成。',
      ko: '텍스트 프롬프트에서 가사와 음악이 포함된 완전한 노래 제작.',
      pl: 'Tworzenie kompletnych piosenek z tekstami i muzyką z promptów tekstowych.',
      ro: 'Crearea de cântece complete cu versuri și muzică din prompturi text.'
    },
    url: 'https://suno.com',
    category: 'Música',
    favicon: 'https://suno.com/favicon.ico',
    tags: {
      es: ['Canciones', 'Letras', 'Música completa', 'Prompts'],
      en: ['Songs', 'Lyrics', 'Complete music', 'Prompts'],
      pt: ['Músicas', 'Letras', 'Música completa', 'Prompts'],
      fr: ['Chansons', 'Paroles', 'Musique complète', 'Prompts'],
      de: ['Lieder', 'Texte', 'Vollständige Musik', 'Prompts'],
      it: ['Canzoni', 'Testi', 'Musica completa', 'Prompt'],
      zh: ['歌曲', '歌词', '完整音乐', '提示'],
      ja: ['楽曲', '歌詞', '完全な音楽', 'プロンプト'],
      ko: ['노래', '가사', '완전한 음악', '프롬프트'],
      pl: ['Piosenki', 'Teksty', 'Kompletna muzyka', 'Prompty'],
      ro: ['Cântece', 'Versuri', 'Muzică completă', 'Prompturi']
    },
    rating: 4.8
  },

  // Motores de búsqueda (5 recursos)
  {
    id: 'andi-search',
    name: 'Andi Search',
    description: {
      es: 'Motor de búsqueda conversacional con IA que proporciona respuestas directas y contextuales.',
      en: 'Conversational AI search engine that provides direct and contextual answers.',
      pt: 'Motor de busca conversacional com IA que fornece respostas diretas e contextuais.',
      fr: 'Moteur de recherche conversationnel IA qui fournit des réponses directes et contextuelles.',
      de: 'Konversationelle KI-Suchmaschine, die direkte und kontextuelle Antworten liefert.',
      it: 'Motore di ricerca conversazionale AI che fornisce risposte dirette e contestuali.',
      zh: '提供直接和上下文答案的对话式AI搜索引擎。',
      ja: '直接的で文脈に沿った回答を提供する对话型AI検索エンジン。',
      ko: '직접적이고 맥락적인 답변을 제공하는 대화형 AI 검색 엔진.',
      pl: 'Konwersacyjna wyszukiwarka AI, która dostarcza bezpośrednie i kontekstowe odpowiedzi.',
      ro: 'Motor de căutare conversațional AI care oferă răspunsuri directe și contextuale.'
    },
    url: 'https://andisearch.com',
    category: 'Motores de búsqueda',
    favicon: 'https://andisearch.com/favicon.ico',
    tags: {
      es: ['Conversacional', 'Respuestas directas', 'Contextuales', 'Motor búsqueda'],
      en: ['Conversational', 'Direct answers', 'Contextual', 'Search engine'],
      pt: ['Conversacional', 'Respostas diretas', 'Contextuais', 'Motor busca'],
      fr: ['Conversationnel', 'Réponses directes', 'Contextuelles', 'Moteur recherche'],
      de: ['Konversationell', 'Direkte Antworten', 'Kontextuell', 'Suchmaschine'],
      it: ['Conversazionale', 'Risposte dirette', 'Contestuali', 'Motore ricerca'],
      zh: ['对话式', '直接答案', '上下文', '搜索引擎'],
      ja: ['対話型', '直接回答', '文脈的', '検索エンジン'],
      ko: ['대화형', '직접 답변', '맥락적', '검색 엔진'],
      pl: ['Konwersacyjny', 'Bezpośrednie odpowiedzi', 'Kontekstowe', 'Wyszukiwarka'],
      ro: ['Conversațional', 'Răspunsuri directe', 'Contextuale', 'Motor căutare']
    },
    rating: 4.2
  },
  {
    id: 'deepai-search',
    name: 'DeepAI Search',
    description: {
      es: 'Motor de búsqueda especializado en contenido de inteligencia artificial y tecnología.',
      en: 'Search engine specialized in artificial intelligence and technology content.',
      pt: 'Motor de busca especializado em conteúdo de inteligência artificial e tecnologia.',
      fr: 'Moteur de recherche spécialisé dans le contenu d\'intelligence artificielle et technologie.',
      de: 'Suchmaschine spezialisiert auf künstliche Intelligenz und Technologie-Inhalte.',
      it: 'Motore di ricerca specializzato in contenuti di intelligenza artificiale e tecnologia.',
      zh: '专门从事人工智能和技术内容的搜索引擎。',
      ja: '人工知能と技術コンテンツに特化した検索エンジン。',
      ko: '인공지능과 기술 콘텐츠에 특화된 검색 엔진.',
      pl: 'Wyszukiwarka wyspecjalizowana w treściach sztucznej inteligencji i technologii.',
      ro: 'Motor de căutare specializat în conținut de inteligență artificială și tehnologie.'
    },
    url: 'https://deepai.org',
    category: 'Motores de búsqueda',
    favicon: 'https://deepai.org/favicon.ico',
    tags: {
      es: ['Especializado', 'Inteligencia artificial', 'Tecnología', 'Contenido'],
      en: ['Specialized', 'Artificial intelligence', 'Technology', 'Content'],
      pt: ['Especializado', 'Inteligência artificial', 'Tecnologia', 'Conteúdo'],
      fr: ['Spécialisé', 'Intelligence artificielle', 'Technologie', 'Contenu'],
      de: ['Spezialisiert', 'Künstliche Intelligenz', 'Technologie', 'Inhalt'],
      it: ['Specializzato', 'Intelligenza artificiale', 'Tecnologia', 'Contenuto'],
      zh: ['专门', '人工智能', '技术', '内容'],
      ja: ['特化', '人工知能', '技術', 'コンテンツ'],
      ko: ['전문', '인공지능', '기술', '콘텐츠'],
      pl: ['Wyspecjalizowany', 'Sztuczna inteligencja', 'Technologia', 'Treść'],
      ro: ['Specializat', 'Inteligență artificială', 'Tehnologie', 'Conținut']
    },
    rating: 4.1
  },
  {
    id: 'lambda-chat',
    name: 'Lambda Chat',
    description: {
      es: 'Motor de búsqueda y chat con IA para consultas técnicas y programación.',
      en: 'AI search engine and chat for technical queries and programming.',
      pt: 'Motor de busca e chat com IA para consultas técnicas e programação.',
      fr: 'Moteur de recherche et chat IA pour requêtes techniques et programmation.',
      de: 'KI-Suchmaschine und Chat für technische Anfragen und Programmierung.',
      it: 'Motore di ricerca e chat AI per query tecniche e programmazione.',
      zh: '用于技术查询和编程的AI搜索引擎和聊天。',
      ja: '技術的なクエリとプログラミングのためのAI検索エンジンとチャット。',
      ko: '기술적 질의와 프로그래밍을 위한 AI 검색 엔진과 채팅.',
      pl: 'Wyszukiwarka AI i czat do zapytań technicznych i programowania.',
      ro: 'Motor de căutare AI și chat pentru întrebări tehnice și programare.'
    },
    url: 'https://lambda.chat',
    category: 'Motores de búsqueda',
    favicon: 'https://lambda.chat/favicon.ico',
    tags: {
      es: ['Consultas técnicas', 'Programación', 'Chat IA', 'Motor búsqueda'],
      en: ['Technical queries', 'Programming', 'AI chat', 'Search engine'],
      pt: ['Consultas técnicas', 'Programação', 'Chat IA', 'Motor busca'],
      fr: ['Requêtes techniques', 'Programmation', 'Chat IA', 'Moteur recherche'],
      de: ['Technische Anfragen', 'Programmierung', 'KI-Chat', 'Suchmaschine'],
      it: ['Query tecniche', 'Programmazione', 'Chat AI', 'Motore ricerca'],
      zh: ['技术查询', '编程', 'AI聊天', '搜索引擎'],
      ja: ['技術的クエリ', 'プログラミング', 'AIチャット', '検索エンジン'],
      ko: ['기술적 질의', '프로그래밍', 'AI 채팅', '검색 엔진'],
      pl: ['Zapytania techniczne', 'Programowanie', 'Czat AI', 'Wyszukiwarka'],
      ro: ['Întrebări tehnice', 'Programare', 'Chat AI', 'Motor căutare']
    },
    rating: 4.3
  },
  {
    id: 'perplexity',
    name: 'Perplexity',
    description: {
      es: 'Motor de búsqueda con IA que proporciona respuestas precisas con fuentes citadas y contexto.',
      en: 'AI search engine that provides accurate answers with cited sources and context.',
      pt: 'Motor de busca com IA que fornece respostas precisas com fontes citadas e contexto.',
      fr: 'Moteur de recherche IA qui fournit des réponses précises avec sources citées et contexte.',
      de: 'KI-Suchmaschine, die präzise Antworten mit zitierten Quellen und Kontext liefert.',
      it: 'Motore di ricerca AI che fornisce risposte precise con fonti citate e contesto.',
      zh: '提供准确答案、引用来源和上下文的AI搜索引擎。',
      ja: '引用された情報源と文脈を含む正確な回答を提供するAI検索エンジン。',
      ko: '인용된 출처와 맥락을 포함한 정확한 답변을 제공하는 AI 검색 엔진.',
      pl: 'Wyszukiwarka AI, która dostarcza dokładne odpowiedzi z cytowanymi źródłami i kontekstem.',
      ro: 'Motor de căutare AI care oferă răspunsuri precise cu surse citate și context.'
    },
    url: 'https://www.perplexity.ai',
    category: 'Motores de búsqueda',
    favicon: 'https://www.perplexity.ai/favicon.ico',
    tags: {
      es: ['Motor búsqueda', 'Respuestas precisas', 'Fuentes citadas', 'Contexto'],
      en: ['Search engine', 'Accurate answers', 'Cited sources', 'Context'],
      pt: ['Motor busca', 'Respostas precisas', 'Fontes citadas', 'Contexto'],
      fr: ['Moteur recherche', 'Réponses précises', 'Sources citées', 'Contexte'],
      de: ['Suchmaschine', 'Präzise Antworten', 'Zitierte Quellen', 'Kontext'],
      it: ['Motore ricerca', 'Risposte precise', 'Fonti citate', 'Contesto'],
      zh: ['搜索引擎', '准确答案', '引用来源', '上下文'],
      ja: ['検索エンジン', '正確な回答', '引用情報源', '文脈'],
      ko: ['검색 엔진', '정확한 답변', '인용 출처', '맥락'],
      pl: ['Wyszukiwarka', 'Dokładne odpowiedzi', 'Cytowane źródła', 'Kontekst'],
      ro: ['Motor căutare', 'Răspunsuri precise', 'Surse citate', 'Context']
    },
    rating: 4.8
  },
  {
    id: 'you-com',
    name: 'You.com',
    description: {
      es: 'Motor de búsqueda potenciado por IA que proporciona respuestas directas y fuentes confiables.',
      en: 'AI-powered search engine that provides direct answers and reliable sources.',
      pt: 'Motor de busca alimentado por IA que fornece respostas diretas e fontes confiáveis.',
      fr: 'Moteur de recherche alimenté par IA qui fournit des réponses directes et sources fiables.',
      de: 'KI-gestützte Suchmaschine, die direkte Antworten und zuverlässige Quellen liefert.',
      it: 'Motore di ricerca alimentato da AI che fornisce risposte dirette e fonti affidabili.',
      zh: '提供直接答案和可靠来源的AI驱动搜索引擎。',
      ja: '直接的な回答と信頼できる情報源を提供するAI駆动検索エンジン。',
      ko: '직접적인 답변과 신뢰할 수 있는 출처를 제공하는 AI 기반 검색 엔진.',
      pl: 'Wyszukiwarka napędzana przez AI, która dostarcza bezpośrednie odpowiedzi i wiarygodne źródła.',
      ro: 'Motor de căutare alimentat de AI care oferă răspunsuri directe și surse de încredere.'
    },
    url: 'https://you.com',
    category: 'Motores de búsqueda',
    favicon: 'https://you.com/favicon.ico',
    tags: {
      es: ['Motor búsqueda', 'Respuestas directas', 'Fuentes confiables'],
      en: ['Search engine', 'Direct answers', 'Reliable sources'],
      pt: ['Motor busca', 'Respostas diretas', 'Fontes confiáveis'],
      fr: ['Moteur recherche', 'Réponses directes', 'Sources fiables'],
      de: ['Suchmaschine', 'Direkte Antworten', 'Zuverlässige Quellen'],
      it: ['Motore ricerca', 'Risposte dirette', 'Fonti affidabili'],
      zh: ['搜索引擎', '直接答案', '可靠来源'],
      ja: ['検索エンジン', '直接回答', '信頼できる情報源'],
      ko: ['검색 엔진', '직접 답변', '신뢰할 수 있는 출처'],
      pl: ['Wyszukiwarka', 'Bezpośrednie odpowiedzi', 'Wiarygodne źródła'],
      ro: ['Motor căutare', 'Răspunsuri directe', 'Surse de încredere']
    },
    rating: 4.5
  },

  // Audio (6 recursos)
  {
    id: 'auphonic',
    name: 'Auphonic',
    description: {
      es: 'Procesamiento automático de audio con IA para mejorar la calidad de podcasts y grabaciones.',
      en: 'Automatic AI audio processing to improve podcast and recording quality.',
      pt: 'Processamento automático de áudio com IA para melhorar a qualidade de podcasts e gravações.',
      fr: 'Traitement audio automatique IA pour améliorer la qualité des podcasts et enregistrements.',
      de: 'Automatische KI-Audioverarbeitung zur Verbesserung der Qualität von Podcasts und Aufnahmen.',
      it: 'Elaborazione audio automatica AI per migliorare la qualità di podcast e registrazioni.',
      zh: '自动AI音频处理，提高播客和录音质量。',
      ja: 'ポッドキャストと録音の品質を向上させる自動AI音声処理。',
      ko: '팟캐스트와 녹음 품질을 향상시키는 자동 AI 오디오 처리.',
      pl: 'Automatyczne przetwarzanie dźwięku AI w celu poprawy jakości podcastów i nagrań.',
      ro: 'Procesarea automată audio AI pentru îmbunătățirea calității podcast-urilor și înregistrărilor.'
    },
    url: 'https://auphonic.com',
    category: 'Audio',
    favicon: 'https://auphonic.com/favicon.ico',
    tags: {
      es: ['Procesamiento automático', 'Podcasts', 'Grabaciones', 'Mejorar calidad'],
      en: ['Automatic processing', 'Podcasts', 'Recordings', 'Quality improvement'],
      pt: ['Processamento automático', 'Podcasts', 'Gravações', 'Melhoria qualidade'],
      fr: ['Traitement automatique', 'Podcasts', 'Enregistrements', 'Amélioration qualité'],
      de: ['Automatische Verarbeitung', 'Podcasts', 'Aufnahmen', 'Qualitätsverbesserung'],
      it: ['Elaborazione automatica', 'Podcast', 'Registrazioni', 'Miglioramento qualità'],
      zh: ['自动处理', '播客', '录音', '质量提升'],
      ja: ['自動処理', 'ポッドキャスト', '録音', '品質向上'],
      ko: ['자동 처리', '팟캐스트', '녹음', '품질 향상'],
      pl: ['Automatyczne przetwarzanie', 'Podcasty', 'Nagrania', 'Poprawa jakości'],
      ro: ['Procesare automată', 'Podcast-uri', 'Înregistrări', 'Îmbunătățirea calității']
    },
    rating: 4.4
  },
  {
    id: 'eleven-labs',
    name: 'ElevenLabs',
    description: {
      es: 'Generación de voz sintética ultra realista con clonación de voz y múltiples idiomas.',
      en: 'Ultra-realistic synthetic voice generation with voice cloning and multiple languages.',
      pt: 'Geração de voz sintética ultra-realista com clonagem de voz e múltiplas linguagens.',
      fr: 'Génération de voix synthétique ultra-réaliste avec clonage vocal et plusieurs langues.',
      de: 'Ultra-realistische synthetische Stimmgenerierung mit Stimmklonierung und mehreren Sprachen.',
      it: 'Generazione di voce sintetica ultra-realistica con clonazione vocale e più lingue.',
      zh: '具有语音克隆和多语言功能的超逼真合成语音生成。',
      ja: '音声クローニングと多言語対応の超リアルな合成音声生成。',
      ko: '음성 복제 및 다국어 지원을 통한 초현실적인 합성 음성 생성.',
      pl: 'Ultra-realistyczna generacja głosu syntetycznego z klonowaniem głosu i wieloma językami.',
      ro: 'Generarea de voce sintetică ultra-realistă cu clonarea vocii și mai multe limbi.'
    },
    url: 'https://elevenlabs.io',
    category: 'Audio',
    favicon: 'https://elevenlabs.io/favicon.ico',
    tags: {
      es: ['Voz sintética', 'Clonación', 'Multiidioma', 'Ultra realista'],
      en: ['Synthetic voice', 'Cloning', 'Multilingual', 'Ultra realistic'],
      pt: ['Voz sintética', 'Clonagem', 'Multilíngue', 'Ultra realista'],
      fr: ['Voix synthétique', 'Clonage', 'Multilingue', 'Ultra réaliste'],
      de: ['Synthetische Stimme', 'Klonierung', 'Mehrsprachig', 'Ultra realistisch'],
      it: ['Voce sintetica', 'Clonazione', 'Multilingue', 'Ultra realistico'],
      zh: ['合成语音', '克隆', '多语言', '超逼真'],
      ja: ['合成音声', 'クローニング', '多言語', '超リアル'],
      ko: ['합성 음성', '복제', '다국어', '초현실적'],
      pl: ['Głos syntetyczny', 'Klonowanie', 'Wielojęzyczny', 'Ultra realistyczny'],
      ro: ['Voce sintetică', 'Clonare', 'Multilingv', 'Ultra realist']
    },
    rating: 4.9
  },
  {
    id: 'lalal-ai',
    name: 'LALAL.AI',
    description: {
      es: 'Separación de stems musicales con IA para aislar voces, instrumentos y efectos.',
      en: 'AI music stem separation to isolate vocals, instruments and effects.',
      pt: 'Separação de stems musicais com IA para isolar vocais, instrumentos e efeitos.',
      fr: 'Séparation de stems musicales IA pour isoler voix, instruments et effets.',
      de: 'KI-Musikstem-Trennung zur Isolierung von Gesang, Instrumenten und Effekten.',
      it: 'Separazione stem musicali AI per isolare voci, strumenti ed effetti.',
      zh: 'AI音乐干声分离，用于隔离人声、乐器和效果。',
      ja: 'ボーカル、楽器、エフェクトを分离するAI音楽ステム分離。',
      ko: '보컬, 악기 및 효과를 분리하는 AI 음악 스템 분리.',
      pl: 'Separacja stemów muzycznych AI do izolowania wokalu, instrumentów i efektów.',
      ro: 'Separarea stem-urilor muzicale AI pentru izolarea vocalelor, instrumentelor și efectelor.'
    },
    url: 'https://www.lalal.ai',
    category: 'Audio',
    favicon: 'https://www.lalal.ai/favicon.ico',
    tags: {
      es: ['Separación stems', 'Aislar voces', 'Instrumentos', 'Efectos'],
      en: ['Stem separation', 'Isolate vocals', 'Instruments', 'Effects'],
      pt: ['Separação stems', 'Isolar vocais', 'Instrumentos', 'Efeitos'],
      fr: ['Séparation stems', 'Isoler voix', 'Instruments', 'Effets'],
      de: ['Stem-Trennung', 'Gesang isolieren', 'Instrumente', 'Effekte'],
      it: ['Separazione stem', 'Isolare voci', 'Strumenti', 'Effetti'],
      zh: ['干声分离', '隔离人声', '乐器', '效果'],
      ja: ['ステム分離', 'ボーカル分離', '楽器', 'エフェクト'],
      ko: ['스템 분리', '보컬 분리', '악기', '효과'],
      pl: ['Separacja stemów', 'Izolowanie wokalu', 'Instrumenty', 'Efekty'],
      ro: ['Separare stem-uri', 'Izola vocale', 'Instrumente', 'Efecte']
    },
    rating: 4.6
  },
  {
    id: 'resound',
    name: 'Resound',
    description: {
      es: 'Herramientas de IA para edición y mejora automática de calidad de audio.',
      en: 'AI tools for automatic audio editing and quality enhancement.',
      pt: 'Ferramentas de IA para edição automática e melhoria da qualidade de áudio.',
      fr: 'Outils IA pour édition audio automatique et amélioration de la qualité.',
      de: 'KI-Tools für automatische Audiobearbeitung und Qualitätsverbesserung.',
      it: 'Strumenti AI per editing audio automatico e miglioramento della qualità.',
      zh: '用于自动音频编辑和质量增强的AI工具。',
      ja: '自動音声編集と品質向上のためのAIツール。',
      ko: '자동 오디오 편집 및 품질 향상을 위한 AI 도구.',
      pl: 'Narzędzia AI do automatycznej edycji dźwięku i poprawy jakości.',
      ro: 'Instrumente AI pentru editarea automată audio și îmbunătățirea calității.'
    },
    url: 'https://www.resound.fm',
    category: 'Audio',
    favicon: 'https://www.resound.fm/favicon.ico',
    tags: {
      es: ['Edición audio', 'Mejora automática', 'Calidad audio', 'Herramientas'],
      en: ['Audio editing', 'Automatic enhancement', 'Audio quality', 'Tools'],
      pt: ['Edição áudio', 'Melhoria automática', 'Qualidade áudio', 'Ferramentas'],
      fr: ['Édition audio', 'Amélioration automatique', 'Qualité audio', 'Outils'],
      de: ['Audio-Bearbeitung', 'Automatische Verbesserung', 'Audio-Qualität', 'Werkzeuge'],
      it: ['Editing audio', 'Miglioramento automatico', 'Qualità audio', 'Strumenti'],
      zh: ['音频编辑', '自动增强', '音频质量', '工具'],
      ja: ['音声編集', '自動向上', '音質', 'ツール'],
      ko: ['오디오 편집', '자동 향상', '오디오 품질', '도구'],
      pl: ['Edycja dźwięku', 'Automatyczne ulepszanie', 'Jakość dźwięku', 'Narzędzia'],
      ro: ['Editare audio', 'Îmbunătățire automată', 'Calitate audio', 'Instrumente']
    },
    rating: 4.3
  },
  {
    id: 'voicemaker',
    name: 'VoiceMaker',
    description: {
      es: 'Generador de voz con IA que convierte texto a voz en múltiples idiomas y estilos.',
      en: 'AI voice generator that converts text to speech in multiple languages and styles.',
      pt: 'Gerador de voz com IA que converte texto em fala em múltiplas linguagens e estilos.',
      fr: 'Générateur de voix IA qui convertit texte en parole en plusieurs langues et styles.',
      de: 'KI-Sprachgenerator, der Text in mehreren Sprachen und Stilen in Sprache umwandelt.',
      it: 'Generatore di voce AI che converte testo in parlato in più lingue e stili.',
      zh: '将文本转换为多种语言和风格语音的AI语音生成器。',
      ja: '複数言語とスタイルでテキストを音声に変转するAI音声ジェネレーター。',
      ko: '여러 언어와 스타일로 텍스트를 음성으로 변환하는 AI 음성 생성기.',
      pl: 'Generator głosu AI, który konwertuje tekst na mowę w wielu językach i stylach.',
      ro: 'Generator de voce AI care convertește textul în vorbire în mai multe limbi și stiluri.'
    },
    url: 'https://voicemaker.in',
    category: 'Audio',
    favicon: 'https://voicemaker.in/favicon.ico',
    tags: {
      es: ['Texto a voz', 'Múltiples idiomas', 'Estilos', 'Generador voz'],
      en: ['Text to speech', 'Multiple languages', 'Styles', 'Voice generator'],
      pt: ['Texto para fala', 'Múltiplas linguagens', 'Estilos', 'Gerador voz'],
      fr: ['Texte vers parole', 'Plusieurs langues', 'Styles', 'Générateur voix'],
      de: ['Text zu Sprache', 'Mehrere Sprachen', 'Stile', 'Sprachgenerator'],
      it: ['Testo in parlato', 'Più lingue', 'Stili', 'Generatore voce'],
      zh: ['文本转语音', '多种语言', '风格', '语音生成器'],
      ja: ['テキスト読み上げ', '複数言語', 'スタイル', '音声ジェネレーター'],
      ko: ['텍스트 음성 변환', '여러 언어', '스타일', '음성 생성기'],
      pl: ['Tekst na mowę', 'Wiele języków', 'Style', 'Generator głosu'],
      ro: ['Text în vorbire', 'Mai multe limbi', 'Stiluri', 'Generator voce']
    },
    rating: 4.4
  },
  {
    id: 'xound',
    name: 'Xound',
    description: {
      es: 'Plataforma de IA para análisis y optimización de calidad de audio en tiempo real.',
      en: 'AI platform for real-time audio quality analysis and optimization.',
      pt: 'Plataforma de IA para análise e otimização da qualidade de áudio em tempo real.',
      fr: 'Plateforme IA pour analyse et optimisation de la qualité audio en temps réel.',
      de: 'KI-Plattform für Echtzeit-Audioqualitätsanalyse und -optimierung.',
      it: 'Piattaforma AI per analisi e ottimizzazione della qualità audio in tempo reale.',
      zh: '用于实时音频质量分析和优化的AI平台。',
      ja: 'リアルタイム音質分析と最適化のためのAIプラットフォーム。',
      ko: '실시간 오디오 품질 분석 및 최적화를 위한 AI 플랫폼.',
      pl: 'Platforma AI do analizy jakości dźwięku w czasie rzeczywistym i optymalizacji.',
      ro: 'Platformă AI pentru analiza calității audio în timp real și optimizare.'
    },
    url: 'https://xound.io',
    category: 'Audio',
    favicon: 'https://xound.io/favicon.ico',
    tags: {
      es: ['Análisis audio', 'Optimización', 'Tiempo real', 'Calidad audio'],
      en: ['Audio analysis', 'Optimization', 'Real-time', 'Audio quality'],
      pt: ['Análise áudio', 'Otimização', 'Tempo real', 'Qualidade áudio'],
      fr: ['Analyse audio', 'Optimisation', 'Temps réel', 'Qualité audio'],
      de: ['Audio-Analyse', 'Optimierung', 'Echtzeit', 'Audio-Qualität'],
      it: ['Analisi audio', 'Ottimizzazione', 'Tempo reale', 'Qualità audio'],
      zh: ['音频分析', '优化', '实时', '音频质量'],
      ja: ['音声分析', '最適化', 'リアルタイム', '音質'],
      ko: ['오디오 분석', '최적화', '실시간', '오디오 품질'],
      pl: ['Analiza dźwięku', 'Optymalizacja', 'Czas rzeczywisty', 'Jakość dźwięku'],
      ro: ['Analiză audio', 'Optimizare', 'Timp real', 'Calitate audio']
    },
    rating: 4.2
  },

  // Redes sociales (3 recursos)
  {
    id: 'metricool',
    name: 'Metricool',
    description: {
      es: 'Plataforma de analítica de redes sociales con herramientas de IA para optimización.',
      en: 'Social media analytics platform with AI tools for optimization.',
      pt: 'Plataforma de análise de redes sociais com ferramentas de IA para otimização.',
      fr: 'Plateforme d\'analyse des réseaux sociaux avec outils IA pour optimisation.',
      de: 'Social-Media-Analyseplattform mit KI-Tools zur Optimierung.',
      it: 'Piattaforma di analisi social media con strumenti AI per ottimizzazione.',
      zh: '具有AI优化工具的社交媒体分析平台。',
      ja: '最適化のためのAIツールを備えたソーシャルメディア分析プラットフォーム。',
      ko: '최적화를 위한 AI 도구를 갖춘 소셜 미디어 분석 플랫폼.',
      pl: 'Platforma analityki mediów społecznościowych z narzędziami AI do optymalizacji.',
      ro: 'Platformă de analiză rețele sociale cu instrumente AI pentru optimizare.'
    },
    url: 'https://metricool.com',
    category: 'Redes sociales',
    favicon: 'https://metricool.com/favicon.ico',
    tags: {
      es: ['Analítica', 'Optimización', 'Plataforma', 'Redes sociales'],
      en: ['Analytics', 'Optimization', 'Platform', 'Social media'],
      pt: ['Análise', 'Otimização', 'Plataforma', 'Redes sociais'],
      fr: ['Analytique', 'Optimisation', 'Plateforme', 'Réseaux sociaux'],
      de: ['Analytik', 'Optimierung', 'Plattform', 'Soziale Medien'],
      it: ['Analisi', 'Ottimizzazione', 'Piattaforma', 'Social media'],
      zh: ['分析', '优化', '平台', '社交媒体'],
      ja: ['分析', '最適化', 'プラットフォーム', 'ソーシャルメディア'],
      ko: ['분석', '최적화', '플랫폼', '소셜 미디어'],
      pl: ['Analityka', 'Optymalizacja', 'Platforma', 'Media społecznościowe'],
      ro: ['Analiză', 'Optimizare', 'Platformă', 'Rețele sociale']
    },
    rating: 4.4
  },
  {
    id: 'olly-social',
    name: 'Olly Social',
    description: {
      es: 'Asistente de IA para comentarios inteligentes y engagement en redes sociales.',
      en: 'AI assistant for smart comments and social media engagement.',
      pt: 'Assistente de IA para comentários inteligentes e engajamento em redes sociais.',
      fr: 'Assistant IA pour commentaires intelligents et engagement sur les réseaux sociaux.',
      de: 'KI-Assistent für intelligente Kommentare und Social-Media-Engagement.',
      it: 'Assistente AI per commenti intelligenti e coinvolgimento sui social media.',
      zh: '用于智能评论和社交媒体参与的AI助手。',
      ja: 'スマートコメントとソーシャルメディアエンゲージメントのためのAIアシスタント。',
      ko: '스마트 댓글과 소셜 미디어 참여를 위한 AI 어시스턴트.',
      pl: 'Asystent AI do inteligentnych komentarzy i zaangażowania w mediach społecznościowych.',
      ro: 'Asistent AI pentru comentarii inteligente și angajament pe rețelele sociale.'
    },
    url: 'https://www.olly.social',
    category: 'Redes sociales',
    favicon: 'https://www.olly.social/favicon.ico',
    tags: {
      es: ['Comentarios inteligentes', 'Engagement', 'Asistente', 'Redes sociales'],
      en: ['Smart comments', 'Engagement', 'Assistant', 'Social media'],
      pt: ['Comentários inteligentes', 'Engajamento', 'Assistente', 'Redes sociais'],
      fr: ['Commentaires intelligents', 'Engagement', 'Assistant', 'Réseaux sociaux'],
      de: ['Intelligente Kommentare', 'Engagement', 'Assistent', 'Soziale Medien'],
      it: ['Commenti intelligenti', 'Coinvolgimento', 'Assistente', 'Social media'],
      zh: ['智能评论', '参与', '助手', '社交媒体'],
      ja: ['スマートコメント', 'エンゲージメント', 'アシスタント', 'ソーシャルメディア'],
      ko: ['스마트 댓글', '참여', '어시스턴트', '소셜 미디어'],
      pl: ['Inteligentne komentarze', 'Zaangażowanie', 'Asystent', 'Media społecznościowe'],
      ro: ['Comentarii inteligente', 'Angajament', 'Asistent', 'Rețele sociale']
    },
    rating: 4.1
  },
  {
    id: 'quso-ai',
    name: 'quso.ai',
    description: {
      es: 'Herramienta de IA para crear y optimizar contenido viral en redes sociales.',
      en: 'AI tool to create and optimize viral content for social media.',
      pt: 'Ferramenta de IA para criar e otimizar conteúdo viral em redes sociais.',
      fr: 'Outil IA pour créer et optimiser du contenu viral sur les réseaux sociaux.',
      de: 'KI-Tool zur Erstellung und Optimierung viraler Inhalte für soziale Medien.',
      it: 'Strumento AI per creare e ottimizzare contenuti virali sui social media.',
      zh: '用于在社交媒体上创建和优化病毒内容的AI工具。',
      ja: 'ソーシャルメディアでバイラルコンテンツを作成・最適化するAIツール。',
      ko: '소셜 미디어에서 바이럴 콘텐츠를 만들고 최적화하는 AI 도구.',
      pl: 'Narzędzie AI do tworzenia i optymalizacji wirusowych treści w mediach społecznościowych.',
      ro: 'Instrument AI pentru crearea și optimizarea conținutului viral pe rețelele sociale.'
    },
    url: 'https://quso.ai',
    category: 'Redes sociales',
    favicon: 'https://quso.ai/favicon.ico',
    tags: {
      es: ['Contenido viral', 'Optimizar', 'Crear', 'Redes sociales'],
      en: ['Viral content', 'Optimize', 'Create', 'Social media'],
      pt: ['Conteúdo viral', 'Otimizar', 'Criar', 'Redes sociais'],
      fr: ['Contenu viral', 'Optimiser', 'Créer', 'Réseaux sociaux'],
      de: ['Viraler Content', 'Optimieren', 'Erstellen', 'Soziale Medien'],
      it: ['Contenuto virale', 'Ottimizzare', 'Creare', 'Social media'],
      zh: ['病毒内容', '优化', '创建', '社交媒体'],
      ja: ['バイラルコンテンツ', '最適化', '作成', 'ソーシャルメディア'],
      ko: ['바이럴 콘텐츠', '최적화', '생성', '소셜 미디어'],
      pl: ['Wirusowe treści', 'Optymalizować', 'Tworzyć', 'Media społecznościowe'],
      ro: ['Conținut viral', 'Optimiza', 'Crea', 'Rețele sociale']
    },
    rating: 4.2
  }
];